import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AddCompanyCandidatesToExaminationInput = {
  /** Ids кандидатов компании */
  companyCandidateIds: Array<Scalars['ID']['input']>;
  /** Id типового тестирования */
  examinationId: Scalars['ID']['input'];
};

export type AuthTokensDto = {
  __typename?: 'AuthTokensDto';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type BatchInitGenerateQuestionsDataInput = {
  /** Подтип вопроса */
  subtype?: InputMaybe<Scalars['String']['input']>;
  /** Тип вопроса */
  type: Question_Type;
};

export type BatchInitGenerateQuestionsInput = {
  /** Количество вопросов */
  amount: Scalars['Int']['input'];
  /** Id карты компетенций */
  competencyMapId: Scalars['ID']['input'];
  /** Данные для генерации */
  data: Array<BatchInitGenerateQuestionsDataInput>;
  /** Сложность вопросов */
  grade: Grade;
  /** Язык вопросов */
  language: Language;
};

export enum Company_Candidate_Type {
  Candidate = 'CANDIDATE',
  Employee = 'EMPLOYEE'
}

export enum Company_Status {
  Approved = 'APPROVED',
  Blocked = 'BLOCKED',
  Created = 'CREATED',
  NotApproved = 'NOT_APPROVED',
  PartlyApproved = 'PARTLY_APPROVED'
}

export enum Competency_Map_Status {
  Approved = 'APPROVED',
  Archive = 'ARCHIVE',
  Draft = 'DRAFT',
  Generating = 'GENERATING',
  Virtual = 'VIRTUAL'
}

export type Candidate = {
  __typename?: 'Candidate';
  /** Согласие кандидата с офертой и обработкой его данных */
  agreement: Scalars['Boolean']['output'];
  /** Username кандидата в ТГ */
  candidateUsername: CandidateUsername;
  /** ID Username кандидата в ТГ */
  candidateUsernameId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  /** ФИО кандидата из ТГ */
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Язык кандидата */
  language?: Maybe<Language>;
  /** Номер телефона кандидата */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type CandidateAWebDto = {
  __typename?: 'CandidateAWebDto';
  /** Согласие кандидата с офертой и обработкой его данных */
  agreement: Scalars['Boolean']['output'];
  /** Username и id кандидата в ТГ */
  candidateUsername: CandidateUsernameAWebDto;
  /** ID Username кандидата в ТГ */
  candidateUsernameId: Scalars['ID']['output'];
  /** ФИО кандидата из ТГ */
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Язык кандидата */
  language?: Maybe<Language>;
  /** Номер телефона кандидата */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CandidateUsername = {
  __typename?: 'CandidateUsername';
  /** Кандидат */
  candidate?: Maybe<Candidate>;
  /** Связь кандидата с компанией */
  companyCandidate?: Maybe<Array<CompanyCandidate>>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Временный логин */
  login?: Maybe<Scalars['String']['output']>;
  /** ID пользователя из telegram */
  telegramId?: Maybe<Scalars['Float']['output']>;
  /** Профиль телеграм кандидата */
  telegramUsername?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type CandidateUsernameAWebDto = {
  __typename?: 'CandidateUsernameAWebDto';
  /** Кандидат */
  candidate?: Maybe<CandidateAWebDto>;
  id: Scalars['ID']['output'];
  /** Временный логин */
  login?: Maybe<Scalars['String']['output']>;
  /** ID пользователя из telegram */
  telegramId?: Maybe<Scalars['Float']['output']>;
  /** Профиль телеграм кандидата */
  telegramUsername?: Maybe<Scalars['String']['output']>;
};

export type Company = {
  __typename?: 'Company';
  /** Дата последних изменений */
  actualityDate?: Maybe<Scalars['Float']['output']>;
  /** Соглашение на обработку персональных данных */
  agreement: Scalars['Boolean']['output'];
  /** Блоки знаний */
  companyKnowledgeBlocks?: Maybe<Array<KnowledgeBlock>>;
  /** История изменения статуса */
  companyStatusHistory?: Maybe<Array<CompanyStatusHistory>>;
  /** Пользователи компании */
  companyUsers?: Maybe<Array<CompanyUser>>;
  /** Карты компетенций компании */
  competencyMaps?: Maybe<Array<CompetencyMap>>;
  /** Номер внутреннего контракта */
  contractNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Позиция текущего пользователя */
  currentUserPosition?: Maybe<Scalars['String']['output']>;
  /** Полное наименование */
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Идентификатор компании */
  identification: Scalars['String']['output'];
  /** ИНН */
  inn: Scalars['String']['output'];
  /** Флаг суперкомпании */
  isSupercompany: Scalars['Boolean']['output'];
  /** КПП */
  kpp: Scalars['String']['output'];
  /** Дата ликвидации */
  liquidationDate?: Maybe<Scalars['Float']['output']>;
  /** ФИО руководителя */
  managerFio: Scalars['String']['output'];
  /** Должность руководителя */
  managerPosition: Scalars['String']['output'];
  /** ОГРН */
  ogrn: Scalars['String']['output'];
  /** Дата выдачи ОГРН */
  ogrnDate: Scalars['Float']['output'];
  /** Код ОКАТО */
  okato: Scalars['String']['output'];
  /** Код ОКПО */
  okpo: Scalars['String']['output'];
  /** Код ОКТМО */
  oktmo: Scalars['String']['output'];
  /** Адрес регистрации */
  registrationAddress: Scalars['String']['output'];
  /** Дата регистрации */
  registrationDate: Scalars['Float']['output'];
  /** Краткое наименование */
  shortName: Scalars['String']['output'];
  /** Cтатус организации */
  state: Organization_State;
  /** Статус компании в системе */
  status: Company_Status;
  /** Тип организации */
  type: Type_Of_Organization;
  updatedAt: Scalars['Date']['output'];
  /** Вакансии компании */
  vacancies?: Maybe<Array<Vacancy>>;
};

export type CompanyAWebDto = {
  __typename?: 'CompanyAWebDto';
  /** Дата последних изменений */
  actualityDate?: Maybe<Scalars['Float']['output']>;
  /** Полное наименование */
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Идентификатор компании */
  identification: Scalars['String']['output'];
  /** ИНН */
  inn: Scalars['String']['output'];
  /** Флаг суперкомпании */
  isSupercompany: Scalars['Boolean']['output'];
  /** КПП */
  kpp: Scalars['String']['output'];
  /** Дата ликвидации */
  liquidationDate?: Maybe<Scalars['Float']['output']>;
  /** ФИО руководителя */
  managerFio: Scalars['String']['output'];
  /** Должность руководителя */
  managerPosition: Scalars['String']['output'];
  /** ОГРН */
  ogrn: Scalars['String']['output'];
  /** Дата выдачи ОГРН */
  ogrnDate: Scalars['Float']['output'];
  /** Код ОКАТО */
  okato: Scalars['String']['output'];
  /** Код ОКПО */
  okpo: Scalars['String']['output'];
  /** Код ОКТМО */
  oktmo: Scalars['String']['output'];
  /** Адрес регистрации */
  registrationAddress: Scalars['String']['output'];
  /** Дата регистрации */
  registrationDate: Scalars['Float']['output'];
  /** Краткое наименование */
  shortName: Scalars['String']['output'];
  /** Cтатус организации */
  state: Organization_State;
  /** Статус компании в системе */
  status: Company_Status;
  /** Тип организации */
  type: Type_Of_Organization;
};

export type CompanyCandidate = {
  __typename?: 'CompanyCandidate';
  /** Средний результат по всем тестированиям */
  averageTrialsScore?: Maybe<Scalars['Float']['output']>;
  /** Username кандидата в ТГ */
  candidateUsername?: Maybe<CandidateUsername>;
  /** ID Username кандидата в ТГ */
  candidateUsernameId?: Maybe<Scalars['ID']['output']>;
  /** Компания пользователя */
  company: Company;
  /** ID компании пользователя */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  /** Файл резюме */
  cvFile?: Maybe<File>;
  /** ID файла резюме */
  cvFileId?: Maybe<Scalars['ID']['output']>;
  /** Email кандидата */
  email?: Maybe<Scalars['String']['output']>;
  /** ФИО кандидата как его заполнила компания */
  fullName: Scalars['String']['output'];
  /** Грейд кандидата */
  grade?: Maybe<Grade>;
  id: Scalars['ID']['output'];
  /** Дата последнего тестирования */
  lastTrialDate?: Maybe<Scalars['Date']['output']>;
  /** Отчет рекрутера последнего тестирования */
  lastTrialRecruiterReportFiles?: Maybe<Array<TrialFile>>;
  /** Результат последнего тестирования */
  lastTrialScore?: Maybe<Scalars['Float']['output']>;
  /** Статус последнего тестирования */
  lastTrialStatus?: Maybe<Trial_Status>;
  /** Время прохождения последнего тестирования */
  lastTrialTime?: Maybe<Scalars['Float']['output']>;
  /** Ссылка на headhunter */
  link?: Maybe<Scalars['String']['output']>;
  /** Номер кандидата компании */
  numericId: Scalars['Float']['output'];
  /** Организация */
  organization?: Maybe<Scalars['String']['output']>;
  /** Позиция кандидата в компании */
  position?: Maybe<Scalars['String']['output']>;
  /** Тестирования кандидата */
  trials?: Maybe<Array<Trial>>;
  /** Кол-во пройденных тестирований */
  trialsCount?: Maybe<Scalars['Float']['output']>;
  /** Тип кандидата компании */
  type: Company_Candidate_Type;
  updatedAt: Scalars['Date']['output'];
  /** Оценки CV по вакансиям */
  vacancyCompanyCandidates?: Maybe<Array<VacancyCompanyCandidate>>;
};

export type CompanyCandidateAWebDto = {
  __typename?: 'CompanyCandidateAWebDto';
  /** Username и id кандидата в ТГ */
  candidateUsername?: Maybe<CandidateUsernameAWebDto>;
  /** ID Username кандидата в ТГ */
  candidateUsernameId?: Maybe<Scalars['ID']['output']>;
  /** Компания */
  company: CompanyAWebDto;
  /** ID компании пользователя */
  companyId: Scalars['ID']['output'];
  /** Email кандидата */
  email?: Maybe<Scalars['String']['output']>;
  /** ФИО кандидата как его заполнила компания */
  fullName: Scalars['String']['output'];
  /** Грейд кандидата */
  grade?: Maybe<Grade>;
  id: Scalars['ID']['output'];
  /** Номер кандидата компании */
  numericId: Scalars['Float']['output'];
  /** Организация */
  organization?: Maybe<Scalars['String']['output']>;
  /** Позиция кандидата в компании */
  position?: Maybe<Scalars['String']['output']>;
};

export type CompanyStatusHistory = {
  __typename?: 'CompanyStatusHistory';
  /** Компания пользователя */
  company: Company;
  /** ID компании пользователя */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Новый статус компании */
  newStatus: Company_Status;
  updatedAt: Scalars['Date']['output'];
};

export type CompanyUser = {
  __typename?: 'CompanyUser';
  /** Компания пользователя */
  company: Company;
  /** ID компании пользователя */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Флаг подтверждения */
  isConfirmed: Scalars['Boolean']['output'];
  /** Является ли создателем компании */
  isCreator: Scalars['Boolean']['output'];
  /** Является ли руководителем */
  isSupervisor: Scalars['Boolean']['output'];
  /** Должность */
  position: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Email пользователя */
  userEmail: UserEmail;
  /** ID email пользователя */
  userEmailId: Scalars['ID']['output'];
};

export type Competence = {
  __typename?: 'Competence';
  /** Карта компетенции */
  competencyMap: CompetencyMap;
  /** ID карты компетенции */
  competencyMapId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Компетенции блока */
  knowledgeBlockCompetences?: Maybe<Array<KnowledgeBlockCompetence>>;
  /** Порядок компетенции в карте компетенций */
  order: Scalars['Int']['output'];
  /** Название компетенции */
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CompetenceAWebDto = {
  __typename?: 'CompetenceAWebDto';
  /** Карта компетенций */
  competencyMap: CompetencyMapAWebDto;
  /** ID карты компетенции */
  competencyMapId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Компетенции блока */
  knowledgeBlockCompetences?: Maybe<Array<KnowledgeBlockCompetenceAWebDto>>;
  /** Порядок компетенции в карте компетенций */
  order: Scalars['Int']['output'];
  /** Название компетенции */
  title: Scalars['String']['output'];
};

export type CompetenceScore = {
  /** Id компетенции */
  competenceId: Scalars['ID']['input'];
  /** Результат по компетенции */
  score: Scalars['Float']['input'];
};

export type CompetenceScoreType = {
  __typename?: 'CompetenceScoreType';
  competenceId: Scalars['ID']['output'];
  order: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
};

export type CompetencyMap = {
  __typename?: 'CompetencyMap';
  /** Логи генерации */
  MlLogs?: Maybe<Array<MlLog>>;
  /** Количество блоков знаний в карте компетенций */
  blocksCount: Scalars['Float']['output'];
  /** Комментарий к карте компетенций */
  comment?: Maybe<Scalars['String']['output']>;
  /** Компания */
  company: Company;
  /** ID компании */
  companyId: Scalars['ID']['output'];
  /** Компетенции карты компетенций */
  competences?: Maybe<Array<Competence>>;
  /** Количество компетенций в карте компетенций */
  competencesCount: Scalars['Float']['output'];
  /** Скопированные карты компетенций */
  copies?: Maybe<Array<CompetencyMap>>;
  createdAt: Scalars['Date']['output'];
  /** Дата "мягкого" удаления */
  deletedAt?: Maybe<Scalars['Date']['output']>;
  demoCode?: Maybe<Scalars['String']['output']>;
  /** Типовые тестирования */
  examinations?: Maybe<Array<Examination>>;
  /** Грейды карты компетенций */
  grades?: Maybe<Array<Grade>>;
  id: Scalars['ID']['output'];
  /** Использовать проверку репозитория */
  isRepositoryCheck: Scalars['Boolean']['output'];
  /** Флаг примера */
  isSample: Scalars['Boolean']['output'];
  /** Валидна ли карта компетенций (есть ли во всех топиках подтверждённые вопросы) */
  isValid?: Maybe<Scalars['Boolean']['output']>;
  /** Список уникальных языков, используемых в вопросах карты */
  languages?: Maybe<Array<Language>>;
  /** Дата создания последнего тестирования по кк */
  lastTrialDate?: Maybe<Scalars['Date']['output']>;
  /** Номер карты компетенций компании */
  numericId: Scalars['Float']['output'];
  /** Оригинальная карта компетенций */
  originalCompetencyMap?: Maybe<CompetencyMap>;
  /** ID оригинальной карты компетенции */
  originalCompetencyMapId?: Maybe<Scalars['ID']['output']>;
  /** Среднее расчётное время прохождение карты компетенций */
  questionsTime?: Maybe<Scalars['Float']['output']>;
  /** Специализация карты компетенций */
  specialization: Scalars['String']['output'];
  /** Статус карты */
  status: Competency_Map_Status;
  /** Название карты компетенций */
  title: Scalars['String']['output'];
  /** Информация о тестированиях с данной картой компетенций */
  trialsInfo: CompetencyMapTrialsInfoDto;
  updatedAt: Scalars['Date']['output'];
  /** Использовать карту компетенций в боте */
  useInBot: Scalars['Boolean']['output'];
  /** Версия карты компетенций */
  version: Scalars['Float']['output'];
};

export type CompetencyMapAWebDto = {
  __typename?: 'CompetencyMapAWebDto';
  /** Комментарий к карте компетенций */
  comment?: Maybe<Scalars['String']['output']>;
  /** Компания, которой принадлежит карта */
  company: CompanyAWebDto;
  /** ID компании */
  companyId: Scalars['ID']['output'];
  /** Компетенции карты компетенций */
  competences?: Maybe<Array<CompetenceAWebDto>>;
  id: Scalars['ID']['output'];
  /** Использовать проверку репозитория */
  isRepositoryCheck: Scalars['Boolean']['output'];
  /** Флаг примера */
  isSample: Scalars['Boolean']['output'];
  /** Номер карты компетенций компании */
  numericId: Scalars['Float']['output'];
  /** Специализация карты компетенций */
  specialization: Scalars['String']['output'];
  /** Статус карты */
  status: Competency_Map_Status;
  /** Название карты компетенций */
  title: Scalars['String']['output'];
};

export type CompetencyMapFromXlsxInput = {
  /** Файл с данными для заполнения */
  file: Scalars['Upload']['input'];
  /** Специализация карты компетенций */
  specialization: Scalars['String']['input'];
  /** Название карты компетенций */
  title: Scalars['String']['input'];
};

export type CompetencyMapTrialsInfoDto = {
  __typename?: 'CompetencyMapTrialsInfoDto';
  /** Количество тестирований с данной картой компетенций */
  count: Scalars['Float']['output'];
  /** Есть ли начатые тестирования */
  hasStarted: Scalars['Boolean']['output'];
};

export type CopyCompetenceMapInputDto = {
  /** Id карты компетенций */
  competencyMapId: Scalars['ID']['input'];
  /** Название новой карты компетенций */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompetencyMapFromFileInput = {
  /** Файл с данными для заполнения */
  dataFile: Scalars['Upload']['input'];
  /** Специализация карты компетенций */
  specialization: Scalars['String']['input'];
  /** Название карты компетенции */
  title: Scalars['String']['input'];
};

export type CreateExaminationGroupInput = {
  /** Ids кандидатов компании */
  companyCandidateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateExaminationInput = {
  /** Комментарий к тестированию */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Id карты компетенций */
  competencyMapId: Scalars['ID']['input'];
  groupInput?: InputMaybe<CreateExaminationGroupInput>;
  /** Отправлять ли результат канидату */
  isSendResult?: Scalars['Boolean']['input'];
  personalInput?: InputMaybe<CreateExaminationPersonalInput>;
  /** Тип отчета для отправки */
  sendResultType?: Trial_File_Type;
  /** Название тестирования */
  title: Scalars['String']['input'];
  /** Тип тестирования */
  type: Examination_Type;
};

export type CreateExaminationPersonalInput = {
  /** Id кандидата компании */
  companyCandidateId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOrUpdateCompanyCandidateInput = {
  /** Файл резюме */
  cvFile?: InputMaybe<Scalars['Upload']['input']>;
  /** Email кандидата */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ФИО кандидата */
  fullName: Scalars['String']['input'];
  /** Грейд кандидата */
  grade?: InputMaybe<Grade>;
  /** Id кандидата */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Ссылка на headhunter */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Организация */
  organization?: InputMaybe<Scalars['String']['input']>;
  /** Номер телефона */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Позиция кандидата в компании */
  position?: InputMaybe<Scalars['String']['input']>;
  /** Профиль телеграм кандидата */
  telegramUsername: Scalars['String']['input'];
  /** Тип кандидата компании */
  type: Company_Candidate_Type;
};

export type CreateOrUpdateCompanyCandidateLoginInput = {
  /** Файл резюме */
  cvFile?: InputMaybe<Scalars['Upload']['input']>;
  /** Email кандидата */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ФИО кандидата */
  fullName: Scalars['String']['input'];
  /** Грейд кандидата */
  grade?: InputMaybe<Grade>;
  /** Id кандидата */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Ссылка на headhunter */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Логин кандидата */
  login: Scalars['String']['input'];
  /** Организация */
  organization?: InputMaybe<Scalars['String']['input']>;
  /** Пароль при создании */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Номер телефона */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Позиция кандидата в компании */
  position?: InputMaybe<Scalars['String']['input']>;
  /** Тип кандидата компании */
  type: Company_Candidate_Type;
};

export type CreateOrUpdateCompanyInput = {
  /** Дата последних изменений */
  actualityDate?: InputMaybe<Scalars['Float']['input']>;
  /** Полное наименование */
  fullName: Scalars['String']['input'];
  /** Id компании */
  id?: InputMaybe<Scalars['String']['input']>;
  /** ИНН */
  inn: Scalars['String']['input'];
  /** КПП */
  kpp: Scalars['String']['input'];
  /** Дата ликвидации */
  liquidationDate?: InputMaybe<Scalars['Float']['input']>;
  /** ФИО руководителя */
  managerFio: Scalars['String']['input'];
  /** Должность руководителя */
  managerPosition: Scalars['String']['input'];
  /** ОГРН */
  ogrn: Scalars['String']['input'];
  /** Дата выдачи ОГРН */
  ogrnDate: Scalars['Float']['input'];
  /** Код ОКАТО */
  okato: Scalars['String']['input'];
  /** Код ОКПО */
  okpo: Scalars['String']['input'];
  /** Код ОКТМО */
  oktmo: Scalars['String']['input'];
  /** Адрес регистрации */
  registrationAddress: Scalars['String']['input'];
  /** Дата регистрации */
  registrationDate: Scalars['Float']['input'];
  /** Краткое наименование */
  shortName: Scalars['String']['input'];
  /** Cтатус организации */
  state: Organization_State;
  /** Тип организации */
  type: Type_Of_Organization;
  /** Должность пользователя, заносящего компанию */
  userPosition: Scalars['String']['input'];
};

export type CreateOrUpdateCompetenceInput = {
  /** Id компетенции */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Список id блоков знаний */
  knowledgeBlocksIds: Array<Scalars['String']['input']>;
  /** Название компетенции */
  title: Scalars['String']['input'];
};

export type CreateOrUpdateCompetencyMapInput = {
  /** Комментарий к карте компетенций */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Id компании */
  companyId: Scalars['String']['input'];
  /** Компетенции карты компетенций */
  competences: Array<CreateOrUpdateCompetenceInput>;
  demoCode?: InputMaybe<Scalars['String']['input']>;
  /** Id карты компетенций */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Использовать проверку репозитория */
  isRepositoryCheck: Scalars['Boolean']['input'];
  /** Специализация карты компетенций */
  specialization: Scalars['String']['input'];
  /** Статус карты компетенций */
  status?: InputMaybe<Competency_Map_Status>;
  /** Название карты компетенций */
  title: Scalars['String']['input'];
  /** Использовать карту компетенций в боте */
  useInBot?: Scalars['Boolean']['input'];
};

export type CreateOrUpdateKnowledgeBlockInput = {
  /** Id компании */
  companyId: Scalars['String']['input'];
  /** Id компетенции */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Язык профессия */
  profession: Scalars['String']['input'];
  /** Название компетенции */
  title: Scalars['String']['input'];
};

export type CreateOrUpdateQuestionInput = {
  /** Критерии вопроса */
  criterion: Array<Scalars['String']['input']>;
  /** Грейд вопроса */
  grade: Grade;
  /** Id вопроса */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Язык вопроса */
  language: Language;
  /** Элементы вопроса */
  partsInput?: InputMaybe<Array<CreateOrUpdateQuestionPart>>;
  /** Эталонный ответ на вопрос */
  referenceAnswer?: InputMaybe<Scalars['String']['input']>;
  /** Id навыка */
  skillId: Scalars['ID']['input'];
  /** Подтип вопроса */
  subtype?: InputMaybe<Scalars['String']['input']>;
  /** Текст вопроса */
  text: Scalars['String']['input'];
  /** Количество секунд отведённых на вопрос */
  time: Scalars['Float']['input'];
  /** Тип вопроса */
  type: Question_Type;
};

export type CreateOrUpdateQuestionPart = {
  /** Содержание элемента вопроса */
  content: Scalars['String']['input'];
  /** Id элемента */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Является ли ответ верным */
  isCorrect: Scalars['Boolean']['input'];
};

export type CreateOrUpdateSkillInput = {
  /** Id топика */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** ID блока знаний */
  knowledgeBlockId: Scalars['ID']['input'];
  /** Порядок навыка */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Название топика */
  title: Scalars['String']['input'];
};

export type CreateUserInput = {
  /** Email */
  email: Scalars['String']['input'];
  /** Имя */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Отчество */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Пароль */
  password: Scalars['String']['input'];
};

export type CreateVacancyCompanyCandidateByCVs = {
  __typename?: 'CreateVacancyCompanyCandidateByCVs';
  /** ФИО кандидата компании */
  fullName: Scalars['String']['output'];
  /** Логин */
  login: Scalars['String']['output'];
  /** Численный id кандидата в рамках компании */
  numericId: Scalars['Float']['output'];
  /** Пароль */
  password: Scalars['String']['output'];
};

export type CreateVacancyCompanyCandidatesInput = {
  /** Ids кандидатов компании */
  companyCandidateIds: Array<Scalars['ID']['input']>;
  /** Id вакансии */
  vacancyId: Scalars['ID']['input'];
};

export type CreateVacancyInput = {
  /** Описание вакансии */
  description: Scalars['String']['input'];
  /** Заголовок */
  title: Scalars['String']['input'];
};

export type CriterionAssessment = {
  __typename?: 'CriterionAssessment';
  criteria: Scalars['String']['output'];
  decision: Scalars['String']['output'];
  explanation: Scalars['String']['output'];
};

export type CriterionMatchFilterInput = {
  /** Тип критерия */
  criteria: Scalars['String']['input'];
  /** Объяснение критерия */
  explanation?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<FilterRange>;
};

export type CvCheck = {
  __typename?: 'CvCheck';
  /** Логи оценки */
  MlLogs?: Maybe<Array<MlLog>>;
  /** Оценки по skills */
  assessmentCV?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['Date']['output'];
  /** CV кандидата */
  cvFile: File;
  /** Id CV кандидата */
  cvFileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Отчет по оценка CV */
  reportFile?: Maybe<File>;
  /** Id отчета по оценке CV */
  reportFileId?: Maybe<Scalars['ID']['output']>;
  /** Оценка CV */
  score?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
  /** Кандидат вакансии */
  vacancyCompanyCandidate: Array<VacancyCompanyCandidate>;
  /** Id кандидата вакансии */
  vacancyCompanyCandidateId: Scalars['ID']['output'];
};

export enum Examination_Type {
  Group = 'GROUP',
  Open = 'OPEN',
  Personal = 'PERSONAL',
  Public = 'PUBLIC'
}

export type Examination = {
  __typename?: 'Examination';
  /** Карта компетенций */
  competencyMap: CompetencyMap;
  /** Id карты компетенций */
  competencyMapId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  /** Генерировать ли дополнитедьные комментарии для данных отчёта */
  genAltReportData: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Активно ли тестирование */
  isActive: Scalars['Boolean']['output'];
  /** Можно ли отменять типовое тестирование */
  isCanCanceled?: Maybe<Scalars['Boolean']['output']>;
  /** Отправлять ли результат канидату */
  isSendResult: Scalars['Boolean']['output'];
  /** Дата завершения последнего тестирования */
  lastCompleteDate?: Maybe<Scalars['Date']['output']>;
  /** Номер тестирования */
  numericId: Scalars['Float']['output'];
  /** Среднее расчётное время прохождение тестирования */
  questionsTime?: Maybe<Scalars['Float']['output']>;
  /** Тип отчета для отправки */
  sendResultType: Trial_File_Type;
  /** Название тестирования */
  title: Scalars['String']['output'];
  /** Тестирования кандидатов */
  trials?: Maybe<Array<Trial>>;
  /** Тип тестирования */
  type: Examination_Type;
  updatedAt: Scalars['Date']['output'];
};

export type ExaminationAWebDto = {
  __typename?: 'ExaminationAWebDto';
  /** Карта компетенций */
  competencyMap: CompetencyMapAWebDto;
  /** Id карты компетенций */
  competencyMapId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Отправлять ли результат канидату */
  isSendResult: Scalars['Boolean']['output'];
  /** Номер тестирования */
  numericId: Scalars['Float']['output'];
  /** Тип отчета для отправки */
  sendResultType: Trial_File_Type;
  /** Тестирования кандидатов */
  trials?: Maybe<Array<TrialAWebDto>>;
};

export type File = {
  __typename?: 'File';
  /** Ответы кандидата по тестированию */
  answers?: Maybe<Array<TrialAnswer>>;
  /** CV кандидата */
  companyCandidates?: Maybe<Array<CompanyCandidate>>;
  createdAt: Scalars['Date']['output'];
  /** CV кандидата для истории оценок */
  cvFiles?: Maybe<Array<CvCheck>>;
  /** Расширение файла */
  extension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Ключ файла в S3 */
  key: Scalars['String']['output'];
  /** Название файла */
  name: Scalars['String']['output'];
  /** Отчет по оценки CV */
  reportFiles?: Maybe<Array<CvCheck>>;
  /** Отчеты по тестированию */
  trialFiles?: Maybe<Array<TrialFile>>;
  updatedAt: Scalars['Date']['output'];
  /** Ссылка на файл */
  url: Scalars['String']['output'];
};

export type FileAWebDto = {
  __typename?: 'FileAWebDto';
  /** Расширение файла */
  extension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Ключ файла в S3 */
  key: Scalars['String']['output'];
  /** Название файла */
  name: Scalars['String']['output'];
  /** Ссылка на файл */
  url: Scalars['String']['output'];
};

export type FilterRange = {
  /** Левая граница */
  from: Scalars['Float']['input'];
  /** Правая граница */
  to: Scalars['Float']['input'];
};

export enum Grade {
  Junior = 'Junior',
  Middle = 'Middle',
  Senior = 'Senior'
}

export type GenerateReportFileInput = {
  /** Id тестирования */
  trialId: Scalars['ID']['input'];
  /** Тип отчета */
  type: Trial_File_Type;
};

export type GenerateSkeletonCompetencyMapDescriptionInput = {
  /** Описание вакансии */
  description: Scalars['String']['input'];
  /** Грейд */
  grade: Grade;
  /** Язык */
  language: Language;
  /** Специализация */
  specialization: Scalars['String']['input'];
  /** Название карты */
  title: Scalars['String']['input'];
};

export type GenerateSkeletonCompetencyMapVacancyInput = {
  /** Описание вакансии */
  description: Scalars['String']['input'];
  /** Язык */
  language: Language;
  /** Специализация */
  specialization: Scalars['String']['input'];
  /** Название карты */
  title: Scalars['String']['input'];
};

export type GetQuestionSubTypeResult = {
  __typename?: 'GetQuestionSubTypeResult';
  /** Подтипы для типа */
  subtypes: Array<Scalars['String']['output']>;
  /** Тип вопроса */
  type: Question_Type;
};

export type InitGenerateQuestionsInput = {
  /** Количество вопросов */
  amount: Scalars['Float']['input'];
  /** Коментарий пользователя для генерации вопросов */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Коментарий пользователя для генерации критериев */
  criterionComment?: InputMaybe<Scalars['String']['input']>;
  /** Грейд вопроса */
  grade: Grade;
  /** Язык вопроса */
  language: Language;
  /** Подтипа практического вопроса */
  questionSubtype?: InputMaybe<Scalars['String']['input']>;
  /** Тип вопроса */
  questionType: Question_Type;
  /** Id навыка */
  skillId: Scalars['ID']['input'];
};

export type KnowledgeBlock = {
  __typename?: 'KnowledgeBlock';
  /** Компания */
  company: Company;
  /** ID компании */
  companyId: Scalars['ID']['output'];
  /** Карты компетенций в текущем блоке знаний */
  competenceMaps?: Maybe<Array<CompetencyMap>>;
  createdAt: Scalars['Date']['output'];
  /** Грейды блока знаний */
  grades?: Maybe<Array<Grade>>;
  id: Scalars['ID']['output'];
  /** Флаг удаления */
  isDeleted: Scalars['Boolean']['output'];
  /** Компетенции Блока */
  knowledgeBlockCompetences?: Maybe<Array<KnowledgeBlockCompetence>>;
  /** Профессия */
  profession: Scalars['String']['output'];
  /** Навыки компетенции */
  skills?: Maybe<Array<Skill>>;
  /** Название блока знаний */
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type KnowledgeBlockAWebDto = {
  __typename?: 'KnowledgeBlockAWebDto';
  id: Scalars['ID']['output'];
  /** Профессия */
  profession: Scalars['String']['output'];
  /** Название блока знаний */
  title: Scalars['String']['output'];
};

export type KnowledgeBlockCompetence = {
  __typename?: 'KnowledgeBlockCompetence';
  /** Компетенция */
  competence: Competence;
  /** ID Компетенции */
  competenceId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Блоки знаний */
  knowledgeBlock: KnowledgeBlock;
  /** ID Блока знаний */
  knowledgeBlockId: Scalars['ID']['output'];
  /** Порядок компетенции в блоке */
  order: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type KnowledgeBlockCompetenceAWebDto = {
  __typename?: 'KnowledgeBlockCompetenceAWebDto';
  /** Компетенция */
  competence: CompetenceAWebDto;
  /** ID Компетенции */
  competenceId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Блок знаний */
  knowledgeBlock: KnowledgeBlockAWebDto;
  /** ID Блока знаний */
  knowledgeBlockId: Scalars['ID']['output'];
};

export enum Language {
  En = 'en',
  Kk = 'kk',
  Ru = 'ru',
  Uz = 'uz'
}

export type ListCompanyCandidateFilterInput = {
  /** Средний результат по всем пройденным тестированиям */
  averageScore?: InputMaybe<FilterRange>;
  /** Дата завершения тестирования, отправлять нужное число в локальном часовом поясе c временем 00:00:000 */
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Дата создания кандидата компании */
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Email кандидата компании */
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Грейд кандидата компании */
  grade?: InputMaybe<Grade>;
  isTelegram?: InputMaybe<Scalars['Boolean']['input']>;
  /** Язык */
  language?: InputMaybe<Language>;
  /** Результат по последнему тестированию */
  lastTrialScore?: InputMaybe<FilterRange>;
  /** Статус последнего тестирования */
  lastTrialStatus?: InputMaybe<Array<Trial_Status>>;
  /** Время тестирования */
  lastTrialTime?: InputMaybe<FilterRange>;
  login?: InputMaybe<Scalars['String']['input']>;
  /** Номер кандидата компании */
  numericId?: InputMaybe<Scalars['Float']['input']>;
  /** Организация */
  organization?: InputMaybe<Scalars['String']['input']>;
  /** Номер телефона кандидата */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Должность */
  position?: InputMaybe<Scalars['String']['input']>;
  /** Ник в телеграмме */
  telegramUsername?: InputMaybe<Scalars['String']['input']>;
  /** Количество тестирования */
  trialsCount?: InputMaybe<Scalars['Float']['input']>;
  /** Тип кандидата компании */
  type?: InputMaybe<Company_Candidate_Type>;
};

export type ListCompetencyMapFilterInput = {
  /** Количество компетенций */
  competencesCount?: InputMaybe<FilterRange>;
  /** Дата создания карты компетенций, отправлять нужное число в локальном часовом поясе c временем 00:00:000 */
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Грейды */
  grades?: InputMaybe<Array<Grade>>;
  /** Проверка репозитория */
  isRepositoryCheck?: InputMaybe<Scalars['Boolean']['input']>;
  /** Язык */
  language?: InputMaybe<Language>;
  /** Дата последнего тестирования, отправлять нужное число в локально часовом поясе с временем 00:00:000 */
  lastTrialAt?: InputMaybe<Scalars['Date']['input']>;
  /** Номер карты компетенций */
  numericId?: InputMaybe<Scalars['Float']['input']>;
  /** Специализация */
  specialization?: InputMaybe<Scalars['String']['input']>;
  /** Статус карты компетенций */
  status?: InputMaybe<Competency_Map_Status>;
  /** Название карты компетенций */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Количество тестирований */
  trialsCount?: InputMaybe<FilterRange>;
  /** Дата последнего изменения карты компетенций, отправлять нужное число в локально часовом поясе с временем 00:00:000 */
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type ListExaminationFilterInput = {
  /** Оценка вероятности использования ИИ по тестированию в % */
  aiGenerationPercentage?: InputMaybe<FilterRange>;
  /** Количество блоков знаний */
  blocksCount?: InputMaybe<FilterRange>;
  /** ФИО кандидата */
  candidateFullName?: InputMaybe<Scalars['String']['input']>;
  /** Id кандидата */
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  /** Номер кандидата компании */
  candidateNumericId?: InputMaybe<Scalars['Float']['input']>;
  /** Общая оценка по тестированию в % */
  candidateScore?: InputMaybe<FilterRange>;
  /** Количество компетенций */
  competencesCount?: InputMaybe<FilterRange>;
  /** Id карты компетенций */
  competencyMapId?: InputMaybe<Scalars['ID']['input']>;
  /** Название карты компетенций */
  competencyMapTitle?: InputMaybe<Scalars['String']['input']>;
  /** Дата завершения тестирования, отправлять нужное число в локальном часовом поясе c временем 00:00:000 */
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Дата создания тестирования, отправлять нужное число в локальном часовом поясе с временем 00:00:000 */
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Тип тестирования */
  examinationType?: InputMaybe<Examination_Type>;
  /** Ожидаемое время прохождения тестирования в секундах */
  expectedTimeOfTesting?: InputMaybe<FilterRange>;
  /** Грейд */
  grades?: InputMaybe<Array<Grade>>;
  /** Id типового тестирования */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Активно ли тестирование */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Была ли оценка репозитория? */
  isRepositoryCheck?: InputMaybe<Scalars['Boolean']['input']>;
  /** Номер типового тестирования */
  numericId?: InputMaybe<Scalars['Float']['input']>;
  /** Специализация */
  specialization?: InputMaybe<Scalars['String']['input']>;
  /** Время прохождения тестирования в секундах */
  timeOfTesting?: InputMaybe<FilterRange>;
  /** Название тестирования */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Статус тестирования */
  trialStatus?: InputMaybe<Trial_Status>;
};

export type ListKnowledgeBlockFilterInput = {
  /** Дата создания блока, отправлять нужное число в локальном часовом поясе c временем 00:00:000 */
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Грейды */
  grades?: InputMaybe<Array<Grade>>;
  /** Название блока знаний */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ListSkillFilterInput = {
  /** Дата создания навыка */
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Грейды */
  grades?: InputMaybe<Array<Grade>>;
  /** Id блока знаний */
  knowledgeBlockId: Scalars['ID']['input'];
  /** Название навыка */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ListTrialFilterInput = {
  /** Оценка вероятности использования ИИ по тестированию в % */
  aiGenerationPercentage?: InputMaybe<FilterRange>;
  /** ФИО кандидата */
  candidateFullName?: InputMaybe<Scalars['String']['input']>;
  /** Numeric id кандидата */
  candidateNumericId?: InputMaybe<Scalars['Float']['input']>;
  /** Общая оценка по тестированию в % */
  candidateScore?: InputMaybe<FilterRange>;
  /** Результаты кандидата по каждой компетенции */
  competenceScores?: InputMaybe<Array<CompetenceScore>>;
  /** Название карты компетенций */
  competencyMapTitle?: InputMaybe<Scalars['String']['input']>;
  /** Дата завершения тестирования, отправлять нужное число в локальном часовом поясе c временем 00:00:000 */
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Id типового тестирования */
  examinationId?: InputMaybe<Scalars['ID']['input']>;
  /** Ожидаемое время прохождения тестирования в секундах */
  expectedTimeOfTesting?: InputMaybe<FilterRange>;
  /** Статус тестирования */
  status?: InputMaybe<Trial_Status>;
  /** Время прохождения тестирования в секундах */
  timeOfTesting?: InputMaybe<FilterRange>;
};

export type ListVacancyCompanyCandidateFilterInput = {
  /** Ключевые плюсы */
  advantages?: InputMaybe<Scalars['String']['input']>;
  /** Дата создания кандидата компании */
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Рекомендации */
  criterionMatch?: InputMaybe<Array<CriterionMatchFilterInput>>;
  /** Соответствие кандидата на вакансию по последнему CV */
  cvCheckScore?: InputMaybe<FilterRange>;
  /** Ключевые минусы */
  disadvantages?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Наличие CV */
  isCVFile?: InputMaybe<Scalars['Boolean']['input']>;
  isTelegram?: InputMaybe<Scalars['Boolean']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  /** Номер кандидата компании */
  numericId?: InputMaybe<Scalars['Float']['input']>;
  /** Рекомендации */
  recommendations?: InputMaybe<Scalars['String']['input']>;
  /** Ник в телеграмме */
  telegramUsername?: InputMaybe<Scalars['String']['input']>;
  /** Количество лет опыта */
  totalExperienceYears?: InputMaybe<FilterRange>;
  /** Id вакансии */
  vacancyId: Scalars['ID']['input'];
};

export type ListVacancyFilterInput = {
  /** Количество кандидатов */
  companyCandidateCount?: InputMaybe<FilterRange>;
  /** Дата создания вакансии, отправлять нужное число в локальном часовом поясе c временем 00:00:000 */
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  /** Численный id в рамках компании */
  numericId?: InputMaybe<Scalars['Float']['input']>;
  /** Название вакансии */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum Ml_Log_Event {
  AssessAnswer = 'assess_answer',
  CmFromDescription = 'cm_from_description',
  CmFromVacancy = 'cm_from_vacancy',
  GenerateAltReport = 'generate_alt_report',
  GenerateQuestions = 'generate_questions',
  GenerateReport = 'generate_report',
  Regenerate = 'regenerate',
  RegenerateSync = 'regenerate_sync',
  RelevanceAssessment = 'relevance_assessment'
}

export enum Ml_Log_Status {
  Error = 'ERROR',
  Initialized = 'INITIALIZED',
  InternalError = 'INTERNAL_ERROR',
  RequestFailed = 'REQUEST_FAILED',
  Success = 'SUCCESS'
}

export type MlLog = {
  __typename?: 'MlLog';
  /** Карта компетенций */
  competencyMap?: Maybe<CompetencyMap>;
  /** ID Карты компетенций */
  competencyMapId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Оценка CV */
  cvCheck?: Maybe<CvCheck>;
  /** ID Оценки CV */
  cvCheckId?: Maybe<Scalars['ID']['output']>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Тип лога */
  event: Ml_Log_Event;
  id: Scalars['ID']['output'];
  /** Вопрос */
  question?: Maybe<Question>;
  /** ID Вопроса */
  questionId?: Maybe<Scalars['ID']['output']>;
  /** Данные запроса */
  requestData?: Maybe<Scalars['JSON']['output']>;
  /** Id запроса */
  requestId: Scalars['ID']['output'];
  /** Данные ответа */
  responseData?: Maybe<Scalars['JSON']['output']>;
  /** Навык (при генерации вопросов) */
  skill?: Maybe<Skill>;
  /** ID топика */
  skillId?: Maybe<Scalars['ID']['output']>;
  /** Статус лога */
  status: Ml_Log_Status;
  /** Тестирование */
  trial?: Maybe<Trial>;
  /** Ответ (при оценке ответа */
  trialAnswer?: Maybe<TrialAnswer>;
  /** ID Ответа */
  trialAnswerId?: Maybe<Scalars['ID']['output']>;
  /** ID Карты компетенций */
  trialId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Добавление кандидатов в групповое тестирование */
  addCompanyCandidatesToExamination: Array<Trial>;
  /** Инициализация запрос на оценку CV кандидатов компании */
  assessmentCv: Scalars['Boolean']['output'];
  /** Запуск генерации вопросов по всем навыкам */
  batchInitGenerateQuestions: Scalars['Boolean']['output'];
  /** Отмена тестирования */
  cancelExamination: Scalars['Boolean']['output'];
  /** Обновление статуса тестирования */
  cancelTrial: Trial;
  /** Отправить вопрос в подтвержденные или наоборот */
  confirmOrRejectQuestion: Question;
  /** Создание новой карты компетенций на основе другой */
  copyCompetencyMap: CompetencyMap;
  /** Загрузка карты компетенции из файла .json */
  createCompetencyMapFromJson: CompetencyMap;
  /** Загрузка карты компетенции из файла xlsx c инициализацией генерации вопросов */
  createCompetencyMapFromXlsx: CompetencyMap;
  /** Создания типового тестирования */
  createExamination: Examination;
  /** Создание или обновление компании */
  createOrUpdateCompany: Company;
  /** Создание или обновление кандидата компании */
  createOrUpdateCompanyCandidate: CompanyCandidate;
  /** Создание или обновление кандидата компании */
  createOrUpdateCompanyCandidateLogin: CompanyCandidate;
  /** Создание или обновление карты компетенций */
  createOrUpdateCompetencyMap: CompetencyMap;
  /** Создание или обновление блока знаний */
  createOrUpdateKnowledgeBlock: KnowledgeBlock;
  /** Создание или обновление вопроса */
  createOrUpdateQuestion: Question;
  /** Создание или обновлений топика */
  createOrUpdateSkill: Skill;
  /** Регистрация пользователя */
  createUser: AuthTokensDto;
  /** Создание вакансии */
  createVacancy: Vacancy;
  /** Добавление кандидатов на вакансию */
  createVacancyCompanyCandidate: Array<VacancyCompanyCandidate>;
  /** Загрузка кандидатов по списку CV */
  createVacancyCompanyCandidateByCVs?: Maybe<Array<CreateVacancyCompanyCandidateByCVs>>;
  /** Удаление карты компетенций */
  deleteCompetencyMap: Scalars['Boolean']['output'];
  /** Удаление блока знаний */
  deleteKnowledgeBlock: Scalars['Boolean']['output'];
  /** Удаление вопроса */
  deleteQuestion: Scalars['Boolean']['output'];
  /** Удаление топика */
  deleteSkill: Scalars['Boolean']['output'];
  /** Удаление вакансии */
  deleteVacancy: Scalars['Boolean']['output'];
  /** Удаление кандидат вакансии по Id */
  deleteVacancyCompanyCandidate: Scalars['Boolean']['output'];
  /** Файл отчета */
  generateReportFile?: Maybe<TrialFile>;
  /** Инициализация генерации скелета карты с указанием грейда */
  generateSkeletonOfCompetencyMapByDescription: Scalars['Boolean']['output'];
  /** Инициализация генерации скелета карты без грейда */
  generateSkeletonOfCompetencyMapByVacancy: Scalars['Boolean']['output'];
  /** Генерация вопроса для топика */
  initGenerateQuestions: Scalars['Boolean']['output'];
  /** Авторизация связке номер email + пароль */
  loginByCredentials: AuthTokensDto;
  /** Обновление токенов авторизации */
  refreshTokens: AuthTokensDto;
  /** Асинхронная перегенерация элементов вопроса */
  regenerateQuestion: Scalars['Boolean']['output'];
  /** Синхронная перегенерация элементов вопроса */
  regenerateQuestionSync: RegenerateQuestionDataResultDto;
  /** Создание или обновление тестирования */
  updatePersonalTrial: Trial;
  /** Обновление статуса карты компетенций */
  updateStatusCompetencyMap: CompetencyMap;
  /** Обновление данных пользователя */
  updateUser: User;
  /** Прямая загрузка фалйа */
  uploadFile: PlainFileDto;
};


export type MutationAddCompanyCandidatesToExaminationArgs = {
  input: AddCompanyCandidatesToExaminationInput;
};


export type MutationAssessmentCvArgs = {
  vacancyId: Scalars['ID']['input'];
};


export type MutationBatchInitGenerateQuestionsArgs = {
  input: BatchInitGenerateQuestionsInput;
};


export type MutationCancelExaminationArgs = {
  examinationId: Scalars['ID']['input'];
};


export type MutationCancelTrialArgs = {
  trialId: Scalars['ID']['input'];
};


export type MutationConfirmOrRejectQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type MutationCopyCompetencyMapArgs = {
  input: CopyCompetenceMapInputDto;
};


export type MutationCreateCompetencyMapFromJsonArgs = {
  input: CreateCompetencyMapFromFileInput;
};


export type MutationCreateCompetencyMapFromXlsxArgs = {
  input: CompetencyMapFromXlsxInput;
};


export type MutationCreateExaminationArgs = {
  input: CreateExaminationInput;
};


export type MutationCreateOrUpdateCompanyArgs = {
  input: CreateOrUpdateCompanyInput;
};


export type MutationCreateOrUpdateCompanyCandidateArgs = {
  input: CreateOrUpdateCompanyCandidateInput;
};


export type MutationCreateOrUpdateCompanyCandidateLoginArgs = {
  input: CreateOrUpdateCompanyCandidateLoginInput;
};


export type MutationCreateOrUpdateCompetencyMapArgs = {
  input: CreateOrUpdateCompetencyMapInput;
};


export type MutationCreateOrUpdateKnowledgeBlockArgs = {
  input: CreateOrUpdateKnowledgeBlockInput;
};


export type MutationCreateOrUpdateQuestionArgs = {
  input: CreateOrUpdateQuestionInput;
};


export type MutationCreateOrUpdateSkillArgs = {
  input: CreateOrUpdateSkillInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVacancyArgs = {
  input: CreateVacancyInput;
};


export type MutationCreateVacancyCompanyCandidateArgs = {
  input: CreateVacancyCompanyCandidatesInput;
};


export type MutationCreateVacancyCompanyCandidateByCVsArgs = {
  files: Array<Scalars['Upload']['input']>;
  vacancyId: Scalars['ID']['input'];
};


export type MutationDeleteCompetencyMapArgs = {
  competencyMapId: Scalars['ID']['input'];
};


export type MutationDeleteKnowledgeBlockArgs = {
  knowledgeBlockId: Scalars['ID']['input'];
};


export type MutationDeleteQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type MutationDeleteSkillArgs = {
  skillId: Scalars['ID']['input'];
};


export type MutationDeleteVacancyArgs = {
  vacancyId: Scalars['String']['input'];
};


export type MutationDeleteVacancyCompanyCandidateArgs = {
  vacancyCompanyCandidateId: Scalars['ID']['input'];
};


export type MutationGenerateReportFileArgs = {
  input: GenerateReportFileInput;
};


export type MutationGenerateSkeletonOfCompetencyMapByDescriptionArgs = {
  input: GenerateSkeletonCompetencyMapDescriptionInput;
};


export type MutationGenerateSkeletonOfCompetencyMapByVacancyArgs = {
  input: GenerateSkeletonCompetencyMapVacancyInput;
};


export type MutationInitGenerateQuestionsArgs = {
  input: InitGenerateQuestionsInput;
};


export type MutationLoginByCredentialsArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationRefreshTokensArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegenerateQuestionArgs = {
  input: RegenerateQuestionInput;
};


export type MutationRegenerateQuestionSyncArgs = {
  input: RegenerateQuestionDataInput;
};


export type MutationUpdatePersonalTrialArgs = {
  input: UpdateTrialInput;
};


export type MutationUpdateStatusCompetencyMapArgs = {
  input: UpdateCompetencyMapStatusInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserDataInput;
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload']['input'];
};

export enum Organization_State {
  Active = 'ACTIVE',
  Bankrupt = 'BANKRUPT',
  Liquidated = 'LIQUIDATED',
  Liquidating = 'LIQUIDATING',
  Reorganizing = 'REORGANIZING'
}

export enum OrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PaginatedCompanyCandidate = {
  __typename?: 'PaginatedCompanyCandidate';
  /** Данные на указанной странице */
  data?: Maybe<Array<CompanyCandidate>>;
  /** Есть ли следующая страница */
  hasNextPage: Scalars['Boolean']['output'];
  /** Есть ли предыдущая странца */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Номер страницы (отсчёт с 0) */
  limit: Scalars['Float']['output'];
  /** Общее число записей */
  page: Scalars['Float']['output'];
  /** Ограничение количества записей на странице */
  totalCount: Scalars['Float']['output'];
};

export type PaginatedCompetencyMap = {
  __typename?: 'PaginatedCompetencyMap';
  /** Данные на указанной странице */
  data?: Maybe<Array<CompetencyMap>>;
  /** Есть ли следующая страница */
  hasNextPage: Scalars['Boolean']['output'];
  /** Есть ли предыдущая странца */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Номер страницы (отсчёт с 0) */
  limit: Scalars['Float']['output'];
  /** Общее число записей */
  page: Scalars['Float']['output'];
  /** Ограничение количества записей на странице */
  totalCount: Scalars['Float']['output'];
};

export type PaginatedExamination = {
  __typename?: 'PaginatedExamination';
  /** Данные на указанной странице */
  data?: Maybe<Array<Examination>>;
  /** Есть ли следующая страница */
  hasNextPage: Scalars['Boolean']['output'];
  /** Есть ли предыдущая странца */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Номер страницы (отсчёт с 0) */
  limit: Scalars['Float']['output'];
  /** Общее число записей */
  page: Scalars['Float']['output'];
  /** Ограничение количества записей на странице */
  totalCount: Scalars['Float']['output'];
};

export type PaginatedKnowledgeBlock = {
  __typename?: 'PaginatedKnowledgeBlock';
  /** Данные на указанной странице */
  data?: Maybe<Array<KnowledgeBlock>>;
  /** Есть ли следующая страница */
  hasNextPage: Scalars['Boolean']['output'];
  /** Есть ли предыдущая странца */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Номер страницы (отсчёт с 0) */
  limit: Scalars['Float']['output'];
  /** Общее число записей */
  page: Scalars['Float']['output'];
  /** Ограничение количества записей на странице */
  totalCount: Scalars['Float']['output'];
};

export type PaginatedSkill = {
  __typename?: 'PaginatedSkill';
  /** Данные на указанной странице */
  data?: Maybe<Array<Skill>>;
  /** Есть ли следующая страница */
  hasNextPage: Scalars['Boolean']['output'];
  /** Есть ли предыдущая странца */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Номер страницы (отсчёт с 0) */
  limit: Scalars['Float']['output'];
  /** Общее число записей */
  page: Scalars['Float']['output'];
  /** Ограничение количества записей на странице */
  totalCount: Scalars['Float']['output'];
};

export type PaginatedTrial = {
  __typename?: 'PaginatedTrial';
  /** Данные на указанной странице */
  data?: Maybe<Array<Trial>>;
  /** Есть ли следующая страница */
  hasNextPage: Scalars['Boolean']['output'];
  /** Есть ли предыдущая странца */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Номер страницы (отсчёт с 0) */
  limit: Scalars['Float']['output'];
  /** Общее число записей */
  page: Scalars['Float']['output'];
  /** Ограничение количества записей на странице */
  totalCount: Scalars['Float']['output'];
};

export type PaginatedVacancy = {
  __typename?: 'PaginatedVacancy';
  /** Данные на указанной странице */
  data?: Maybe<Array<Vacancy>>;
  /** Есть ли следующая страница */
  hasNextPage: Scalars['Boolean']['output'];
  /** Есть ли предыдущая странца */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Номер страницы (отсчёт с 0) */
  limit: Scalars['Float']['output'];
  /** Общее число записей */
  page: Scalars['Float']['output'];
  /** Ограничение количества записей на странице */
  totalCount: Scalars['Float']['output'];
};

export type PaginatedVacancyCompanyCandidate = {
  __typename?: 'PaginatedVacancyCompanyCandidate';
  /** Данные на указанной странице */
  data?: Maybe<Array<VacancyCompanyCandidate>>;
  /** Есть ли следующая страница */
  hasNextPage: Scalars['Boolean']['output'];
  /** Есть ли предыдущая странца */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Номер страницы (отсчёт с 0) */
  limit: Scalars['Float']['output'];
  /** Общее число записей */
  page: Scalars['Float']['output'];
  /** Ограничение количества записей на странице */
  totalCount: Scalars['Float']['output'];
};

export type PlainFileDto = {
  __typename?: 'PlainFileDto';
  createdAt: Scalars['Date']['output'];
  /** Расширение файла */
  extension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Ключ файла в S3 */
  key: Scalars['String']['output'];
  /** Название файла */
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Ссылка на файл */
  url: Scalars['String']['output'];
};

export type PlainMlLogDto = {
  __typename?: 'PlainMlLogDto';
  /** ID Карты компетенций */
  competencyMapId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  /** ID Оценки CV */
  cvCheckId?: Maybe<Scalars['ID']['output']>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Тип лога */
  event: Ml_Log_Event;
  id: Scalars['ID']['output'];
  /** Дата первого лога по запросу */
  originalCreatedAt: Scalars['Date']['output'];
  /** Данные запроса */
  requestData?: Maybe<Scalars['JSON']['output']>;
  /** Id запроса */
  requestId: Scalars['ID']['output'];
  /** Данные ответа */
  responseData?: Maybe<Scalars['JSON']['output']>;
  /** ID топика */
  skillId?: Maybe<Scalars['ID']['output']>;
  /** Статус лога */
  status: Ml_Log_Status;
  /** ID Ответа */
  trialAnswerId?: Maybe<Scalars['ID']['output']>;
  /** ID Карты компетенций */
  trialId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export enum PlatformCompanyCandidateListOrderFields {
  CandidateUsernameCandidateLanguage = 'candidateUsername_candidate_language',
  CandidateUsernameCandidatePhoneNumber = 'candidateUsername_candidate_phoneNumber',
  CandidateUsernameLogin = 'candidateUsername_login',
  CandidateUsernameTelegramUsername = 'candidateUsername_telegramUsername',
  CreatedAt = 'createdAt',
  Email = 'email',
  FullName = 'fullName',
  Grade = 'grade',
  NumericId = 'numericId',
  Organization = 'organization',
  Position = 'position',
  Type = 'type'
}

export type PlatformCompanyCandidateListOrderInput = {
  /** Поле сортировки */
  field: PlatformCompanyCandidateListOrderFields;
  /** Порядок сортировка */
  order: OrderType;
};

export enum PlatformCompetencyMapListOrderFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsRepositoryCheck = 'isRepositoryCheck',
  NumericId = 'numericId',
  Specialization = 'specialization',
  Status = 'status',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type PlatformCompetencyMapListOrderInput = {
  /** Поле сортировки */
  field: PlatformCompetencyMapListOrderFields;
  /** Порядок сортировка */
  order: OrderType;
};

export enum PlatformExaminationListOrderFields {
  CompetencyMapIsRepositoryCheck = 'competencyMap_isRepositoryCheck',
  CompetencyMapSpecialization = 'competencyMap_specialization',
  CompetencyMapTitle = 'competencyMap_title',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  NumericId = 'numericId',
  Title = 'title',
  Type = 'type'
}

export type PlatformExaminationListOrderInput = {
  /** Поле сортировки */
  field: PlatformExaminationListOrderFields;
  /** Порядок сортировка */
  order: OrderType;
};

export enum PlatformTrialListOrderFields {
  CompanyCandidateFullName = 'companyCandidate_fullName',
  CompanyCandidateNumericId = 'companyCandidate_numericId',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  Id = 'id',
  Status = 'status'
}

export type PlatformTrialListOrderInput = {
  /** Поле сортировки */
  field: PlatformTrialListOrderFields;
  /** Порядок сортировка */
  order: OrderType;
};

export enum PlatformVacancyCompanyCandidateListOrderFields {
  CompanyCandidateCandidateUsernameCandidateLanguage = 'companyCandidate_candidateUsername_candidate_language',
  CompanyCandidateCandidateUsernameCandidatePhoneNumber = 'companyCandidate_candidateUsername_candidate_phoneNumber',
  CompanyCandidateCandidateUsernameLogin = 'companyCandidate_candidateUsername_login',
  CompanyCandidateCandidateUsernameTelegramUsername = 'companyCandidate_candidateUsername_telegramUsername',
  CompanyCandidateCreatedAt = 'companyCandidate_createdAt',
  CompanyCandidateCvFileId = 'companyCandidate_cvFileId',
  CompanyCandidateFullName = 'companyCandidate_fullName',
  CompanyCandidateNumericId = 'companyCandidate_numericId',
  CvChecksScore = 'cvChecks_score'
}

export type PlatformVacancyCompanyCandidateListOrderInput = {
  /** Поле сортировки */
  field: PlatformVacancyCompanyCandidateListOrderFields;
  /** Порядок сортировка */
  order: OrderType;
};

export enum PlatformVacancyListOrderFields {
  CreatedAt = 'createdAt',
  NumericId = 'numericId',
  Title = 'title'
}

export type PlatformVacancyListOrderInput = {
  /** Поле сортировки */
  field: PlatformVacancyListOrderFields;
  /** Порядок сортировка */
  order: OrderType;
};

export enum Question_Type {
  MultipleChoiceQuestions = 'multiple_choice_questions',
  Practical = 'practical',
  Theoretical = 'theoretical'
}

export type Query = {
  __typename?: 'Query';
  /** Компания по Id */
  company?: Maybe<Company>;
  /** Кандидат компании по Id */
  companyCandidate?: Maybe<CompanyCandidate>;
  /** Список кандидатов компании */
  companyCandidates: PaginatedCompanyCandidate;
  /** Карта компетенций по ID */
  competencyMap?: Maybe<CompetencyMap>;
  /** Последние логи по генерации вопросов для карты компетенций */
  competencyMapGenQuestionsLog: Array<PlainMlLogDto>;
  /** Список карт компетенций */
  competencyMaps: PaginatedCompetencyMap;
  /** Тестирование c типом */
  examination: Examination;
  /** Получение списка тестирований */
  examinations: PaginatedExamination;
  /** Список професий компании */
  getUniqProfession: Array<Scalars['String']['output']>;
  /** Блок знаний по Id */
  knowledgeBlock?: Maybe<KnowledgeBlock>;
  /** Специализации блока знаний */
  knowledgeBlockSpecializations: Array<Scalars['String']['output']>;
  /** Список блоков знаний */
  knowledgeBlocks: PaginatedKnowledgeBlock;
  /** Текущий пользователь */
  me: User;
  /** Вопрос */
  question: Question;
  /** Подтипы для типа вопроса */
  questionSubtypes: Array<GetQuestionSubTypeResult>;
  /** Топик по Id */
  skill?: Maybe<Skill>;
  /** Последние логи по генерации вопросов для навыка */
  skillGenQuestionsLog: Array<PlainMlLogDto>;
  /** Список топиков */
  skills: PaginatedSkill;
  /** Тестирование по ID */
  trial?: Maybe<Trial>;
  /** Список тестирований */
  trials: PaginatedTrial;
  /** Компании пользователя */
  userCompanies?: Maybe<Array<Company>>;
  /** Список вакансий компании */
  vacancies: PaginatedVacancy;
  /** Вакансия компании по Id */
  vacancy?: Maybe<Vacancy>;
  /** Кандидат вакансии по Id */
  vacancyCompanyCandidate?: Maybe<VacancyCompanyCandidate>;
  /** Список кандидатов вакансии */
  vacancyCompanyCandidates: PaginatedVacancyCompanyCandidate;
};


export type QueryCompanyCandidateArgs = {
  companyCandidateId: Scalars['ID']['input'];
};


export type QueryCompanyCandidatesArgs = {
  filter?: InputMaybe<ListCompanyCandidateFilterInput>;
  limit: Scalars['Float']['input'];
  order: PlatformCompanyCandidateListOrderInput;
  page: Scalars['Float']['input'];
};


export type QueryCompetencyMapArgs = {
  competencyMapId: Scalars['ID']['input'];
};


export type QueryCompetencyMapGenQuestionsLogArgs = {
  competencyMapId: Scalars['ID']['input'];
};


export type QueryCompetencyMapsArgs = {
  filter?: InputMaybe<ListCompetencyMapFilterInput>;
  limit: Scalars['Float']['input'];
  order: PlatformCompetencyMapListOrderInput;
  page: Scalars['Float']['input'];
};


export type QueryExaminationArgs = {
  examinationId: Scalars['ID']['input'];
};


export type QueryExaminationsArgs = {
  filter?: InputMaybe<ListExaminationFilterInput>;
  limit: Scalars['Float']['input'];
  order: PlatformExaminationListOrderInput;
  page: Scalars['Float']['input'];
};


export type QueryGetUniqProfessionArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKnowledgeBlockArgs = {
  knowledgeBlockId: Scalars['ID']['input'];
};


export type QueryKnowledgeBlocksArgs = {
  filter?: InputMaybe<ListKnowledgeBlockFilterInput>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
};


export type QueryQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuestionSubtypesArgs = {
  questionType: Array<Question_Type>;
};


export type QuerySkillArgs = {
  skillId: Scalars['ID']['input'];
};


export type QuerySkillGenQuestionsLogArgs = {
  skillId: Scalars['ID']['input'];
};


export type QuerySkillsArgs = {
  filter: ListSkillFilterInput;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
};


export type QueryTrialArgs = {
  trialId: Scalars['ID']['input'];
};


export type QueryTrialsArgs = {
  filter?: InputMaybe<ListTrialFilterInput>;
  limit: Scalars['Float']['input'];
  order: PlatformTrialListOrderInput;
  page: Scalars['Float']['input'];
};


export type QueryVacanciesArgs = {
  filter?: InputMaybe<ListVacancyFilterInput>;
  limit: Scalars['Float']['input'];
  order: PlatformVacancyListOrderInput;
  page: Scalars['Float']['input'];
};


export type QueryVacancyArgs = {
  vacancyId: Scalars['ID']['input'];
};


export type QueryVacancyCompanyCandidateArgs = {
  vacancyCompanyCandidateId: Scalars['ID']['input'];
};


export type QueryVacancyCompanyCandidatesArgs = {
  filter?: InputMaybe<ListVacancyCompanyCandidateFilterInput>;
  limit: Scalars['Float']['input'];
  order: PlatformVacancyCompanyCandidateListOrderInput;
  page: Scalars['Float']['input'];
};

export type Question = {
  __typename?: 'Question';
  /** Логи генерации */
  MlLogs?: Maybe<Array<MlLog>>;
  /** Ответы кандидата по тестированию */
  answers?: Maybe<Array<TrialAnswer>>;
  /** Подтверждён ли вопрос */
  confirmation: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  /** Критерии вопроса */
  criterion: Array<Scalars['String']['output']>;
  /** Грейд вопроса */
  grade: Grade;
  id: Scalars['ID']['output'];
  /** Флаг удаления */
  isDeleted: Scalars['Boolean']['output'];
  /** Язык вопроса */
  language: Language;
  /** Микрокритерии вопроса */
  microCriterion?: Maybe<Array<Scalars['String']['output']>>;
  /** Элементы вопроса */
  parts?: Maybe<Array<QuestionPart>>;
  /** Рекомендуемое количество секунд отведённых на вопрос */
  recommendedTime?: Maybe<Scalars['Float']['output']>;
  /** Эталонный ответ на вопрос */
  referenceAnswer?: Maybe<Scalars['String']['output']>;
  /** Навык */
  skill: Skill;
  /** ID топика */
  skillId: Scalars['ID']['output'];
  /** Подтип вопроса */
  subtype?: Maybe<Scalars['String']['output']>;
  /** Текст вопроса */
  text: Scalars['String']['output'];
  /** Количество секунд отведённых на вопрос */
  time: Scalars['Float']['output'];
  /** Тип вопроса */
  type: Question_Type;
  updatedAt: Scalars['Date']['output'];
};

export type QuestionAWebDto = {
  __typename?: 'QuestionAWebDto';
  /** Подтверждён ли вопрос */
  confirmation: Scalars['Boolean']['output'];
  /** Критерии вопроса */
  criterion: Array<Scalars['String']['output']>;
  /** Грейд вопроса */
  grade: Grade;
  id: Scalars['ID']['output'];
  /** Язык вопроса */
  language: Language;
  /** Элементы вопроса */
  parts?: Maybe<Array<QuestionPartAWebDto>>;
  /** Рекомендуемое количество секунд отведённых на вопрос */
  recommendedTime?: Maybe<Scalars['Float']['output']>;
  /** Топик */
  skill: SkillAWebDto;
  /** ID топика */
  skillId: Scalars['ID']['output'];
  /** Текст вопроса */
  text: Scalars['String']['output'];
  /** Количество секунд отведённых на вопрос */
  time: Scalars['Float']['output'];
  /** Тип вопроса */
  type: Question_Type;
};

export type QuestionPart = {
  __typename?: 'QuestionPart';
  /** Содержание элемента вопроса */
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Является ли ответ верным */
  isCorrect: Scalars['Boolean']['output'];
  /** Порядок элемента */
  order: Scalars['Float']['output'];
  /** Вопрос */
  question: Question;
  /** ID топика */
  questionId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type QuestionPartAWebDto = {
  __typename?: 'QuestionPartAWebDto';
  /** Содержание элемента вопроса */
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Порядок элемента */
  order: Scalars['Float']['output'];
  /** ID топика */
  questionId: Scalars['ID']['output'];
};

export type RegenerateQuestionDataInput = {
  /** Коментарий пользователя для генерации ответа */
  answerComment?: InputMaybe<Scalars['String']['input']>;
  /** Коментарий пользователя для генерации критериев */
  criteriaComment?: InputMaybe<Scalars['String']['input']>;
  /** Критерии вопроса */
  criterion?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Грейд вопроса */
  grade: Grade;
  /** Язык вопроса */
  language: Language;
  /** Коментарий пользователя для генерации вопроса */
  questionComment?: InputMaybe<Scalars['String']['input']>;
  /** Эталонный ответ на вопрос */
  referenceAnswer?: InputMaybe<Scalars['String']['input']>;
  /** Id навыка */
  skillId: Scalars['ID']['input'];
  /** Текст вопроса */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Количество секунд отведённых на вопрос */
  time: Scalars['Float']['input'];
  /** Перегенерировать ли критерии вопроса */
  updateCriteria: Scalars['Boolean']['input'];
  /** Перегенерировать ли текст вопроса */
  updateQuestion: Scalars['Boolean']['input'];
  /** Перегенерировать ли эталонный ответ вопроса */
  updateReferenceAnswer: Scalars['Boolean']['input'];
};

export type RegenerateQuestionDataResultDto = {
  __typename?: 'RegenerateQuestionDataResultDto';
  /** Критерии вопроса */
  criterion?: Maybe<Array<Scalars['String']['output']>>;
  /** Эталонный ответ на вопрос */
  referenceAnswer?: Maybe<Scalars['String']['output']>;
  /** Текст вопроса */
  text?: Maybe<Scalars['String']['output']>;
};

export type RegenerateQuestionInput = {
  /** Коментарий пользователя для генерации ответа */
  answerComment?: InputMaybe<Scalars['String']['input']>;
  /** Коментарий пользователя для генерации критериев */
  criteriaComment?: InputMaybe<Scalars['String']['input']>;
  /** Коментарий пользователя для генерации вопроса */
  questionComment?: InputMaybe<Scalars['String']['input']>;
  /** Id вопроса */
  questionId: Scalars['ID']['input'];
  /** Перегенерировать ли критерии вопроса */
  updateCriteria: Scalars['Boolean']['input'];
  /** Перегенерировать ли текст вопроса */
  updateQuestion: Scalars['Boolean']['input'];
  /** Перегенерировать ли эталонный ответ вопроса */
  updateReferenceAnswer: Scalars['Boolean']['input'];
};

export type Skill = {
  __typename?: 'Skill';
  /** Логи генерации вопросов */
  MlLogs?: Maybe<Array<MlLog>>;
  /** Количество подтвержденных вопросов */
  confirmedQuestionsCount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Грейды топика */
  grades?: Maybe<Array<Grade>>;
  id: Scalars['ID']['output'];
  /** Флаг удаления */
  isDeleted: Scalars['Boolean']['output'];
  /** Блоки знаний */
  knowledgeBlock: KnowledgeBlock;
  /** ID Блока знаний */
  knowledgeBlockId: Scalars['ID']['output'];
  /** Количество не подтвержденных вопросов */
  notConfirmedQuestionsCount?: Maybe<Scalars['Float']['output']>;
  /** Порядок топика в компетенции */
  order: Scalars['Int']['output'];
  /** Вопросы навыка */
  questions?: Maybe<Array<Question>>;
  /** Название топика */
  title: Scalars['String']['output'];
  /** Ответ по тестированию для топика */
  trialAnswer?: Maybe<TrialAnswer>;
  updatedAt: Scalars['Date']['output'];
};


export type SkillTrialAnswerArgs = {
  trialId: Scalars['ID']['input'];
};

export type SkillAWebDto = {
  __typename?: 'SkillAWebDto';
  id: Scalars['ID']['output'];
  /** Блок знаний */
  knowledgeBlock: KnowledgeBlockAWebDto;
  /** ID Блока знаний */
  knowledgeBlockId: Scalars['ID']['output'];
  /** Порядок топика в компетенции */
  order: Scalars['Int']['output'];
  /** Название топика */
  title: Scalars['String']['output'];
};

export enum Trial_File_Type {
  CandidateReport = 'CANDIDATE_REPORT',
  RecruiterReport = 'RECRUITER_REPORT'
}

export enum Trial_Question_Status {
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
  Started = 'STARTED'
}

export enum Trial_Status {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Received = 'RECEIVED',
  Started = 'STARTED',
  Suspended = 'SUSPENDED'
}

export enum Type_Of_Organization {
  Individual = 'INDIVIDUAL',
  Legal = 'LEGAL'
}

export type Trial = {
  __typename?: 'Trial';
  /** Логи генерации */
  MlLogs?: Maybe<Array<MlLog>>;
  /** ID чата с ботом в telegram */
  botChatId?: Maybe<Scalars['Float']['output']>;
  /** Результат кандидата по тестированию */
  candidateScore?: Maybe<Scalars['Float']['output']>;
  /** Время затраченное на прохождение тестирования кандидатом */
  candidateTime?: Maybe<Scalars['Float']['output']>;
  /** Комментарий к тестированию */
  comment?: Maybe<Scalars['String']['output']>;
  /** Кандидат компании */
  companyCandidate: CompanyCandidate;
  /** ID Кандидата компании */
  companyCandidateId: Scalars['ID']['output'];
  /** Результаты кандидата по каждой компетенции */
  competencesScore?: Maybe<Array<CompetenceScoreType>>;
  /** Дата завершения тестирования */
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Тип тестирования */
  examination: Examination;
  /** Id типа тестирования */
  examinationId: Scalars['ID']['output'];
  /** Грейды тестирования */
  grades?: Maybe<Array<Grade>>;
  id: Scalars['ID']['output'];
  /** Завершено ли тестирование */
  isAssessmentComplete: Scalars['Boolean']['output'];
  /** Числовой id тестирования */
  numericId: Scalars['Float']['output'];
  /** Список вопросов */
  questionList?: Maybe<Array<TrialQuestionListElement>>;
  /** Генерировать вопросы картинкой */
  questionsAsImage: Scalars['Boolean']['output'];
  /** Отчет рекрутера */
  recruiterReportFiles?: Maybe<Array<TrialFile>>;
  /** Данные для отчёта от мл */
  reportData?: Maybe<TrialReportData>;
  /** Статус тестирования */
  status: Trial_Status;
  /** Ответы кандидата по тестированию */
  trialAnswers?: Maybe<Array<TrialAnswer>>;
  /** Отчеты по тестированию */
  trialFiles?: Maybe<Array<TrialFile>>;
  /** Результаты проверки репозитория */
  trialRepositoryChecks: Array<TrialRepositoryCheck>;
  /** История статусов тестирования */
  trialStatusHistory?: Maybe<Array<TrialStatusHistory>>;
  updatedAt: Scalars['Date']['output'];
};

export type TrialAWebDto = {
  __typename?: 'TrialAWebDto';
  /** Комментарий к тестированию */
  comment?: Maybe<Scalars['String']['output']>;
  /** Кандидат */
  companyCandidate: CompanyCandidateAWebDto;
  /** ID Кандидата компании */
  companyCandidateId: Scalars['ID']['output'];
  /** Дата завершения тестирования */
  completedAt?: Maybe<Scalars['Date']['output']>;
  /** Карта компетенций */
  examination: ExaminationAWebDto;
  /** Id типа тестирования */
  examinationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Числовой id тестирования */
  numericId: Scalars['Float']['output'];
  /** Список вопросов */
  questionList?: Maybe<Array<TrialQuestionListElement>>;
  /** Генерировать вопросы картинкой */
  questionsAsImage: Scalars['Boolean']['output'];
  /** Статус тестирования */
  status: Trial_Status;
  /** Ответы */
  trialAnswers?: Maybe<Array<TrialAnswerAWebDto>>;
  /** Результаты проверки репозитория */
  trialRepositoryChecks: Array<TrialRepositoryCheckAWebDto>;
};

export type TrialAnswer = {
  __typename?: 'TrialAnswer';
  /** Логи оценки ответа */
  MlLogs?: Maybe<Array<MlLog>>;
  /** Ответ на вопрос */
  answer?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Вердикт ответа */
  criterionAssessments?: Maybe<Array<CriterionAssessment>>;
  /** Файл голосового ответа */
  file?: Maybe<File>;
  /** ID файла голосового ответа */
  fileId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Пропущен ли вопрос */
  isSkipped: Scalars['Boolean']['output'];
  /** Дополнительные данные об ответе */
  metadata?: Maybe<TrialAnswerMetadata>;
  /** Вердикт микрокритерия */
  microcriterionAssessments?: Maybe<Array<CriterionAssessment>>;
  /** Оценка микрокритерия */
  microcriterionScore?: Maybe<Scalars['Float']['output']>;
  /** Ответ на вопрос с вариантами ответа */
  partsIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Вопрос */
  question: Question;
  /** ID вопроса */
  questionId: Scalars['ID']['output'];
  /** Оценка ответа */
  score?: Maybe<Scalars['Float']['output']>;
  /** Количество секунд затраченных на ответ */
  time: Scalars['Float']['output'];
  /** Тестирование */
  trial: Trial;
  /** ID Тестирования */
  trialId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type TrialAnswerAWebDto = {
  __typename?: 'TrialAnswerAWebDto';
  /** Ответ на вопрос */
  answer?: Maybe<Scalars['String']['output']>;
  /** Вердикт ответа */
  criterionAssessments?: Maybe<Array<CriterionAssessment>>;
  /** Файл аудио ответа */
  file?: Maybe<FileAWebDto>;
  /** ID файла голосового ответа */
  fileId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Вердикт микрокритерия */
  microcriterionAssessments?: Maybe<Array<CriterionAssessment>>;
  /** Оценка микрокритерия */
  microcriterionScore?: Maybe<Scalars['Float']['output']>;
  /** Ответ на вопрос с вариантами ответа */
  partsIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Вопрос */
  question: QuestionAWebDto;
  /** ID вопроса */
  questionId: Scalars['ID']['output'];
  /** Оценка ответа */
  score?: Maybe<Scalars['Float']['output']>;
  /** Количество секунд затраченных на ответ */
  time: Scalars['Float']['output'];
  /** Тестирование */
  trial: TrialAWebDto;
  /** ID Тестирования */
  trialId: Scalars['ID']['output'];
};

export type TrialAnswerMetadata = {
  __typename?: 'TrialAnswerMetadata';
  insertCount?: Maybe<Scalars['Float']['output']>;
  insertSymbols?: Maybe<Scalars['Float']['output']>;
};

export type TrialFile = {
  __typename?: 'TrialFile';
  createdAt: Scalars['Date']['output'];
  /** Данные файла */
  file: File;
  /** ID файла */
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Тестирование */
  trial: Trial;
  /** ID тестирования */
  trialId: Scalars['ID']['output'];
  /** Тип отчета */
  type: Trial_File_Type;
  updatedAt: Scalars['Date']['output'];
};

export type TrialQuestionListElement = {
  __typename?: 'TrialQuestionListElement';
  /** Количество секунд затраченных кандидатом */
  candidateTime?: Maybe<Scalars['Float']['output']>;
  /** Порядковый номер в тестировании */
  order: Scalars['Float']['output'];
  /** Id вопроса */
  questionId: Scalars['ID']['output'];
  /** Статус вопроса */
  status: Trial_Question_Status;
  /** Количество секунд отведённых на вопрос */
  time: Scalars['Float']['output'];
};

export type TrialReportData = {
  __typename?: 'TrialReportData';
  ai_generation_competencies?: Maybe<Array<Scalars['String']['output']>>;
  ai_generation_percentage?: Maybe<Scalars['Float']['output']>;
  competencies?: Maybe<Scalars['JSON']['output']>;
  development_recommendations?: Maybe<Array<Scalars['String']['output']>>;
  employee_comment?: Maybe<Scalars['String']['output']>;
  general_summary?: Maybe<Array<Scalars['String']['output']>>;
  hr_comment?: Maybe<Scalars['String']['output']>;
};

export type TrialRepositoryCheck = {
  __typename?: 'TrialRepositoryCheck';
  /** Балл за алгоритмы */
  algorithmsScore?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Ошибка API проверки репозитория */
  error?: Maybe<Scalars['JSON']['output']>;
  /** Факты о репозитории */
  facts?: Maybe<TrialRepositoryFacts>;
  id: Scalars['ID']['output'];
  /** Балл за поддерживаемость */
  maintainabilityScore?: Maybe<Scalars['Float']['output']>;
  /** Основной язык репозитория */
  programingLanguage?: Maybe<Scalars['String']['output']>;
  /** Балл за читаемость */
  readabilityScore?: Maybe<Scalars['Float']['output']>;
  /** Ссылка на репозиторий */
  repoUrl?: Maybe<Scalars['String']['output']>;
  /** ID в API проверки репозитория */
  taskId?: Maybe<Scalars['ID']['output']>;
  /** Общий балл */
  totalScore?: Maybe<Scalars['Float']['output']>;
  /** Тестирование */
  trial: Trial;
  /** ID Тестирования */
  trialId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type TrialRepositoryCheckAWebDto = {
  __typename?: 'TrialRepositoryCheckAWebDto';
  /** Балл за алгоритмы */
  algorithmsScore?: Maybe<Scalars['Float']['output']>;
  /** Ошибка API проверки репозитория */
  error?: Maybe<Scalars['JSON']['output']>;
  /** Факты о репозитории */
  facts?: Maybe<TrialRepositoryFacts>;
  /** Балл за поддерживаемость */
  maintainabilityScore?: Maybe<Scalars['Float']['output']>;
  /** Основной язык репозитория */
  programingLanguage?: Maybe<Scalars['String']['output']>;
  /** Балл за читаемость */
  readabilityScore?: Maybe<Scalars['Float']['output']>;
  /** Ссылка на репозиторий */
  repoUrl?: Maybe<Scalars['String']['output']>;
  /** Общий балл */
  totalScore?: Maybe<Scalars['Float']['output']>;
  /** Тестирование */
  trial: TrialAWebDto;
  /** ID Тестирования */
  trialId: Scalars['ID']['output'];
};

export type TrialRepositoryFacts = {
  __typename?: 'TrialRepositoryFacts';
  developers_count?: Maybe<Scalars['Float']['output']>;
  first_release_date?: Maybe<Scalars['Date']['output']>;
  forks_count?: Maybe<Scalars['Float']['output']>;
  is_scoring_available?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Scalars['JSON']['output']>;
  main_language?: Maybe<Scalars['String']['output']>;
  repo_url?: Maybe<Scalars['String']['output']>;
  stars_count?: Maybe<Scalars['Float']['output']>;
};

export type TrialStatusHistory = {
  __typename?: 'TrialStatusHistory';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Новый статус тестирования */
  newStatus: Trial_Status;
  /** Тестирование */
  trial: Trial;
  /** ID Тестирования */
  trialId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type UpdateCompetencyMapStatusInput = {
  /** Id карты компетенции */
  id: Scalars['ID']['input'];
  /** Статус карты компетенций */
  status: Competency_Map_Status;
};

export type UpdateTrialInput = {
  /** Комментарий к тестированию */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Id кандидата компании */
  companyCandidateId?: InputMaybe<Scalars['ID']['input']>;
  /** Id карты компетенции */
  competencyMapId?: InputMaybe<Scalars['ID']['input']>;
  /** Id тестирования */
  id: Scalars['ID']['input'];
  /** Название тестирования */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserDataInput = {
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Имя */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Отчество */
  middleName?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  /** Соглашение на обработку персональных данных */
  agreement: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  /** Имя пользователя */
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Является ли пользователь админом */
  isAdmin: Scalars['Boolean']['output'];
  /** Заблокирован ли пользователь */
  isBlocked: Scalars['Boolean']['output'];
  /** Фамилия пользователя */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Отчество пользователя */
  middleName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  /** Eмail пользователя */
  userEmail: UserEmail;
  /** ID email пользователя */
  userEmailId: Scalars['ID']['output'];
};

export type UserEmail = {
  __typename?: 'UserEmail';
  /** Пользователи компании */
  companyUsers?: Maybe<Array<CompanyUser>>;
  createdAt: Scalars['Date']['output'];
  /** Email пользователя */
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Пользователь */
  user: User;
};

export type Vacancy = {
  __typename?: 'Vacancy';
  /** Компания */
  company: Company;
  /** Количество кандидатов на вакансии */
  companyCandidatesCount: Scalars['Float']['output'];
  /** Id компании */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  /** Описание вакансии */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Численный id в рамках компании */
  numericId: Scalars['Float']['output'];
  /** Название вакансии */
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Оценки CV кандидатов */
  vacancyCompanyCandidates?: Maybe<Array<VacancyCompanyCandidate>>;
};

export type VacancyCompanyCandidate = {
  __typename?: 'VacancyCompanyCandidate';
  /** Кандидат компании */
  companyCandidate: CompanyCandidate;
  /** Id кандидата компании */
  companyCandidateId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  /** Оценка текущего CV */
  currentCvCheck?: Maybe<CvCheck>;
  /** История проверок CV кандидатов */
  cvChecks?: Maybe<Array<CvCheck>>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Вакансия */
  vacancy: Vacancy;
  /** Id вакансии */
  vacancyId: Scalars['ID']['output'];
};

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'AuthTokensDto', accessToken: string, refreshToken: string } };

export type LoginByCredentialsMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginByCredentialsMutation = { __typename?: 'Mutation', loginByCredentials: { __typename?: 'AuthTokensDto', accessToken: string, refreshToken: string } };

export type CreateOrUpdateCompanyCandidateMutationVariables = Exact<{
  input: CreateOrUpdateCompanyCandidateInput;
}>;


export type CreateOrUpdateCompanyCandidateMutation = { __typename?: 'Mutation', createOrUpdateCompanyCandidate: { __typename?: 'CompanyCandidate', id: string, fullName: string, email?: string | null, organization?: string | null, position?: string | null, grade?: Grade | null, candidateUsername?: { __typename?: 'CandidateUsername', id: string, telegramUsername?: string | null, login?: string | null, candidate?: { __typename?: 'Candidate', id: string, phoneNumber?: string | null } | null } | null } };

export type CreateOrUpdateCompanyCandidateLoginMutationVariables = Exact<{
  input: CreateOrUpdateCompanyCandidateLoginInput;
}>;


export type CreateOrUpdateCompanyCandidateLoginMutation = { __typename?: 'Mutation', createOrUpdateCompanyCandidateLogin: { __typename?: 'CompanyCandidate', id: string, fullName: string, email?: string | null, organization?: string | null, position?: string | null, grade?: Grade | null, candidateUsername?: { __typename?: 'CandidateUsername', id: string, telegramUsername?: string | null, login?: string | null, candidate?: { __typename?: 'Candidate', id: string, phoneNumber?: string | null } | null } | null } };

export type CandidateHeaderQueryVariables = Exact<{
  candidateId: Scalars['ID']['input'];
}>;


export type CandidateHeaderQuery = { __typename?: 'Query', companyCandidate?: { __typename?: 'CompanyCandidate', id: string, numericId: number, fullName: string } | null };

export type CandidateInfoQueryVariables = Exact<{
  candidateId: Scalars['ID']['input'];
}>;


export type CandidateInfoQuery = { __typename?: 'Query', companyCandidate?: { __typename?: 'CompanyCandidate', id: string, fullName: string, email?: string | null, grade?: Grade | null, organization?: string | null, position?: string | null, type: Company_Candidate_Type, link?: string | null, candidateUsername?: { __typename?: 'CandidateUsername', id: string, telegramUsername?: string | null, login?: string | null, candidate?: { __typename?: 'Candidate', id: string, phoneNumber?: string | null } | null } | null, cvFile?: { __typename?: 'File', id: string, name: string, url: string } | null } | null };

export type CandidateVacanciesQueryVariables = Exact<{
  candidateId: Scalars['ID']['input'];
}>;


export type CandidateVacanciesQuery = { __typename?: 'Query', companyCandidate?: { __typename?: 'CompanyCandidate', id: string, vacancyCompanyCandidates?: Array<{ __typename?: 'VacancyCompanyCandidate', id: string, vacancy: { __typename?: 'Vacancy', id: string, title: string }, currentCvCheck?: { __typename?: 'CvCheck', id: string, score?: number | null, reportFile?: { __typename?: 'File', id: string, url: string } | null } | null }> | null } | null };

export type CompanyCandidateListQueryVariables = Exact<{
  filter?: InputMaybe<ListCompanyCandidateFilterInput>;
  limit: Scalars['Float']['input'];
  order?: PlatformCompanyCandidateListOrderInput;
  page: Scalars['Float']['input'];
}>;


export type CompanyCandidateListQuery = { __typename?: 'Query', companyCandidates: { __typename?: 'PaginatedCompanyCandidate', totalCount: number, data?: Array<{ __typename?: 'CompanyCandidate', id: string, numericId: number, fullName: string, createdAt: any, organization?: string | null, position?: string | null, type: Company_Candidate_Type, grade?: Grade | null, email?: string | null, link?: string | null, lastTrialDate?: any | null, trialsCount?: number | null, averageTrialsScore?: number | null, lastTrialScore?: number | null, lastTrialStatus?: Trial_Status | null, lastTrialTime?: number | null, candidateUsername?: { __typename?: 'CandidateUsername', id: string, telegramUsername?: string | null, login?: string | null, candidate?: { __typename?: 'Candidate', id: string, phoneNumber?: string | null, language?: Language | null } | null } | null, trials?: Array<{ __typename?: 'Trial', id: string, completedAt?: any | null, examination: { __typename?: 'Examination', id: string, title: string, numericId: number } }> | null, lastTrialRecruiterReportFiles?: Array<{ __typename?: 'TrialFile', id: string, file: { __typename?: 'File', id: string, url: string } }> | null }> | null } };

export type CompanyCandidateOptionListQueryVariables = Exact<{
  filter?: InputMaybe<ListCompanyCandidateFilterInput>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  order?: PlatformCompanyCandidateListOrderInput;
}>;


export type CompanyCandidateOptionListQuery = { __typename?: 'Query', companyCandidates: { __typename?: 'PaginatedCompanyCandidate', totalCount: number, data?: Array<{ __typename?: 'CompanyCandidate', id: string, fullName: string, createdAt: any, numericId: number, candidateUsername?: { __typename?: 'CandidateUsername', id: string, telegramUsername?: string | null, login?: string | null, candidate?: { __typename?: 'Candidate', id: string, phoneNumber?: string | null } | null, companyCandidate?: Array<{ __typename?: 'CompanyCandidate', id: string, companyId: string, email?: string | null, organization?: string | null, position?: string | null, grade?: Grade | null }> | null } | null }> | null } };

export type CreateOrUpdateCompanyMutationVariables = Exact<{
  input: CreateOrUpdateCompanyInput;
}>;


export type CreateOrUpdateCompanyMutation = { __typename?: 'Mutation', createOrUpdateCompany: { __typename?: 'Company', id: string, inn: string, shortName: string, fullName: string, kpp: string, ogrn: string, ogrnDate: number, type: Type_Of_Organization, managerFio: string, managerPosition: string, okpo: string, okato: string, oktmo: string, registrationAddress: string, registrationDate: number, status: Company_Status, state: Organization_State, currentUserPosition?: string | null } };

export type CompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, identification: string, inn: string, shortName: string, fullName: string, contractNumber?: string | null, kpp: string, ogrn: string, ogrnDate: number, type: Type_Of_Organization, managerFio: string, managerPosition: string, okpo: string, okato: string, oktmo: string, registrationAddress: string, registrationDate: number, status: Company_Status, state: Organization_State, currentUserPosition?: string | null } | null };

export type BatchInitGenerateQuestionsMutationVariables = Exact<{
  input: BatchInitGenerateQuestionsInput;
}>;


export type BatchInitGenerateQuestionsMutation = { __typename?: 'Mutation', batchInitGenerateQuestions: boolean };

export type CopyCompetencyMapMutationVariables = Exact<{
  input: CopyCompetenceMapInputDto;
}>;


export type CopyCompetencyMapMutation = { __typename?: 'Mutation', copyCompetencyMap: { __typename?: 'CompetencyMap', id: string } };

export type CreateCompetencyMapFromJsonMutationVariables = Exact<{
  input: CreateCompetencyMapFromFileInput;
}>;


export type CreateCompetencyMapFromJsonMutation = { __typename?: 'Mutation', createCompetencyMapFromJson: { __typename?: 'CompetencyMap', id: string } };

export type CreateCompetencyMapFromXlsxMutationVariables = Exact<{
  input: CompetencyMapFromXlsxInput;
}>;


export type CreateCompetencyMapFromXlsxMutation = { __typename?: 'Mutation', createCompetencyMapFromXlsx: { __typename?: 'CompetencyMap', id: string } };

export type CreateOrUpdateCompetencyMapMutationVariables = Exact<{
  input: CreateOrUpdateCompetencyMapInput;
}>;


export type CreateOrUpdateCompetencyMapMutation = { __typename?: 'Mutation', createOrUpdateCompetencyMap: { __typename?: 'CompetencyMap', id: string, title: string, specialization: string, comment?: string | null, createdAt: any, updatedAt: any, grades?: Array<Grade> | null, useInBot: boolean, isRepositoryCheck: boolean, demoCode?: string | null, status: Competency_Map_Status, competences?: Array<{ __typename?: 'Competence', id: string, title: string, knowledgeBlockCompetences?: Array<{ __typename?: 'KnowledgeBlockCompetence', id: string, knowledgeBlock: { __typename?: 'KnowledgeBlock', id: string, title: string, skills?: Array<{ __typename?: 'Skill', id: string, title: string, confirmedQuestionsCount?: number | null, notConfirmedQuestionsCount?: number | null }> | null } }> | null }> | null } };

export type DeleteCompetencyMapMutationVariables = Exact<{
  competencyMapId: Scalars['ID']['input'];
}>;


export type DeleteCompetencyMapMutation = { __typename?: 'Mutation', deleteCompetencyMap: boolean };

export type GenerateSkeletonOfCompetencyMapByDescriptionMutationVariables = Exact<{
  input: GenerateSkeletonCompetencyMapDescriptionInput;
}>;


export type GenerateSkeletonOfCompetencyMapByDescriptionMutation = { __typename?: 'Mutation', generateSkeletonOfCompetencyMapByDescription: boolean };

export type GenerateSkeletonOfCompetencyMapByVacancyMutationVariables = Exact<{
  input: GenerateSkeletonCompetencyMapVacancyInput;
}>;


export type GenerateSkeletonOfCompetencyMapByVacancyMutation = { __typename?: 'Mutation', generateSkeletonOfCompetencyMapByVacancy: boolean };

export type UpdateCompetencyMapStatusMutationVariables = Exact<{
  input: UpdateCompetencyMapStatusInput;
}>;


export type UpdateCompetencyMapStatusMutation = { __typename?: 'Mutation', updateStatusCompetencyMap: { __typename?: 'CompetencyMap', id: string, status: Competency_Map_Status } };

export type CompetencyMapQueryVariables = Exact<{
  competencyMapId: Scalars['ID']['input'];
}>;


export type CompetencyMapQuery = { __typename?: 'Query', competencyMap?: { __typename?: 'CompetencyMap', id: string, title: string, specialization: string, comment?: string | null, createdAt: any, updatedAt: any, grades?: Array<Grade> | null, useInBot: boolean, demoCode?: string | null, status: Competency_Map_Status, isRepositoryCheck: boolean, questionsTime?: number | null, originalCompetencyMapId?: string | null, trialsInfo: { __typename?: 'CompetencyMapTrialsInfoDto', hasStarted: boolean }, examinations?: Array<{ __typename?: 'Examination', id: string, trials?: Array<{ __typename?: 'Trial', id: string, status: Trial_Status }> | null }> | null, originalCompetencyMap?: { __typename?: 'CompetencyMap', id: string, title: string } | null, competences?: Array<{ __typename?: 'Competence', id: string, title: string, knowledgeBlockCompetences?: Array<{ __typename?: 'KnowledgeBlockCompetence', id: string, knowledgeBlock: { __typename?: 'KnowledgeBlock', id: string, title: string, profession: string, skills?: Array<{ __typename?: 'Skill', id: string, title: string, grades?: Array<Grade> | null, confirmedQuestionsCount?: number | null, notConfirmedQuestionsCount?: number | null, questions?: Array<{ __typename?: 'Question', id: string, confirmation: boolean }> | null }> | null } }> | null }> | null } | null };

export type CompetencyMapGenQuestionsLogQueryVariables = Exact<{
  competencyMapId: Scalars['ID']['input'];
}>;


export type CompetencyMapGenQuestionsLogQuery = { __typename?: 'Query', competencyMapGenQuestionsLog: Array<{ __typename?: 'PlainMlLogDto', id: string, status: Ml_Log_Status, skillId?: string | null, createdAt: any }> };

export type CompetencyMapHeaderQueryVariables = Exact<{
  competencyMapId: Scalars['ID']['input'];
}>;


export type CompetencyMapHeaderQuery = { __typename?: 'Query', competencyMap?: { __typename?: 'CompetencyMap', id: string, title: string } | null };

export type CompetencyMapOptionsQueryVariables = Exact<{
  filter?: InputMaybe<ListCompetencyMapFilterInput>;
  limit?: Scalars['Float']['input'];
  page?: Scalars['Float']['input'];
  order: PlatformCompetencyMapListOrderInput;
}>;


export type CompetencyMapOptionsQuery = { __typename?: 'Query', competencyMaps: { __typename?: 'PaginatedCompetencyMap', totalCount: number, data?: Array<{ __typename?: 'CompetencyMap', id: string, title: string, grades?: Array<Grade> | null, comment?: string | null }> | null } };

export type CompetencyMapQuestionsQueryVariables = Exact<{
  competencyMapId: Scalars['ID']['input'];
}>;


export type CompetencyMapQuestionsQuery = { __typename?: 'Query', competencyMap?: { __typename?: 'CompetencyMap', id: string, questionsTime?: number | null, competences?: Array<{ __typename?: 'Competence', id: string, title: string, knowledgeBlockCompetences?: Array<{ __typename?: 'KnowledgeBlockCompetence', id: string, knowledgeBlock: { __typename?: 'KnowledgeBlock', id: string, title: string, skills?: Array<{ __typename?: 'Skill', id: string, title: string, questions?: Array<{ __typename?: 'Question', id: string, confirmation: boolean, text: string, criterion: Array<string>, time: number, grade: Grade, recommendedTime?: number | null, microCriterion?: Array<string> | null, type: Question_Type, subtype?: string | null, language: Language, referenceAnswer?: string | null, parts?: Array<{ __typename?: 'QuestionPart', id: string, content: string, isCorrect: boolean }> | null }> | null }> | null } }> | null }> | null } | null };

export type CompetencyMapsQueryVariables = Exact<{
  filter?: InputMaybe<ListCompetencyMapFilterInput>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  order: PlatformCompetencyMapListOrderInput;
}>;


export type CompetencyMapsQuery = { __typename?: 'Query', competencyMaps: { __typename?: 'PaginatedCompetencyMap', totalCount: number, data?: Array<{ __typename?: 'CompetencyMap', id: string, numericId: number, title: string, grades?: Array<Grade> | null, competencesCount: number, specialization: string, status: Competency_Map_Status, createdAt: any, updatedAt: any, isRepositoryCheck: boolean, lastTrialDate?: any | null, languages?: Array<Language> | null, trialsInfo: { __typename?: 'CompetencyMapTrialsInfoDto', count: number, hasStarted: boolean } }> | null } };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'PlainFileDto', id: string, url: string } };

export type CreateOrUpdateKnowledgeBlockMutationVariables = Exact<{
  input: CreateOrUpdateKnowledgeBlockInput;
}>;


export type CreateOrUpdateKnowledgeBlockMutation = { __typename?: 'Mutation', createOrUpdateKnowledgeBlock: { __typename?: 'KnowledgeBlock', id: string, title: string, grades?: Array<Grade> | null, createdAt: any, updatedAt: any, profession: string, competenceMaps?: Array<{ __typename?: 'CompetencyMap', id: string, title: string }> | null } };

export type DeleteKnowledgeBlockMutationVariables = Exact<{
  knowledgeBlockId: Scalars['ID']['input'];
}>;


export type DeleteKnowledgeBlockMutation = { __typename?: 'Mutation', deleteKnowledgeBlock: boolean };

export type GetUniqProfessionQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUniqProfessionQuery = { __typename?: 'Query', getUniqProfession: Array<string> };

export type KnowledgeBlockQueryVariables = Exact<{
  knowledgeBlockId: Scalars['ID']['input'];
}>;


export type KnowledgeBlockQuery = { __typename?: 'Query', knowledgeBlock?: { __typename?: 'KnowledgeBlock', id: string, title: string, grades?: Array<Grade> | null, createdAt: any, updatedAt: any, profession: string, competenceMaps?: Array<{ __typename?: 'CompetencyMap', id: string, title: string }> | null } | null };

export type KnowledgeBlockHeaderQueryVariables = Exact<{
  knowledgeBlockId: Scalars['ID']['input'];
}>;


export type KnowledgeBlockHeaderQuery = { __typename?: 'Query', knowledgeBlock?: { __typename?: 'KnowledgeBlock', id: string, title: string } | null };

export type KnowledgeBlockOptionsQueryVariables = Exact<{
  filter?: InputMaybe<ListKnowledgeBlockFilterInput>;
  limit?: Scalars['Float']['input'];
  page?: Scalars['Float']['input'];
}>;


export type KnowledgeBlockOptionsQuery = { __typename?: 'Query', knowledgeBlocks: { __typename?: 'PaginatedKnowledgeBlock', totalCount: number, data?: Array<{ __typename?: 'KnowledgeBlock', id: string, title: string, profession: string, grades?: Array<Grade> | null, skills?: Array<{ __typename?: 'Skill', id: string, title: string, grades?: Array<Grade> | null, confirmedQuestionsCount?: number | null, notConfirmedQuestionsCount?: number | null }> | null }> | null } };

export type KnowledgeBlockOptionsWithSkillsQueryVariables = Exact<{
  filter?: InputMaybe<ListKnowledgeBlockFilterInput>;
  limit?: Scalars['Float']['input'];
  page?: Scalars['Float']['input'];
}>;


export type KnowledgeBlockOptionsWithSkillsQuery = { __typename?: 'Query', knowledgeBlocks: { __typename?: 'PaginatedKnowledgeBlock', totalCount: number, data?: Array<{ __typename?: 'KnowledgeBlock', id: string, title: string, grades?: Array<Grade> | null, profession: string, skills?: Array<{ __typename?: 'Skill', id: string, title: string }> | null }> | null } };

export type KnowledgeBlockSpecializationsQueryVariables = Exact<{ [key: string]: never; }>;


export type KnowledgeBlockSpecializationsQuery = { __typename?: 'Query', knowledgeBlockSpecializations: Array<string> };

export type KnowledgeBlocksQueryVariables = Exact<{
  filter?: InputMaybe<ListKnowledgeBlockFilterInput>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
}>;


export type KnowledgeBlocksQuery = { __typename?: 'Query', knowledgeBlocks: { __typename?: 'PaginatedKnowledgeBlock', totalCount: number, data?: Array<{ __typename?: 'KnowledgeBlock', id: string, title: string, grades?: Array<Grade> | null, createdAt: any, updatedAt: any, skills?: Array<{ __typename?: 'Skill', id: string }> | null }> | null } };

export type ConfirmOrRejectQuestionMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
}>;


export type ConfirmOrRejectQuestionMutation = { __typename?: 'Mutation', confirmOrRejectQuestion: { __typename?: 'Question', id: string, time: number, text: string, criterion: Array<string>, confirmation: boolean, grade: Grade, recommendedTime?: number | null, type: Question_Type, subtype?: string | null } };

export type CreateOrUpdateQuestionMutationVariables = Exact<{
  input: CreateOrUpdateQuestionInput;
}>;


export type CreateOrUpdateQuestionMutation = { __typename?: 'Mutation', createOrUpdateQuestion: { __typename?: 'Question', id: string } };

export type DeleteQuestionMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
}>;


export type DeleteQuestionMutation = { __typename?: 'Mutation', deleteQuestion: boolean };

export type GenerateQuestionsMutationVariables = Exact<{
  input: InitGenerateQuestionsInput;
}>;


export type GenerateQuestionsMutation = { __typename?: 'Mutation', initGenerateQuestions: boolean };

export type RegenerateQuestionMutationVariables = Exact<{
  input: RegenerateQuestionDataInput;
}>;


export type RegenerateQuestionMutation = { __typename?: 'Mutation', regenerateQuestionSync: { __typename?: 'RegenerateQuestionDataResultDto', criterion?: Array<string> | null, referenceAnswer?: string | null, text?: string | null } };

export type QuestionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuestionQuery = { __typename?: 'Query', question: { __typename?: 'Question', id: string, confirmation: boolean, text: string, criterion: Array<string>, time: number, grade: Grade, recommendedTime?: number | null, microCriterion?: Array<string> | null, type: Question_Type, subtype?: string | null, language: Language, referenceAnswer?: string | null, skill: { __typename?: 'Skill', id: string }, parts?: Array<{ __typename?: 'QuestionPart', id: string, content: string, isCorrect: boolean }> | null } };

export type QuestionSubtypesQueryVariables = Exact<{
  questionType: Array<Question_Type> | Question_Type;
}>;


export type QuestionSubtypesQuery = { __typename?: 'Query', questionSubtypes: Array<{ __typename?: 'GetQuestionSubTypeResult', subtypes: Array<string>, type: Question_Type }> };

export type CreateOrUpdateSkillMutationVariables = Exact<{
  input: CreateOrUpdateSkillInput;
}>;


export type CreateOrUpdateSkillMutation = { __typename?: 'Mutation', createOrUpdateSkill: { __typename?: 'Skill', id: string, title: string, grades?: Array<Grade> | null, createdAt: any, updatedAt: any, knowledgeBlock: { __typename?: 'KnowledgeBlock', id: string, title: string, profession: string }, questions?: Array<{ __typename?: 'Question', id: string, confirmation: boolean, text: string, criterion: Array<string>, time: number, microCriterion?: Array<string> | null, type: Question_Type, subtype?: string | null }> | null } };

export type DeleteSkillMutationVariables = Exact<{
  skillId: Scalars['ID']['input'];
}>;


export type DeleteSkillMutation = { __typename?: 'Mutation', deleteSkill: boolean };

export type SkillQueryVariables = Exact<{
  skillId: Scalars['ID']['input'];
}>;


export type SkillQuery = { __typename?: 'Query', skill?: { __typename?: 'Skill', id: string, title: string, grades?: Array<Grade> | null, createdAt: any, updatedAt: any, knowledgeBlock: { __typename?: 'KnowledgeBlock', id: string, title: string, profession: string } } | null };

export type SkillBasicQueryVariables = Exact<{
  skillId: Scalars['ID']['input'];
}>;


export type SkillBasicQuery = { __typename?: 'Query', skill?: { __typename?: 'Skill', id: string, title: string, knowledgeBlock: { __typename?: 'KnowledgeBlock', id: string, title: string } } | null };

export type SkillGenQuestionsLogQueryVariables = Exact<{
  skillId: Scalars['ID']['input'];
}>;


export type SkillGenQuestionsLogQuery = { __typename?: 'Query', skillGenQuestionsLog: Array<{ __typename?: 'PlainMlLogDto', id: string, status: Ml_Log_Status, createdAt: any }> };

export type SkillQuestionsQueryVariables = Exact<{
  skillId: Scalars['ID']['input'];
}>;


export type SkillQuestionsQuery = { __typename?: 'Query', skill?: { __typename?: 'Skill', id: string, questions?: Array<{ __typename?: 'Question', id: string, confirmation: boolean, text: string, criterion: Array<string>, time: number, grade: Grade, recommendedTime?: number | null, microCriterion?: Array<string> | null, type: Question_Type, subtype?: string | null, language: Language, referenceAnswer?: string | null, parts?: Array<{ __typename?: 'QuestionPart', id: string, content: string, isCorrect: boolean }> | null }> | null } | null };

export type SkillsQueryVariables = Exact<{
  filter: ListSkillFilterInput;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
}>;


export type SkillsQuery = { __typename?: 'Query', skills: { __typename?: 'PaginatedSkill', totalCount: number, data?: Array<{ __typename?: 'Skill', id: string, title: string, grades?: Array<Grade> | null, confirmedQuestionsCount?: number | null, createdAt: any, updatedAt: any, knowledgeBlock: { __typename?: 'KnowledgeBlock', id: string, title: string } }> | null } };

export type AddCompanyCandidatesToExaminationMutationVariables = Exact<{
  input: AddCompanyCandidatesToExaminationInput;
}>;


export type AddCompanyCandidatesToExaminationMutation = { __typename?: 'Mutation', addCompanyCandidatesToExamination: Array<{ __typename?: 'Trial', id: string }> };

export type CancelExaminationMutationVariables = Exact<{
  examinationId: Scalars['ID']['input'];
}>;


export type CancelExaminationMutation = { __typename?: 'Mutation', cancelExamination: boolean };

export type CreateExaminationMutationVariables = Exact<{
  input: CreateExaminationInput;
}>;


export type CreateExaminationMutation = { __typename?: 'Mutation', createExamination: { __typename?: 'Examination', id: string, numericId: number, createdAt: any, type: Examination_Type, competencyMap: { __typename?: 'CompetencyMap', id: string, title: string, comment?: string | null, grades?: Array<Grade> | null }, trials?: Array<{ __typename?: 'Trial', id: string }> | null } };

export type UpdatePersonalTrialMutationVariables = Exact<{
  input: UpdateTrialInput;
}>;


export type UpdatePersonalTrialMutation = { __typename?: 'Mutation', updatePersonalTrial: { __typename?: 'Trial', id: string, comment?: string | null, status: Trial_Status, numericId: number, createdAt: any, companyCandidate: { __typename?: 'CompanyCandidate', id: string, fullName: string, email?: string | null, grade?: Grade | null, candidateUsername?: { __typename?: 'CandidateUsername', id: string, telegramUsername?: string | null, candidate?: { __typename?: 'Candidate', id: string, phoneNumber?: string | null } | null } | null }, examination: { __typename?: 'Examination', id: string, competencyMap: { __typename?: 'CompetencyMap', id: string, title: string, comment?: string | null, grades?: Array<Grade> | null } }, trialStatusHistory?: Array<{ __typename?: 'TrialStatusHistory', id: string, newStatus: Trial_Status, createdAt: any }> | null } };

export type GenerateReportFileMutationVariables = Exact<{
  input: GenerateReportFileInput;
}>;


export type GenerateReportFileMutation = { __typename?: 'Mutation', generateReportFile?: { __typename?: 'TrialFile', id: string, trial: { __typename?: 'Trial', id: string, numericId: number, completedAt?: any | null, examination: { __typename?: 'Examination', id: string, numericId: number, title: string, competencyMap: { __typename?: 'CompetencyMap', id: string, title: string } }, companyCandidate: { __typename?: 'CompanyCandidate', id: string, fullName: string } }, file: { __typename?: 'File', id: string, url: string } } | null };

export type CancelTrialMutationVariables = Exact<{
  trialId: Scalars['ID']['input'];
}>;


export type CancelTrialMutation = { __typename?: 'Mutation', cancelTrial: { __typename?: 'Trial', id: string, status: Trial_Status } };

export type ExaminationCompetencyListQueryVariables = Exact<{
  examinationId: Scalars['ID']['input'];
}>;


export type ExaminationCompetencyListQuery = { __typename?: 'Query', examination: { __typename?: 'Examination', id: string, competencyMap: { __typename?: 'CompetencyMap', id: string, competences?: Array<{ __typename?: 'Competence', id: string, title: string, order: number }> | null } } };

export type ExaminationHeaderQueryVariables = Exact<{
  examinationId: Scalars['ID']['input'];
}>;


export type ExaminationHeaderQuery = { __typename?: 'Query', examination: { __typename?: 'Examination', id: string, numericId: number, type: Examination_Type, title: string, isActive: boolean, trials?: Array<{ __typename?: 'Trial', id: string, status: Trial_Status, completedAt?: any | null, companyCandidate: { __typename?: 'CompanyCandidate', id: string, fullName: string } }> | null } };

export type ExaminationInfoQueryVariables = Exact<{
  examinationId: Scalars['ID']['input'];
}>;


export type ExaminationInfoQuery = { __typename?: 'Query', examination: { __typename?: 'Examination', id: string, title: string, createdAt: any, numericId: number, type: Examination_Type, isSendResult: boolean, sendResultType: Trial_File_Type, competencyMap: { __typename?: 'CompetencyMap', id: string, title: string, comment?: string | null, grades?: Array<Grade> | null }, trials?: Array<{ __typename?: 'Trial', id: string, status: Trial_Status, completedAt?: any | null, createdAt: any, comment?: string | null, companyCandidate: { __typename?: 'CompanyCandidate', id: string, fullName: string, email?: string | null, position?: string | null, organization?: string | null, grade?: Grade | null, candidateUsername?: { __typename?: 'CandidateUsername', id: string, telegramUsername?: string | null, login?: string | null, candidate?: { __typename?: 'Candidate', id: string, phoneNumber?: string | null } | null } | null }, trialStatusHistory?: Array<{ __typename?: 'TrialStatusHistory', id: string, newStatus: Trial_Status, createdAt: any }> | null }> | null } };

export type ExaminationListQueryVariables = Exact<{
  filter?: InputMaybe<ListExaminationFilterInput>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  order: PlatformExaminationListOrderInput;
}>;


export type ExaminationListQuery = { __typename?: 'Query', examinations: { __typename?: 'PaginatedExamination', totalCount: number, data?: Array<{ __typename?: 'Examination', id: string, numericId: number, title: string, type: Examination_Type, questionsTime?: number | null, lastCompleteDate?: any | null, createdAt: any, competencyMap: { __typename?: 'CompetencyMap', id: string, title: string, specialization: string, blocksCount: number, competencesCount: number, grades?: Array<Grade> | null, isRepositoryCheck: boolean, competences?: Array<{ __typename?: 'Competence', id: string, knowledgeBlockCompetences?: Array<{ __typename?: 'KnowledgeBlockCompetence', id: string }> | null }> | null }, trials?: Array<{ __typename?: 'Trial', id: string, candidateTime?: number | null, candidateScore?: number | null, createdAt: any, completedAt?: any | null, status: Trial_Status, isAssessmentComplete: boolean, examination: { __typename?: 'Examination', id: string, type: Examination_Type, questionsTime?: number | null }, companyCandidate: { __typename?: 'CompanyCandidate', id: string, fullName: string, numericId: number, candidateUsername?: { __typename?: 'CandidateUsername', id: string, login?: string | null } | null }, recruiterReportFiles?: Array<{ __typename?: 'TrialFile', id: string, type: Trial_File_Type, file: { __typename?: 'File', id: string, url: string } }> | null, reportData?: { __typename?: 'TrialReportData', ai_generation_percentage?: number | null } | null }> | null }> | null } };

export type ExaminationTitleQueryVariables = Exact<{
  examinationId: Scalars['ID']['input'];
}>;


export type ExaminationTitleQuery = { __typename?: 'Query', examination: { __typename?: 'Examination', id: string, title: string } };

export type TrialHeaderQueryVariables = Exact<{
  trialId: Scalars['ID']['input'];
}>;


export type TrialHeaderQuery = { __typename?: 'Query', trial?: { __typename?: 'Trial', id: string, numericId: number, status: Trial_Status, completedAt?: any | null, isAssessmentComplete: boolean, companyCandidate: { __typename?: 'CompanyCandidate', id: string, fullName: string }, examination: { __typename?: 'Examination', id: string, title: string, numericId: number }, recruiterReportFiles?: Array<{ __typename?: 'TrialFile', id: string, file: { __typename?: 'File', id: string, url: string } }> | null } | null };

export type TrialInfoQueryVariables = Exact<{
  trialId: Scalars['ID']['input'];
}>;


export type TrialInfoQuery = { __typename?: 'Query', trial?: { __typename?: 'Trial', id: string, comment?: string | null, status: Trial_Status, createdAt: any, completedAt?: any | null, companyCandidate: { __typename?: 'CompanyCandidate', id: string, fullName: string, email?: string | null, organization?: string | null, position?: string | null, grade?: Grade | null, candidateUsername?: { __typename?: 'CandidateUsername', id: string, telegramUsername?: string | null, login?: string | null, candidate?: { __typename?: 'Candidate', id: string, phoneNumber?: string | null } | null } | null }, examination: { __typename?: 'Examination', id: string, title: string, isSendResult: boolean, sendResultType: Trial_File_Type, competencyMap: { __typename?: 'CompetencyMap', id: string, title: string, comment?: string | null, grades?: Array<Grade> | null } }, trialStatusHistory?: Array<{ __typename?: 'TrialStatusHistory', id: string, newStatus: Trial_Status, createdAt: any }> | null } | null };

export type TrialListQueryVariables = Exact<{
  filter?: InputMaybe<ListTrialFilterInput>;
  limit: Scalars['Float']['input'];
  order: PlatformTrialListOrderInput;
  page: Scalars['Float']['input'];
}>;


export type TrialListQuery = { __typename?: 'Query', trials: { __typename?: 'PaginatedTrial', totalCount: number, data?: Array<{ __typename?: 'Trial', id: string, candidateTime?: number | null, completedAt?: any | null, status: Trial_Status, isAssessmentComplete: boolean, candidateScore?: number | null, examination: { __typename?: 'Examination', id: string, questionsTime?: number | null }, companyCandidate: { __typename?: 'CompanyCandidate', id: string, numericId: number, fullName: string }, recruiterReportFiles?: Array<{ __typename?: 'TrialFile', id: string, type: Trial_File_Type, file: { __typename?: 'File', id: string, url: string } }> | null, reportData?: { __typename?: 'TrialReportData', ai_generation_percentage?: number | null } | null, competencesScore?: Array<{ __typename?: 'CompetenceScoreType', competenceId: string, score: number, order: number }> | null }> | null } };

export type TrialResultQueryVariables = Exact<{
  trialId: Scalars['ID']['input'];
}>;


export type TrialResultQuery = { __typename?: 'Query', trial?: { __typename?: 'Trial', id: string, candidateScore?: number | null, companyCandidate: { __typename?: 'CompanyCandidate', id: string, fullName: string }, trialRepositoryChecks: Array<{ __typename?: 'TrialRepositoryCheck', id: string, algorithmsScore?: number | null, error?: any | null, maintainabilityScore?: number | null, readabilityScore?: number | null, repoUrl?: string | null, totalScore?: number | null, facts?: { __typename?: 'TrialRepositoryFacts', first_release_date?: any | null, main_language?: string | null, developers_count?: number | null, forks_count?: number | null, languages?: any | null, repo_url?: string | null, stars_count?: number | null } | null }>, examination: { __typename?: 'Examination', id: string, numericId: number, title: string, competencyMap: { __typename?: 'CompetencyMap', id: string, competences?: Array<{ __typename?: 'Competence', id: string, title: string, knowledgeBlockCompetences?: Array<{ __typename?: 'KnowledgeBlockCompetence', id: string, knowledgeBlock: { __typename?: 'KnowledgeBlock', id: string, title: string, skills?: Array<{ __typename?: 'Skill', id: string, title: string, trialAnswer?: { __typename?: 'TrialAnswer', id: string, score?: number | null, time: number, answer?: string | null, partsIds?: Array<string> | null, file?: { __typename?: 'File', id: string, url: string, name: string } | null, question: { __typename?: 'Question', id: string, text: string, type: Question_Type, parts?: Array<{ __typename?: 'QuestionPart', id: string, content: string, isCorrect: boolean }> | null }, criterionAssessments?: Array<{ __typename?: 'CriterionAssessment', criteria: string, decision: string }> | null } | null }> | null } }> | null }> | null } } } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserDataInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, userEmail: { __typename?: 'UserEmail', id: string, email: string } } };

export type UserCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCompaniesQuery = { __typename?: 'Query', userCompanies?: Array<{ __typename?: 'Company', id: string, shortName: string, currentUserPosition?: string | null }> | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, middleName?: string | null, userEmail: { __typename?: 'UserEmail', id: string, email: string } } };

export type AddCandidatesToVacancyMutationVariables = Exact<{
  input: CreateVacancyCompanyCandidatesInput;
}>;


export type AddCandidatesToVacancyMutation = { __typename?: 'Mutation', createVacancyCompanyCandidate: Array<{ __typename?: 'VacancyCompanyCandidate', id: string }> };

export type CreateVacancyMutationVariables = Exact<{
  input: CreateVacancyInput;
}>;


export type CreateVacancyMutation = { __typename?: 'Mutation', createVacancy: { __typename?: 'Vacancy', id: string, description: string, numericId: number, title: string } };

export type DeleteVacancyMutationVariables = Exact<{
  vacancyId: Scalars['String']['input'];
}>;


export type DeleteVacancyMutation = { __typename?: 'Mutation', deleteVacancy: boolean };

export type DeleteVacancyCompanyCandidateMutationVariables = Exact<{
  vacancyCompanyCandidateId: Scalars['ID']['input'];
}>;


export type DeleteVacancyCompanyCandidateMutation = { __typename?: 'Mutation', deleteVacancyCompanyCandidate: boolean };

export type InitAssessmentCvMutationVariables = Exact<{
  vacancyId: Scalars['ID']['input'];
}>;


export type InitAssessmentCvMutation = { __typename?: 'Mutation', assessmentCv: boolean };

export type UploadCandidatesToVacancyMutationVariables = Exact<{
  files: Array<Scalars['Upload']['input']> | Scalars['Upload']['input'];
  vacancyId: Scalars['ID']['input'];
}>;


export type UploadCandidatesToVacancyMutation = { __typename?: 'Mutation', createVacancyCompanyCandidateByCVs?: Array<{ __typename?: 'CreateVacancyCompanyCandidateByCVs', fullName: string, login: string, numericId: number, password: string }> | null };

export type VacanciesListQueryVariables = Exact<{
  filter?: InputMaybe<ListVacancyFilterInput>;
  limit: Scalars['Float']['input'];
  order: PlatformVacancyListOrderInput;
  page: Scalars['Float']['input'];
}>;


export type VacanciesListQuery = { __typename?: 'Query', vacancies: { __typename?: 'PaginatedVacancy', totalCount: number, data?: Array<{ __typename?: 'Vacancy', id: string, createdAt: any, companyCandidatesCount: number, description: string, numericId: number, title: string }> | null } };

export type VacancyQueryVariables = Exact<{
  vacancyId: Scalars['ID']['input'];
}>;


export type VacancyQuery = { __typename?: 'Query', vacancy?: { __typename?: 'Vacancy', id: string, description: string, numericId: number, title: string } | null };

export type VacancyCompanyCandidatesQueryVariables = Exact<{
  filter?: InputMaybe<ListVacancyCompanyCandidateFilterInput>;
  limit: Scalars['Float']['input'];
  order?: PlatformVacancyCompanyCandidateListOrderInput;
  page: Scalars['Float']['input'];
}>;


export type VacancyCompanyCandidatesQuery = { __typename?: 'Query', vacancyCompanyCandidates: { __typename?: 'PaginatedVacancyCompanyCandidate', totalCount: number, data?: Array<{ __typename?: 'VacancyCompanyCandidate', id: string, createdAt: any, currentCvCheck?: { __typename?: 'CvCheck', id: string, score?: number | null, assessmentCV?: any | null, reportFile?: { __typename?: 'File', id: string, url: string } | null } | null, cvChecks?: Array<{ __typename?: 'CvCheck', id: string }> | null, companyCandidate: { __typename?: 'CompanyCandidate', id: string, numericId: number, fullName: string, createdAt: any, cvFileId?: string | null, candidateUsername?: { __typename?: 'CandidateUsername', id: string, telegramUsername?: string | null, login?: string | null } | null } }> | null } };

export type VacancyHeaderQueryVariables = Exact<{
  vacancyId: Scalars['ID']['input'];
}>;


export type VacancyHeaderQuery = { __typename?: 'Query', vacancy?: { __typename?: 'Vacancy', id: string, title: string } | null };


export const CreateUserDocument = gql`
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    accessToken
    refreshToken
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const LoginByCredentialsDocument = gql`
    mutation loginByCredentials($email: String!, $password: String!) {
  loginByCredentials(email: $email, password: $password) {
    accessToken
    refreshToken
  }
}
    `;
export type LoginByCredentialsMutationFn = Apollo.MutationFunction<LoginByCredentialsMutation, LoginByCredentialsMutationVariables>;

/**
 * __useLoginByCredentialsMutation__
 *
 * To run a mutation, you first call `useLoginByCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginByCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginByCredentialsMutation, { data, loading, error }] = useLoginByCredentialsMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginByCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<LoginByCredentialsMutation, LoginByCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginByCredentialsMutation, LoginByCredentialsMutationVariables>(LoginByCredentialsDocument, options);
      }
export type LoginByCredentialsMutationHookResult = ReturnType<typeof useLoginByCredentialsMutation>;
export type LoginByCredentialsMutationResult = Apollo.MutationResult<LoginByCredentialsMutation>;
export type LoginByCredentialsMutationOptions = Apollo.BaseMutationOptions<LoginByCredentialsMutation, LoginByCredentialsMutationVariables>;
export const CreateOrUpdateCompanyCandidateDocument = gql`
    mutation createOrUpdateCompanyCandidate($input: CreateOrUpdateCompanyCandidateInput!) {
  createOrUpdateCompanyCandidate(input: $input) {
    id
    fullName
    candidateUsername {
      id
      telegramUsername
      login
      candidate {
        id
        phoneNumber
      }
    }
    email
    organization
    position
    grade
  }
}
    `;
export type CreateOrUpdateCompanyCandidateMutationFn = Apollo.MutationFunction<CreateOrUpdateCompanyCandidateMutation, CreateOrUpdateCompanyCandidateMutationVariables>;

/**
 * __useCreateOrUpdateCompanyCandidateMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCompanyCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCompanyCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCompanyCandidateMutation, { data, loading, error }] = useCreateOrUpdateCompanyCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateCompanyCandidateMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateCompanyCandidateMutation, CreateOrUpdateCompanyCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateCompanyCandidateMutation, CreateOrUpdateCompanyCandidateMutationVariables>(CreateOrUpdateCompanyCandidateDocument, options);
      }
export type CreateOrUpdateCompanyCandidateMutationHookResult = ReturnType<typeof useCreateOrUpdateCompanyCandidateMutation>;
export type CreateOrUpdateCompanyCandidateMutationResult = Apollo.MutationResult<CreateOrUpdateCompanyCandidateMutation>;
export type CreateOrUpdateCompanyCandidateMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateCompanyCandidateMutation, CreateOrUpdateCompanyCandidateMutationVariables>;
export const CreateOrUpdateCompanyCandidateLoginDocument = gql`
    mutation createOrUpdateCompanyCandidateLogin($input: CreateOrUpdateCompanyCandidateLoginInput!) {
  createOrUpdateCompanyCandidateLogin(input: $input) {
    id
    fullName
    candidateUsername {
      id
      telegramUsername
      login
      candidate {
        id
        phoneNumber
      }
    }
    email
    organization
    position
    grade
  }
}
    `;
export type CreateOrUpdateCompanyCandidateLoginMutationFn = Apollo.MutationFunction<CreateOrUpdateCompanyCandidateLoginMutation, CreateOrUpdateCompanyCandidateLoginMutationVariables>;

/**
 * __useCreateOrUpdateCompanyCandidateLoginMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCompanyCandidateLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCompanyCandidateLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCompanyCandidateLoginMutation, { data, loading, error }] = useCreateOrUpdateCompanyCandidateLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateCompanyCandidateLoginMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateCompanyCandidateLoginMutation, CreateOrUpdateCompanyCandidateLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateCompanyCandidateLoginMutation, CreateOrUpdateCompanyCandidateLoginMutationVariables>(CreateOrUpdateCompanyCandidateLoginDocument, options);
      }
export type CreateOrUpdateCompanyCandidateLoginMutationHookResult = ReturnType<typeof useCreateOrUpdateCompanyCandidateLoginMutation>;
export type CreateOrUpdateCompanyCandidateLoginMutationResult = Apollo.MutationResult<CreateOrUpdateCompanyCandidateLoginMutation>;
export type CreateOrUpdateCompanyCandidateLoginMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateCompanyCandidateLoginMutation, CreateOrUpdateCompanyCandidateLoginMutationVariables>;
export const CandidateHeaderDocument = gql`
    query candidateHeader($candidateId: ID!) {
  companyCandidate(companyCandidateId: $candidateId) {
    id
    numericId
    fullName
  }
}
    `;

/**
 * __useCandidateHeaderQuery__
 *
 * To run a query within a React component, call `useCandidateHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateHeaderQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useCandidateHeaderQuery(baseOptions: Apollo.QueryHookOptions<CandidateHeaderQuery, CandidateHeaderQueryVariables> & ({ variables: CandidateHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateHeaderQuery, CandidateHeaderQueryVariables>(CandidateHeaderDocument, options);
      }
export function useCandidateHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateHeaderQuery, CandidateHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateHeaderQuery, CandidateHeaderQueryVariables>(CandidateHeaderDocument, options);
        }
export function useCandidateHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateHeaderQuery, CandidateHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateHeaderQuery, CandidateHeaderQueryVariables>(CandidateHeaderDocument, options);
        }
export type CandidateHeaderQueryHookResult = ReturnType<typeof useCandidateHeaderQuery>;
export type CandidateHeaderLazyQueryHookResult = ReturnType<typeof useCandidateHeaderLazyQuery>;
export type CandidateHeaderSuspenseQueryHookResult = ReturnType<typeof useCandidateHeaderSuspenseQuery>;
export type CandidateHeaderQueryResult = Apollo.QueryResult<CandidateHeaderQuery, CandidateHeaderQueryVariables>;
export const CandidateInfoDocument = gql`
    query candidateInfo($candidateId: ID!) {
  companyCandidate(companyCandidateId: $candidateId) {
    id
    fullName
    email
    candidateUsername {
      id
      telegramUsername
      login
      candidate {
        id
        phoneNumber
      }
    }
    grade
    organization
    position
    type
    link
    cvFile {
      id
      name
      url
    }
  }
}
    `;

/**
 * __useCandidateInfoQuery__
 *
 * To run a query within a React component, call `useCandidateInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateInfoQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useCandidateInfoQuery(baseOptions: Apollo.QueryHookOptions<CandidateInfoQuery, CandidateInfoQueryVariables> & ({ variables: CandidateInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateInfoQuery, CandidateInfoQueryVariables>(CandidateInfoDocument, options);
      }
export function useCandidateInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateInfoQuery, CandidateInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateInfoQuery, CandidateInfoQueryVariables>(CandidateInfoDocument, options);
        }
export function useCandidateInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateInfoQuery, CandidateInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateInfoQuery, CandidateInfoQueryVariables>(CandidateInfoDocument, options);
        }
export type CandidateInfoQueryHookResult = ReturnType<typeof useCandidateInfoQuery>;
export type CandidateInfoLazyQueryHookResult = ReturnType<typeof useCandidateInfoLazyQuery>;
export type CandidateInfoSuspenseQueryHookResult = ReturnType<typeof useCandidateInfoSuspenseQuery>;
export type CandidateInfoQueryResult = Apollo.QueryResult<CandidateInfoQuery, CandidateInfoQueryVariables>;
export const CandidateVacanciesDocument = gql`
    query candidateVacancies($candidateId: ID!) {
  companyCandidate(companyCandidateId: $candidateId) {
    id
    vacancyCompanyCandidates {
      id
      vacancy {
        id
        title
      }
      currentCvCheck {
        id
        score
        reportFile {
          id
          url
        }
      }
    }
  }
}
    `;

/**
 * __useCandidateVacanciesQuery__
 *
 * To run a query within a React component, call `useCandidateVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateVacanciesQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useCandidateVacanciesQuery(baseOptions: Apollo.QueryHookOptions<CandidateVacanciesQuery, CandidateVacanciesQueryVariables> & ({ variables: CandidateVacanciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateVacanciesQuery, CandidateVacanciesQueryVariables>(CandidateVacanciesDocument, options);
      }
export function useCandidateVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateVacanciesQuery, CandidateVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateVacanciesQuery, CandidateVacanciesQueryVariables>(CandidateVacanciesDocument, options);
        }
export function useCandidateVacanciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateVacanciesQuery, CandidateVacanciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateVacanciesQuery, CandidateVacanciesQueryVariables>(CandidateVacanciesDocument, options);
        }
export type CandidateVacanciesQueryHookResult = ReturnType<typeof useCandidateVacanciesQuery>;
export type CandidateVacanciesLazyQueryHookResult = ReturnType<typeof useCandidateVacanciesLazyQuery>;
export type CandidateVacanciesSuspenseQueryHookResult = ReturnType<typeof useCandidateVacanciesSuspenseQuery>;
export type CandidateVacanciesQueryResult = Apollo.QueryResult<CandidateVacanciesQuery, CandidateVacanciesQueryVariables>;
export const CompanyCandidateListDocument = gql`
    query companyCandidateList($filter: ListCompanyCandidateFilterInput, $limit: Float!, $order: PlatformCompanyCandidateListOrderInput! = {order: DESC, field: createdAt}, $page: Float!) {
  companyCandidates(filter: $filter, limit: $limit, page: $page, order: $order) {
    totalCount
    data {
      id
      numericId
      fullName
      createdAt
      organization
      position
      type
      grade
      email
      candidateUsername {
        id
        telegramUsername
        login
        candidate {
          id
          phoneNumber
          language
        }
      }
      link
      lastTrialDate
      trials {
        id
        completedAt
        examination {
          id
          title
          numericId
        }
      }
      trialsCount
      averageTrialsScore
      lastTrialScore
      lastTrialStatus
      lastTrialTime
      lastTrialRecruiterReportFiles {
        id
        file {
          id
          url
        }
      }
    }
  }
}
    `;

/**
 * __useCompanyCandidateListQuery__
 *
 * To run a query within a React component, call `useCompanyCandidateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyCandidateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyCandidateListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCompanyCandidateListQuery(baseOptions: Apollo.QueryHookOptions<CompanyCandidateListQuery, CompanyCandidateListQueryVariables> & ({ variables: CompanyCandidateListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyCandidateListQuery, CompanyCandidateListQueryVariables>(CompanyCandidateListDocument, options);
      }
export function useCompanyCandidateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyCandidateListQuery, CompanyCandidateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyCandidateListQuery, CompanyCandidateListQueryVariables>(CompanyCandidateListDocument, options);
        }
export function useCompanyCandidateListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyCandidateListQuery, CompanyCandidateListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyCandidateListQuery, CompanyCandidateListQueryVariables>(CompanyCandidateListDocument, options);
        }
export type CompanyCandidateListQueryHookResult = ReturnType<typeof useCompanyCandidateListQuery>;
export type CompanyCandidateListLazyQueryHookResult = ReturnType<typeof useCompanyCandidateListLazyQuery>;
export type CompanyCandidateListSuspenseQueryHookResult = ReturnType<typeof useCompanyCandidateListSuspenseQuery>;
export type CompanyCandidateListQueryResult = Apollo.QueryResult<CompanyCandidateListQuery, CompanyCandidateListQueryVariables>;
export const CompanyCandidateOptionListDocument = gql`
    query companyCandidateOptionList($filter: ListCompanyCandidateFilterInput, $limit: Float!, $page: Float!, $order: PlatformCompanyCandidateListOrderInput! = {order: DESC, field: createdAt}) {
  companyCandidates(filter: $filter, limit: $limit, page: $page, order: $order) {
    totalCount
    data {
      id
      fullName
      createdAt
      numericId
      candidateUsername {
        id
        telegramUsername
        login
        candidate {
          id
          phoneNumber
        }
        companyCandidate {
          id
          companyId
          email
          organization
          position
          grade
        }
      }
    }
  }
}
    `;

/**
 * __useCompanyCandidateOptionListQuery__
 *
 * To run a query within a React component, call `useCompanyCandidateOptionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyCandidateOptionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyCandidateOptionListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCompanyCandidateOptionListQuery(baseOptions: Apollo.QueryHookOptions<CompanyCandidateOptionListQuery, CompanyCandidateOptionListQueryVariables> & ({ variables: CompanyCandidateOptionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyCandidateOptionListQuery, CompanyCandidateOptionListQueryVariables>(CompanyCandidateOptionListDocument, options);
      }
export function useCompanyCandidateOptionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyCandidateOptionListQuery, CompanyCandidateOptionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyCandidateOptionListQuery, CompanyCandidateOptionListQueryVariables>(CompanyCandidateOptionListDocument, options);
        }
export function useCompanyCandidateOptionListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyCandidateOptionListQuery, CompanyCandidateOptionListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyCandidateOptionListQuery, CompanyCandidateOptionListQueryVariables>(CompanyCandidateOptionListDocument, options);
        }
export type CompanyCandidateOptionListQueryHookResult = ReturnType<typeof useCompanyCandidateOptionListQuery>;
export type CompanyCandidateOptionListLazyQueryHookResult = ReturnType<typeof useCompanyCandidateOptionListLazyQuery>;
export type CompanyCandidateOptionListSuspenseQueryHookResult = ReturnType<typeof useCompanyCandidateOptionListSuspenseQuery>;
export type CompanyCandidateOptionListQueryResult = Apollo.QueryResult<CompanyCandidateOptionListQuery, CompanyCandidateOptionListQueryVariables>;
export const CreateOrUpdateCompanyDocument = gql`
    mutation createOrUpdateCompany($input: CreateOrUpdateCompanyInput!) {
  createOrUpdateCompany(input: $input) {
    id
    inn
    shortName
    fullName
    kpp
    ogrn
    ogrnDate
    type
    managerFio
    managerPosition
    okpo
    okato
    oktmo
    registrationAddress
    registrationDate
    status
    state
    currentUserPosition
  }
}
    `;
export type CreateOrUpdateCompanyMutationFn = Apollo.MutationFunction<CreateOrUpdateCompanyMutation, CreateOrUpdateCompanyMutationVariables>;

/**
 * __useCreateOrUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCompanyMutation, { data, loading, error }] = useCreateOrUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateCompanyMutation, CreateOrUpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateCompanyMutation, CreateOrUpdateCompanyMutationVariables>(CreateOrUpdateCompanyDocument, options);
      }
export type CreateOrUpdateCompanyMutationHookResult = ReturnType<typeof useCreateOrUpdateCompanyMutation>;
export type CreateOrUpdateCompanyMutationResult = Apollo.MutationResult<CreateOrUpdateCompanyMutation>;
export type CreateOrUpdateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateCompanyMutation, CreateOrUpdateCompanyMutationVariables>;
export const CompanyDocument = gql`
    query company {
  company {
    id
    identification
    inn
    shortName
    fullName
    contractNumber
    kpp
    ogrn
    ogrnDate
    type
    managerFio
    managerPosition
    okpo
    okato
    oktmo
    registrationAddress
    registrationDate
    status
    state
    currentUserPosition
  }
}
    `;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyQuery(baseOptions?: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export function useCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanySuspenseQueryHookResult = ReturnType<typeof useCompanySuspenseQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const BatchInitGenerateQuestionsDocument = gql`
    mutation batchInitGenerateQuestions($input: BatchInitGenerateQuestionsInput!) {
  batchInitGenerateQuestions(input: $input)
}
    `;
export type BatchInitGenerateQuestionsMutationFn = Apollo.MutationFunction<BatchInitGenerateQuestionsMutation, BatchInitGenerateQuestionsMutationVariables>;

/**
 * __useBatchInitGenerateQuestionsMutation__
 *
 * To run a mutation, you first call `useBatchInitGenerateQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchInitGenerateQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchInitGenerateQuestionsMutation, { data, loading, error }] = useBatchInitGenerateQuestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchInitGenerateQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<BatchInitGenerateQuestionsMutation, BatchInitGenerateQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchInitGenerateQuestionsMutation, BatchInitGenerateQuestionsMutationVariables>(BatchInitGenerateQuestionsDocument, options);
      }
export type BatchInitGenerateQuestionsMutationHookResult = ReturnType<typeof useBatchInitGenerateQuestionsMutation>;
export type BatchInitGenerateQuestionsMutationResult = Apollo.MutationResult<BatchInitGenerateQuestionsMutation>;
export type BatchInitGenerateQuestionsMutationOptions = Apollo.BaseMutationOptions<BatchInitGenerateQuestionsMutation, BatchInitGenerateQuestionsMutationVariables>;
export const CopyCompetencyMapDocument = gql`
    mutation copyCompetencyMap($input: CopyCompetenceMapInputDto!) {
  copyCompetencyMap(input: $input) {
    id
  }
}
    `;
export type CopyCompetencyMapMutationFn = Apollo.MutationFunction<CopyCompetencyMapMutation, CopyCompetencyMapMutationVariables>;

/**
 * __useCopyCompetencyMapMutation__
 *
 * To run a mutation, you first call `useCopyCompetencyMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyCompetencyMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyCompetencyMapMutation, { data, loading, error }] = useCopyCompetencyMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyCompetencyMapMutation(baseOptions?: Apollo.MutationHookOptions<CopyCompetencyMapMutation, CopyCompetencyMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyCompetencyMapMutation, CopyCompetencyMapMutationVariables>(CopyCompetencyMapDocument, options);
      }
export type CopyCompetencyMapMutationHookResult = ReturnType<typeof useCopyCompetencyMapMutation>;
export type CopyCompetencyMapMutationResult = Apollo.MutationResult<CopyCompetencyMapMutation>;
export type CopyCompetencyMapMutationOptions = Apollo.BaseMutationOptions<CopyCompetencyMapMutation, CopyCompetencyMapMutationVariables>;
export const CreateCompetencyMapFromJsonDocument = gql`
    mutation createCompetencyMapFromJson($input: CreateCompetencyMapFromFileInput!) {
  createCompetencyMapFromJson(input: $input) {
    id
  }
}
    `;
export type CreateCompetencyMapFromJsonMutationFn = Apollo.MutationFunction<CreateCompetencyMapFromJsonMutation, CreateCompetencyMapFromJsonMutationVariables>;

/**
 * __useCreateCompetencyMapFromJsonMutation__
 *
 * To run a mutation, you first call `useCreateCompetencyMapFromJsonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompetencyMapFromJsonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompetencyMapFromJsonMutation, { data, loading, error }] = useCreateCompetencyMapFromJsonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompetencyMapFromJsonMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompetencyMapFromJsonMutation, CreateCompetencyMapFromJsonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompetencyMapFromJsonMutation, CreateCompetencyMapFromJsonMutationVariables>(CreateCompetencyMapFromJsonDocument, options);
      }
export type CreateCompetencyMapFromJsonMutationHookResult = ReturnType<typeof useCreateCompetencyMapFromJsonMutation>;
export type CreateCompetencyMapFromJsonMutationResult = Apollo.MutationResult<CreateCompetencyMapFromJsonMutation>;
export type CreateCompetencyMapFromJsonMutationOptions = Apollo.BaseMutationOptions<CreateCompetencyMapFromJsonMutation, CreateCompetencyMapFromJsonMutationVariables>;
export const CreateCompetencyMapFromXlsxDocument = gql`
    mutation createCompetencyMapFromXlsx($input: CompetencyMapFromXlsxInput!) {
  createCompetencyMapFromXlsx(input: $input) {
    id
  }
}
    `;
export type CreateCompetencyMapFromXlsxMutationFn = Apollo.MutationFunction<CreateCompetencyMapFromXlsxMutation, CreateCompetencyMapFromXlsxMutationVariables>;

/**
 * __useCreateCompetencyMapFromXlsxMutation__
 *
 * To run a mutation, you first call `useCreateCompetencyMapFromXlsxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompetencyMapFromXlsxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompetencyMapFromXlsxMutation, { data, loading, error }] = useCreateCompetencyMapFromXlsxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompetencyMapFromXlsxMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompetencyMapFromXlsxMutation, CreateCompetencyMapFromXlsxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompetencyMapFromXlsxMutation, CreateCompetencyMapFromXlsxMutationVariables>(CreateCompetencyMapFromXlsxDocument, options);
      }
export type CreateCompetencyMapFromXlsxMutationHookResult = ReturnType<typeof useCreateCompetencyMapFromXlsxMutation>;
export type CreateCompetencyMapFromXlsxMutationResult = Apollo.MutationResult<CreateCompetencyMapFromXlsxMutation>;
export type CreateCompetencyMapFromXlsxMutationOptions = Apollo.BaseMutationOptions<CreateCompetencyMapFromXlsxMutation, CreateCompetencyMapFromXlsxMutationVariables>;
export const CreateOrUpdateCompetencyMapDocument = gql`
    mutation createOrUpdateCompetencyMap($input: CreateOrUpdateCompetencyMapInput!) {
  createOrUpdateCompetencyMap(input: $input) {
    id
    title
    specialization
    comment
    createdAt
    updatedAt
    grades
    useInBot
    isRepositoryCheck
    demoCode
    status
    competences {
      id
      title
      knowledgeBlockCompetences {
        id
        knowledgeBlock {
          id
          title
          skills {
            id
            title
            confirmedQuestionsCount
            notConfirmedQuestionsCount
          }
        }
      }
    }
  }
}
    `;
export type CreateOrUpdateCompetencyMapMutationFn = Apollo.MutationFunction<CreateOrUpdateCompetencyMapMutation, CreateOrUpdateCompetencyMapMutationVariables>;

/**
 * __useCreateOrUpdateCompetencyMapMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCompetencyMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCompetencyMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCompetencyMapMutation, { data, loading, error }] = useCreateOrUpdateCompetencyMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateCompetencyMapMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateCompetencyMapMutation, CreateOrUpdateCompetencyMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateCompetencyMapMutation, CreateOrUpdateCompetencyMapMutationVariables>(CreateOrUpdateCompetencyMapDocument, options);
      }
export type CreateOrUpdateCompetencyMapMutationHookResult = ReturnType<typeof useCreateOrUpdateCompetencyMapMutation>;
export type CreateOrUpdateCompetencyMapMutationResult = Apollo.MutationResult<CreateOrUpdateCompetencyMapMutation>;
export type CreateOrUpdateCompetencyMapMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateCompetencyMapMutation, CreateOrUpdateCompetencyMapMutationVariables>;
export const DeleteCompetencyMapDocument = gql`
    mutation deleteCompetencyMap($competencyMapId: ID!) {
  deleteCompetencyMap(competencyMapId: $competencyMapId)
}
    `;
export type DeleteCompetencyMapMutationFn = Apollo.MutationFunction<DeleteCompetencyMapMutation, DeleteCompetencyMapMutationVariables>;

/**
 * __useDeleteCompetencyMapMutation__
 *
 * To run a mutation, you first call `useDeleteCompetencyMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompetencyMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompetencyMapMutation, { data, loading, error }] = useDeleteCompetencyMapMutation({
 *   variables: {
 *      competencyMapId: // value for 'competencyMapId'
 *   },
 * });
 */
export function useDeleteCompetencyMapMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompetencyMapMutation, DeleteCompetencyMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompetencyMapMutation, DeleteCompetencyMapMutationVariables>(DeleteCompetencyMapDocument, options);
      }
export type DeleteCompetencyMapMutationHookResult = ReturnType<typeof useDeleteCompetencyMapMutation>;
export type DeleteCompetencyMapMutationResult = Apollo.MutationResult<DeleteCompetencyMapMutation>;
export type DeleteCompetencyMapMutationOptions = Apollo.BaseMutationOptions<DeleteCompetencyMapMutation, DeleteCompetencyMapMutationVariables>;
export const GenerateSkeletonOfCompetencyMapByDescriptionDocument = gql`
    mutation generateSkeletonOfCompetencyMapByDescription($input: GenerateSkeletonCompetencyMapDescriptionInput!) {
  generateSkeletonOfCompetencyMapByDescription(input: $input)
}
    `;
export type GenerateSkeletonOfCompetencyMapByDescriptionMutationFn = Apollo.MutationFunction<GenerateSkeletonOfCompetencyMapByDescriptionMutation, GenerateSkeletonOfCompetencyMapByDescriptionMutationVariables>;

/**
 * __useGenerateSkeletonOfCompetencyMapByDescriptionMutation__
 *
 * To run a mutation, you first call `useGenerateSkeletonOfCompetencyMapByDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSkeletonOfCompetencyMapByDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSkeletonOfCompetencyMapByDescriptionMutation, { data, loading, error }] = useGenerateSkeletonOfCompetencyMapByDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSkeletonOfCompetencyMapByDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSkeletonOfCompetencyMapByDescriptionMutation, GenerateSkeletonOfCompetencyMapByDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSkeletonOfCompetencyMapByDescriptionMutation, GenerateSkeletonOfCompetencyMapByDescriptionMutationVariables>(GenerateSkeletonOfCompetencyMapByDescriptionDocument, options);
      }
export type GenerateSkeletonOfCompetencyMapByDescriptionMutationHookResult = ReturnType<typeof useGenerateSkeletonOfCompetencyMapByDescriptionMutation>;
export type GenerateSkeletonOfCompetencyMapByDescriptionMutationResult = Apollo.MutationResult<GenerateSkeletonOfCompetencyMapByDescriptionMutation>;
export type GenerateSkeletonOfCompetencyMapByDescriptionMutationOptions = Apollo.BaseMutationOptions<GenerateSkeletonOfCompetencyMapByDescriptionMutation, GenerateSkeletonOfCompetencyMapByDescriptionMutationVariables>;
export const GenerateSkeletonOfCompetencyMapByVacancyDocument = gql`
    mutation generateSkeletonOfCompetencyMapByVacancy($input: GenerateSkeletonCompetencyMapVacancyInput!) {
  generateSkeletonOfCompetencyMapByVacancy(input: $input)
}
    `;
export type GenerateSkeletonOfCompetencyMapByVacancyMutationFn = Apollo.MutationFunction<GenerateSkeletonOfCompetencyMapByVacancyMutation, GenerateSkeletonOfCompetencyMapByVacancyMutationVariables>;

/**
 * __useGenerateSkeletonOfCompetencyMapByVacancyMutation__
 *
 * To run a mutation, you first call `useGenerateSkeletonOfCompetencyMapByVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSkeletonOfCompetencyMapByVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSkeletonOfCompetencyMapByVacancyMutation, { data, loading, error }] = useGenerateSkeletonOfCompetencyMapByVacancyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSkeletonOfCompetencyMapByVacancyMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSkeletonOfCompetencyMapByVacancyMutation, GenerateSkeletonOfCompetencyMapByVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSkeletonOfCompetencyMapByVacancyMutation, GenerateSkeletonOfCompetencyMapByVacancyMutationVariables>(GenerateSkeletonOfCompetencyMapByVacancyDocument, options);
      }
export type GenerateSkeletonOfCompetencyMapByVacancyMutationHookResult = ReturnType<typeof useGenerateSkeletonOfCompetencyMapByVacancyMutation>;
export type GenerateSkeletonOfCompetencyMapByVacancyMutationResult = Apollo.MutationResult<GenerateSkeletonOfCompetencyMapByVacancyMutation>;
export type GenerateSkeletonOfCompetencyMapByVacancyMutationOptions = Apollo.BaseMutationOptions<GenerateSkeletonOfCompetencyMapByVacancyMutation, GenerateSkeletonOfCompetencyMapByVacancyMutationVariables>;
export const UpdateCompetencyMapStatusDocument = gql`
    mutation updateCompetencyMapStatus($input: UpdateCompetencyMapStatusInput!) {
  updateStatusCompetencyMap(input: $input) {
    id
    status
  }
}
    `;
export type UpdateCompetencyMapStatusMutationFn = Apollo.MutationFunction<UpdateCompetencyMapStatusMutation, UpdateCompetencyMapStatusMutationVariables>;

/**
 * __useUpdateCompetencyMapStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCompetencyMapStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompetencyMapStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompetencyMapStatusMutation, { data, loading, error }] = useUpdateCompetencyMapStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompetencyMapStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompetencyMapStatusMutation, UpdateCompetencyMapStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompetencyMapStatusMutation, UpdateCompetencyMapStatusMutationVariables>(UpdateCompetencyMapStatusDocument, options);
      }
export type UpdateCompetencyMapStatusMutationHookResult = ReturnType<typeof useUpdateCompetencyMapStatusMutation>;
export type UpdateCompetencyMapStatusMutationResult = Apollo.MutationResult<UpdateCompetencyMapStatusMutation>;
export type UpdateCompetencyMapStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCompetencyMapStatusMutation, UpdateCompetencyMapStatusMutationVariables>;
export const CompetencyMapDocument = gql`
    query competencyMap($competencyMapId: ID!) {
  competencyMap(competencyMapId: $competencyMapId) {
    id
    title
    specialization
    comment
    createdAt
    updatedAt
    grades
    useInBot
    demoCode
    status
    isRepositoryCheck
    questionsTime
    trialsInfo {
      hasStarted
    }
    examinations {
      id
      trials {
        id
        status
      }
    }
    originalCompetencyMapId
    originalCompetencyMap {
      id
      title
    }
    competences {
      id
      title
      knowledgeBlockCompetences {
        id
        knowledgeBlock {
          id
          title
          skills {
            id
            title
            grades
            confirmedQuestionsCount
            notConfirmedQuestionsCount
            questions {
              id
              confirmation
            }
          }
          profession
        }
      }
    }
  }
}
    `;

/**
 * __useCompetencyMapQuery__
 *
 * To run a query within a React component, call `useCompetencyMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetencyMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetencyMapQuery({
 *   variables: {
 *      competencyMapId: // value for 'competencyMapId'
 *   },
 * });
 */
export function useCompetencyMapQuery(baseOptions: Apollo.QueryHookOptions<CompetencyMapQuery, CompetencyMapQueryVariables> & ({ variables: CompetencyMapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetencyMapQuery, CompetencyMapQueryVariables>(CompetencyMapDocument, options);
      }
export function useCompetencyMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetencyMapQuery, CompetencyMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetencyMapQuery, CompetencyMapQueryVariables>(CompetencyMapDocument, options);
        }
export function useCompetencyMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyMapQuery, CompetencyMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetencyMapQuery, CompetencyMapQueryVariables>(CompetencyMapDocument, options);
        }
export type CompetencyMapQueryHookResult = ReturnType<typeof useCompetencyMapQuery>;
export type CompetencyMapLazyQueryHookResult = ReturnType<typeof useCompetencyMapLazyQuery>;
export type CompetencyMapSuspenseQueryHookResult = ReturnType<typeof useCompetencyMapSuspenseQuery>;
export type CompetencyMapQueryResult = Apollo.QueryResult<CompetencyMapQuery, CompetencyMapQueryVariables>;
export const CompetencyMapGenQuestionsLogDocument = gql`
    query competencyMapGenQuestionsLog($competencyMapId: ID!) {
  competencyMapGenQuestionsLog(competencyMapId: $competencyMapId) {
    id
    status
    skillId
    createdAt
  }
}
    `;

/**
 * __useCompetencyMapGenQuestionsLogQuery__
 *
 * To run a query within a React component, call `useCompetencyMapGenQuestionsLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetencyMapGenQuestionsLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetencyMapGenQuestionsLogQuery({
 *   variables: {
 *      competencyMapId: // value for 'competencyMapId'
 *   },
 * });
 */
export function useCompetencyMapGenQuestionsLogQuery(baseOptions: Apollo.QueryHookOptions<CompetencyMapGenQuestionsLogQuery, CompetencyMapGenQuestionsLogQueryVariables> & ({ variables: CompetencyMapGenQuestionsLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetencyMapGenQuestionsLogQuery, CompetencyMapGenQuestionsLogQueryVariables>(CompetencyMapGenQuestionsLogDocument, options);
      }
export function useCompetencyMapGenQuestionsLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetencyMapGenQuestionsLogQuery, CompetencyMapGenQuestionsLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetencyMapGenQuestionsLogQuery, CompetencyMapGenQuestionsLogQueryVariables>(CompetencyMapGenQuestionsLogDocument, options);
        }
export function useCompetencyMapGenQuestionsLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyMapGenQuestionsLogQuery, CompetencyMapGenQuestionsLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetencyMapGenQuestionsLogQuery, CompetencyMapGenQuestionsLogQueryVariables>(CompetencyMapGenQuestionsLogDocument, options);
        }
export type CompetencyMapGenQuestionsLogQueryHookResult = ReturnType<typeof useCompetencyMapGenQuestionsLogQuery>;
export type CompetencyMapGenQuestionsLogLazyQueryHookResult = ReturnType<typeof useCompetencyMapGenQuestionsLogLazyQuery>;
export type CompetencyMapGenQuestionsLogSuspenseQueryHookResult = ReturnType<typeof useCompetencyMapGenQuestionsLogSuspenseQuery>;
export type CompetencyMapGenQuestionsLogQueryResult = Apollo.QueryResult<CompetencyMapGenQuestionsLogQuery, CompetencyMapGenQuestionsLogQueryVariables>;
export const CompetencyMapHeaderDocument = gql`
    query competencyMapHeader($competencyMapId: ID!) {
  competencyMap(competencyMapId: $competencyMapId) {
    id
    title
  }
}
    `;

/**
 * __useCompetencyMapHeaderQuery__
 *
 * To run a query within a React component, call `useCompetencyMapHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetencyMapHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetencyMapHeaderQuery({
 *   variables: {
 *      competencyMapId: // value for 'competencyMapId'
 *   },
 * });
 */
export function useCompetencyMapHeaderQuery(baseOptions: Apollo.QueryHookOptions<CompetencyMapHeaderQuery, CompetencyMapHeaderQueryVariables> & ({ variables: CompetencyMapHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetencyMapHeaderQuery, CompetencyMapHeaderQueryVariables>(CompetencyMapHeaderDocument, options);
      }
export function useCompetencyMapHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetencyMapHeaderQuery, CompetencyMapHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetencyMapHeaderQuery, CompetencyMapHeaderQueryVariables>(CompetencyMapHeaderDocument, options);
        }
export function useCompetencyMapHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyMapHeaderQuery, CompetencyMapHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetencyMapHeaderQuery, CompetencyMapHeaderQueryVariables>(CompetencyMapHeaderDocument, options);
        }
export type CompetencyMapHeaderQueryHookResult = ReturnType<typeof useCompetencyMapHeaderQuery>;
export type CompetencyMapHeaderLazyQueryHookResult = ReturnType<typeof useCompetencyMapHeaderLazyQuery>;
export type CompetencyMapHeaderSuspenseQueryHookResult = ReturnType<typeof useCompetencyMapHeaderSuspenseQuery>;
export type CompetencyMapHeaderQueryResult = Apollo.QueryResult<CompetencyMapHeaderQuery, CompetencyMapHeaderQueryVariables>;
export const CompetencyMapOptionsDocument = gql`
    query competencyMapOptions($filter: ListCompetencyMapFilterInput = {}, $limit: Float! = 1000, $page: Float! = 0, $order: PlatformCompetencyMapListOrderInput!) {
  competencyMaps(limit: $limit, page: $page, filter: $filter, order: $order) {
    data {
      id
      title
      grades
      comment
    }
    totalCount
  }
}
    `;

/**
 * __useCompetencyMapOptionsQuery__
 *
 * To run a query within a React component, call `useCompetencyMapOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetencyMapOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetencyMapOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCompetencyMapOptionsQuery(baseOptions: Apollo.QueryHookOptions<CompetencyMapOptionsQuery, CompetencyMapOptionsQueryVariables> & ({ variables: CompetencyMapOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetencyMapOptionsQuery, CompetencyMapOptionsQueryVariables>(CompetencyMapOptionsDocument, options);
      }
export function useCompetencyMapOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetencyMapOptionsQuery, CompetencyMapOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetencyMapOptionsQuery, CompetencyMapOptionsQueryVariables>(CompetencyMapOptionsDocument, options);
        }
export function useCompetencyMapOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyMapOptionsQuery, CompetencyMapOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetencyMapOptionsQuery, CompetencyMapOptionsQueryVariables>(CompetencyMapOptionsDocument, options);
        }
export type CompetencyMapOptionsQueryHookResult = ReturnType<typeof useCompetencyMapOptionsQuery>;
export type CompetencyMapOptionsLazyQueryHookResult = ReturnType<typeof useCompetencyMapOptionsLazyQuery>;
export type CompetencyMapOptionsSuspenseQueryHookResult = ReturnType<typeof useCompetencyMapOptionsSuspenseQuery>;
export type CompetencyMapOptionsQueryResult = Apollo.QueryResult<CompetencyMapOptionsQuery, CompetencyMapOptionsQueryVariables>;
export const CompetencyMapQuestionsDocument = gql`
    query competencyMapQuestions($competencyMapId: ID!) {
  competencyMap(competencyMapId: $competencyMapId) {
    id
    questionsTime
    competences {
      id
      title
      knowledgeBlockCompetences {
        id
        knowledgeBlock {
          id
          title
          skills {
            id
            title
            questions {
              id
              confirmation
              text
              criterion
              time
              grade
              recommendedTime
              microCriterion
              type
              subtype
              language
              referenceAnswer
              parts {
                id
                content
                isCorrect
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCompetencyMapQuestionsQuery__
 *
 * To run a query within a React component, call `useCompetencyMapQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetencyMapQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetencyMapQuestionsQuery({
 *   variables: {
 *      competencyMapId: // value for 'competencyMapId'
 *   },
 * });
 */
export function useCompetencyMapQuestionsQuery(baseOptions: Apollo.QueryHookOptions<CompetencyMapQuestionsQuery, CompetencyMapQuestionsQueryVariables> & ({ variables: CompetencyMapQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetencyMapQuestionsQuery, CompetencyMapQuestionsQueryVariables>(CompetencyMapQuestionsDocument, options);
      }
export function useCompetencyMapQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetencyMapQuestionsQuery, CompetencyMapQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetencyMapQuestionsQuery, CompetencyMapQuestionsQueryVariables>(CompetencyMapQuestionsDocument, options);
        }
export function useCompetencyMapQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyMapQuestionsQuery, CompetencyMapQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetencyMapQuestionsQuery, CompetencyMapQuestionsQueryVariables>(CompetencyMapQuestionsDocument, options);
        }
export type CompetencyMapQuestionsQueryHookResult = ReturnType<typeof useCompetencyMapQuestionsQuery>;
export type CompetencyMapQuestionsLazyQueryHookResult = ReturnType<typeof useCompetencyMapQuestionsLazyQuery>;
export type CompetencyMapQuestionsSuspenseQueryHookResult = ReturnType<typeof useCompetencyMapQuestionsSuspenseQuery>;
export type CompetencyMapQuestionsQueryResult = Apollo.QueryResult<CompetencyMapQuestionsQuery, CompetencyMapQuestionsQueryVariables>;
export const CompetencyMapsDocument = gql`
    query competencyMaps($filter: ListCompetencyMapFilterInput, $limit: Float!, $page: Float!, $order: PlatformCompetencyMapListOrderInput!) {
  competencyMaps(filter: $filter, page: $page, limit: $limit, order: $order) {
    totalCount
    data {
      id
      numericId
      title
      grades
      competencesCount
      trialsInfo {
        count
        hasStarted
      }
      specialization
      status
      createdAt
      updatedAt
      isRepositoryCheck
      lastTrialDate
      status
      languages
    }
  }
}
    `;

/**
 * __useCompetencyMapsQuery__
 *
 * To run a query within a React component, call `useCompetencyMapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetencyMapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetencyMapsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCompetencyMapsQuery(baseOptions: Apollo.QueryHookOptions<CompetencyMapsQuery, CompetencyMapsQueryVariables> & ({ variables: CompetencyMapsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetencyMapsQuery, CompetencyMapsQueryVariables>(CompetencyMapsDocument, options);
      }
export function useCompetencyMapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetencyMapsQuery, CompetencyMapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetencyMapsQuery, CompetencyMapsQueryVariables>(CompetencyMapsDocument, options);
        }
export function useCompetencyMapsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyMapsQuery, CompetencyMapsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetencyMapsQuery, CompetencyMapsQueryVariables>(CompetencyMapsDocument, options);
        }
export type CompetencyMapsQueryHookResult = ReturnType<typeof useCompetencyMapsQuery>;
export type CompetencyMapsLazyQueryHookResult = ReturnType<typeof useCompetencyMapsLazyQuery>;
export type CompetencyMapsSuspenseQueryHookResult = ReturnType<typeof useCompetencyMapsSuspenseQuery>;
export type CompetencyMapsQueryResult = Apollo.QueryResult<CompetencyMapsQuery, CompetencyMapsQueryVariables>;
export const UploadFileDocument = gql`
    mutation uploadFile($file: Upload!) {
  uploadFile(file: $file) {
    id
    url
  }
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;
export const CreateOrUpdateKnowledgeBlockDocument = gql`
    mutation createOrUpdateKnowledgeBlock($input: CreateOrUpdateKnowledgeBlockInput!) {
  createOrUpdateKnowledgeBlock(input: $input) {
    id
    title
    grades
    createdAt
    updatedAt
    competenceMaps {
      id
      title
    }
    grades
    profession
  }
}
    `;
export type CreateOrUpdateKnowledgeBlockMutationFn = Apollo.MutationFunction<CreateOrUpdateKnowledgeBlockMutation, CreateOrUpdateKnowledgeBlockMutationVariables>;

/**
 * __useCreateOrUpdateKnowledgeBlockMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateKnowledgeBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateKnowledgeBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateKnowledgeBlockMutation, { data, loading, error }] = useCreateOrUpdateKnowledgeBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateKnowledgeBlockMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateKnowledgeBlockMutation, CreateOrUpdateKnowledgeBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateKnowledgeBlockMutation, CreateOrUpdateKnowledgeBlockMutationVariables>(CreateOrUpdateKnowledgeBlockDocument, options);
      }
export type CreateOrUpdateKnowledgeBlockMutationHookResult = ReturnType<typeof useCreateOrUpdateKnowledgeBlockMutation>;
export type CreateOrUpdateKnowledgeBlockMutationResult = Apollo.MutationResult<CreateOrUpdateKnowledgeBlockMutation>;
export type CreateOrUpdateKnowledgeBlockMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateKnowledgeBlockMutation, CreateOrUpdateKnowledgeBlockMutationVariables>;
export const DeleteKnowledgeBlockDocument = gql`
    mutation deleteKnowledgeBlock($knowledgeBlockId: ID!) {
  deleteKnowledgeBlock(knowledgeBlockId: $knowledgeBlockId)
}
    `;
export type DeleteKnowledgeBlockMutationFn = Apollo.MutationFunction<DeleteKnowledgeBlockMutation, DeleteKnowledgeBlockMutationVariables>;

/**
 * __useDeleteKnowledgeBlockMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeBlockMutation, { data, loading, error }] = useDeleteKnowledgeBlockMutation({
 *   variables: {
 *      knowledgeBlockId: // value for 'knowledgeBlockId'
 *   },
 * });
 */
export function useDeleteKnowledgeBlockMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKnowledgeBlockMutation, DeleteKnowledgeBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKnowledgeBlockMutation, DeleteKnowledgeBlockMutationVariables>(DeleteKnowledgeBlockDocument, options);
      }
export type DeleteKnowledgeBlockMutationHookResult = ReturnType<typeof useDeleteKnowledgeBlockMutation>;
export type DeleteKnowledgeBlockMutationResult = Apollo.MutationResult<DeleteKnowledgeBlockMutation>;
export type DeleteKnowledgeBlockMutationOptions = Apollo.BaseMutationOptions<DeleteKnowledgeBlockMutation, DeleteKnowledgeBlockMutationVariables>;
export const GetUniqProfessionDocument = gql`
    query getUniqProfession($search: String) {
  getUniqProfession(search: $search)
}
    `;

/**
 * __useGetUniqProfessionQuery__
 *
 * To run a query within a React component, call `useGetUniqProfessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqProfessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqProfessionQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetUniqProfessionQuery(baseOptions?: Apollo.QueryHookOptions<GetUniqProfessionQuery, GetUniqProfessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniqProfessionQuery, GetUniqProfessionQueryVariables>(GetUniqProfessionDocument, options);
      }
export function useGetUniqProfessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniqProfessionQuery, GetUniqProfessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniqProfessionQuery, GetUniqProfessionQueryVariables>(GetUniqProfessionDocument, options);
        }
export function useGetUniqProfessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniqProfessionQuery, GetUniqProfessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniqProfessionQuery, GetUniqProfessionQueryVariables>(GetUniqProfessionDocument, options);
        }
export type GetUniqProfessionQueryHookResult = ReturnType<typeof useGetUniqProfessionQuery>;
export type GetUniqProfessionLazyQueryHookResult = ReturnType<typeof useGetUniqProfessionLazyQuery>;
export type GetUniqProfessionSuspenseQueryHookResult = ReturnType<typeof useGetUniqProfessionSuspenseQuery>;
export type GetUniqProfessionQueryResult = Apollo.QueryResult<GetUniqProfessionQuery, GetUniqProfessionQueryVariables>;
export const KnowledgeBlockDocument = gql`
    query knowledgeBlock($knowledgeBlockId: ID!) {
  knowledgeBlock(knowledgeBlockId: $knowledgeBlockId) {
    id
    title
    grades
    createdAt
    updatedAt
    competenceMaps {
      id
      title
    }
    grades
    profession
  }
}
    `;

/**
 * __useKnowledgeBlockQuery__
 *
 * To run a query within a React component, call `useKnowledgeBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBlockQuery({
 *   variables: {
 *      knowledgeBlockId: // value for 'knowledgeBlockId'
 *   },
 * });
 */
export function useKnowledgeBlockQuery(baseOptions: Apollo.QueryHookOptions<KnowledgeBlockQuery, KnowledgeBlockQueryVariables> & ({ variables: KnowledgeBlockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeBlockQuery, KnowledgeBlockQueryVariables>(KnowledgeBlockDocument, options);
      }
export function useKnowledgeBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeBlockQuery, KnowledgeBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeBlockQuery, KnowledgeBlockQueryVariables>(KnowledgeBlockDocument, options);
        }
export function useKnowledgeBlockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KnowledgeBlockQuery, KnowledgeBlockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KnowledgeBlockQuery, KnowledgeBlockQueryVariables>(KnowledgeBlockDocument, options);
        }
export type KnowledgeBlockQueryHookResult = ReturnType<typeof useKnowledgeBlockQuery>;
export type KnowledgeBlockLazyQueryHookResult = ReturnType<typeof useKnowledgeBlockLazyQuery>;
export type KnowledgeBlockSuspenseQueryHookResult = ReturnType<typeof useKnowledgeBlockSuspenseQuery>;
export type KnowledgeBlockQueryResult = Apollo.QueryResult<KnowledgeBlockQuery, KnowledgeBlockQueryVariables>;
export const KnowledgeBlockHeaderDocument = gql`
    query knowledgeBlockHeader($knowledgeBlockId: ID!) {
  knowledgeBlock(knowledgeBlockId: $knowledgeBlockId) {
    id
    title
  }
}
    `;

/**
 * __useKnowledgeBlockHeaderQuery__
 *
 * To run a query within a React component, call `useKnowledgeBlockHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBlockHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBlockHeaderQuery({
 *   variables: {
 *      knowledgeBlockId: // value for 'knowledgeBlockId'
 *   },
 * });
 */
export function useKnowledgeBlockHeaderQuery(baseOptions: Apollo.QueryHookOptions<KnowledgeBlockHeaderQuery, KnowledgeBlockHeaderQueryVariables> & ({ variables: KnowledgeBlockHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeBlockHeaderQuery, KnowledgeBlockHeaderQueryVariables>(KnowledgeBlockHeaderDocument, options);
      }
export function useKnowledgeBlockHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeBlockHeaderQuery, KnowledgeBlockHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeBlockHeaderQuery, KnowledgeBlockHeaderQueryVariables>(KnowledgeBlockHeaderDocument, options);
        }
export function useKnowledgeBlockHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KnowledgeBlockHeaderQuery, KnowledgeBlockHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KnowledgeBlockHeaderQuery, KnowledgeBlockHeaderQueryVariables>(KnowledgeBlockHeaderDocument, options);
        }
export type KnowledgeBlockHeaderQueryHookResult = ReturnType<typeof useKnowledgeBlockHeaderQuery>;
export type KnowledgeBlockHeaderLazyQueryHookResult = ReturnType<typeof useKnowledgeBlockHeaderLazyQuery>;
export type KnowledgeBlockHeaderSuspenseQueryHookResult = ReturnType<typeof useKnowledgeBlockHeaderSuspenseQuery>;
export type KnowledgeBlockHeaderQueryResult = Apollo.QueryResult<KnowledgeBlockHeaderQuery, KnowledgeBlockHeaderQueryVariables>;
export const KnowledgeBlockOptionsDocument = gql`
    query knowledgeBlockOptions($filter: ListKnowledgeBlockFilterInput = {}, $limit: Float! = 100, $page: Float! = 0) {
  knowledgeBlocks(filter: $filter, page: $page, limit: $limit) {
    totalCount
    data {
      id
      title
      profession
      grades
      skills {
        id
        title
        grades
        confirmedQuestionsCount
        notConfirmedQuestionsCount
      }
    }
  }
}
    `;

/**
 * __useKnowledgeBlockOptionsQuery__
 *
 * To run a query within a React component, call `useKnowledgeBlockOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBlockOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBlockOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useKnowledgeBlockOptionsQuery(baseOptions?: Apollo.QueryHookOptions<KnowledgeBlockOptionsQuery, KnowledgeBlockOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeBlockOptionsQuery, KnowledgeBlockOptionsQueryVariables>(KnowledgeBlockOptionsDocument, options);
      }
export function useKnowledgeBlockOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeBlockOptionsQuery, KnowledgeBlockOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeBlockOptionsQuery, KnowledgeBlockOptionsQueryVariables>(KnowledgeBlockOptionsDocument, options);
        }
export function useKnowledgeBlockOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KnowledgeBlockOptionsQuery, KnowledgeBlockOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KnowledgeBlockOptionsQuery, KnowledgeBlockOptionsQueryVariables>(KnowledgeBlockOptionsDocument, options);
        }
export type KnowledgeBlockOptionsQueryHookResult = ReturnType<typeof useKnowledgeBlockOptionsQuery>;
export type KnowledgeBlockOptionsLazyQueryHookResult = ReturnType<typeof useKnowledgeBlockOptionsLazyQuery>;
export type KnowledgeBlockOptionsSuspenseQueryHookResult = ReturnType<typeof useKnowledgeBlockOptionsSuspenseQuery>;
export type KnowledgeBlockOptionsQueryResult = Apollo.QueryResult<KnowledgeBlockOptionsQuery, KnowledgeBlockOptionsQueryVariables>;
export const KnowledgeBlockOptionsWithSkillsDocument = gql`
    query knowledgeBlockOptionsWithSkills($filter: ListKnowledgeBlockFilterInput = {}, $limit: Float! = 100, $page: Float! = 0) {
  knowledgeBlocks(filter: $filter, page: $page, limit: $limit) {
    totalCount
    data {
      id
      title
      grades
      profession
      skills {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useKnowledgeBlockOptionsWithSkillsQuery__
 *
 * To run a query within a React component, call `useKnowledgeBlockOptionsWithSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBlockOptionsWithSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBlockOptionsWithSkillsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useKnowledgeBlockOptionsWithSkillsQuery(baseOptions?: Apollo.QueryHookOptions<KnowledgeBlockOptionsWithSkillsQuery, KnowledgeBlockOptionsWithSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeBlockOptionsWithSkillsQuery, KnowledgeBlockOptionsWithSkillsQueryVariables>(KnowledgeBlockOptionsWithSkillsDocument, options);
      }
export function useKnowledgeBlockOptionsWithSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeBlockOptionsWithSkillsQuery, KnowledgeBlockOptionsWithSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeBlockOptionsWithSkillsQuery, KnowledgeBlockOptionsWithSkillsQueryVariables>(KnowledgeBlockOptionsWithSkillsDocument, options);
        }
export function useKnowledgeBlockOptionsWithSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KnowledgeBlockOptionsWithSkillsQuery, KnowledgeBlockOptionsWithSkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KnowledgeBlockOptionsWithSkillsQuery, KnowledgeBlockOptionsWithSkillsQueryVariables>(KnowledgeBlockOptionsWithSkillsDocument, options);
        }
export type KnowledgeBlockOptionsWithSkillsQueryHookResult = ReturnType<typeof useKnowledgeBlockOptionsWithSkillsQuery>;
export type KnowledgeBlockOptionsWithSkillsLazyQueryHookResult = ReturnType<typeof useKnowledgeBlockOptionsWithSkillsLazyQuery>;
export type KnowledgeBlockOptionsWithSkillsSuspenseQueryHookResult = ReturnType<typeof useKnowledgeBlockOptionsWithSkillsSuspenseQuery>;
export type KnowledgeBlockOptionsWithSkillsQueryResult = Apollo.QueryResult<KnowledgeBlockOptionsWithSkillsQuery, KnowledgeBlockOptionsWithSkillsQueryVariables>;
export const KnowledgeBlockSpecializationsDocument = gql`
    query knowledgeBlockSpecializations {
  knowledgeBlockSpecializations
}
    `;

/**
 * __useKnowledgeBlockSpecializationsQuery__
 *
 * To run a query within a React component, call `useKnowledgeBlockSpecializationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBlockSpecializationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBlockSpecializationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useKnowledgeBlockSpecializationsQuery(baseOptions?: Apollo.QueryHookOptions<KnowledgeBlockSpecializationsQuery, KnowledgeBlockSpecializationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeBlockSpecializationsQuery, KnowledgeBlockSpecializationsQueryVariables>(KnowledgeBlockSpecializationsDocument, options);
      }
export function useKnowledgeBlockSpecializationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeBlockSpecializationsQuery, KnowledgeBlockSpecializationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeBlockSpecializationsQuery, KnowledgeBlockSpecializationsQueryVariables>(KnowledgeBlockSpecializationsDocument, options);
        }
export function useKnowledgeBlockSpecializationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KnowledgeBlockSpecializationsQuery, KnowledgeBlockSpecializationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KnowledgeBlockSpecializationsQuery, KnowledgeBlockSpecializationsQueryVariables>(KnowledgeBlockSpecializationsDocument, options);
        }
export type KnowledgeBlockSpecializationsQueryHookResult = ReturnType<typeof useKnowledgeBlockSpecializationsQuery>;
export type KnowledgeBlockSpecializationsLazyQueryHookResult = ReturnType<typeof useKnowledgeBlockSpecializationsLazyQuery>;
export type KnowledgeBlockSpecializationsSuspenseQueryHookResult = ReturnType<typeof useKnowledgeBlockSpecializationsSuspenseQuery>;
export type KnowledgeBlockSpecializationsQueryResult = Apollo.QueryResult<KnowledgeBlockSpecializationsQuery, KnowledgeBlockSpecializationsQueryVariables>;
export const KnowledgeBlocksDocument = gql`
    query knowledgeBlocks($filter: ListKnowledgeBlockFilterInput, $limit: Float!, $page: Float!) {
  knowledgeBlocks(filter: $filter, page: $page, limit: $limit) {
    totalCount
    data {
      id
      title
      grades
      skills {
        id
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useKnowledgeBlocksQuery__
 *
 * To run a query within a React component, call `useKnowledgeBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBlocksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useKnowledgeBlocksQuery(baseOptions: Apollo.QueryHookOptions<KnowledgeBlocksQuery, KnowledgeBlocksQueryVariables> & ({ variables: KnowledgeBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeBlocksQuery, KnowledgeBlocksQueryVariables>(KnowledgeBlocksDocument, options);
      }
export function useKnowledgeBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeBlocksQuery, KnowledgeBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeBlocksQuery, KnowledgeBlocksQueryVariables>(KnowledgeBlocksDocument, options);
        }
export function useKnowledgeBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KnowledgeBlocksQuery, KnowledgeBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KnowledgeBlocksQuery, KnowledgeBlocksQueryVariables>(KnowledgeBlocksDocument, options);
        }
export type KnowledgeBlocksQueryHookResult = ReturnType<typeof useKnowledgeBlocksQuery>;
export type KnowledgeBlocksLazyQueryHookResult = ReturnType<typeof useKnowledgeBlocksLazyQuery>;
export type KnowledgeBlocksSuspenseQueryHookResult = ReturnType<typeof useKnowledgeBlocksSuspenseQuery>;
export type KnowledgeBlocksQueryResult = Apollo.QueryResult<KnowledgeBlocksQuery, KnowledgeBlocksQueryVariables>;
export const ConfirmOrRejectQuestionDocument = gql`
    mutation confirmOrRejectQuestion($questionId: ID!) {
  confirmOrRejectQuestion(questionId: $questionId) {
    id
    time
    text
    criterion
    confirmation
    grade
    recommendedTime
    type
    subtype
  }
}
    `;
export type ConfirmOrRejectQuestionMutationFn = Apollo.MutationFunction<ConfirmOrRejectQuestionMutation, ConfirmOrRejectQuestionMutationVariables>;

/**
 * __useConfirmOrRejectQuestionMutation__
 *
 * To run a mutation, you first call `useConfirmOrRejectQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOrRejectQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOrRejectQuestionMutation, { data, loading, error }] = useConfirmOrRejectQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useConfirmOrRejectQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmOrRejectQuestionMutation, ConfirmOrRejectQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmOrRejectQuestionMutation, ConfirmOrRejectQuestionMutationVariables>(ConfirmOrRejectQuestionDocument, options);
      }
export type ConfirmOrRejectQuestionMutationHookResult = ReturnType<typeof useConfirmOrRejectQuestionMutation>;
export type ConfirmOrRejectQuestionMutationResult = Apollo.MutationResult<ConfirmOrRejectQuestionMutation>;
export type ConfirmOrRejectQuestionMutationOptions = Apollo.BaseMutationOptions<ConfirmOrRejectQuestionMutation, ConfirmOrRejectQuestionMutationVariables>;
export const CreateOrUpdateQuestionDocument = gql`
    mutation createOrUpdateQuestion($input: CreateOrUpdateQuestionInput!) {
  createOrUpdateQuestion(input: $input) {
    id
  }
}
    `;
export type CreateOrUpdateQuestionMutationFn = Apollo.MutationFunction<CreateOrUpdateQuestionMutation, CreateOrUpdateQuestionMutationVariables>;

/**
 * __useCreateOrUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateQuestionMutation, { data, loading, error }] = useCreateOrUpdateQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateQuestionMutation, CreateOrUpdateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateQuestionMutation, CreateOrUpdateQuestionMutationVariables>(CreateOrUpdateQuestionDocument, options);
      }
export type CreateOrUpdateQuestionMutationHookResult = ReturnType<typeof useCreateOrUpdateQuestionMutation>;
export type CreateOrUpdateQuestionMutationResult = Apollo.MutationResult<CreateOrUpdateQuestionMutation>;
export type CreateOrUpdateQuestionMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateQuestionMutation, CreateOrUpdateQuestionMutationVariables>;
export const DeleteQuestionDocument = gql`
    mutation deleteQuestion($questionId: ID!) {
  deleteQuestion(questionId: $questionId)
}
    `;
export type DeleteQuestionMutationFn = Apollo.MutationFunction<DeleteQuestionMutation, DeleteQuestionMutationVariables>;

/**
 * __useDeleteQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionMutation, { data, loading, error }] = useDeleteQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useDeleteQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuestionMutation, DeleteQuestionMutationVariables>(DeleteQuestionDocument, options);
      }
export type DeleteQuestionMutationHookResult = ReturnType<typeof useDeleteQuestionMutation>;
export type DeleteQuestionMutationResult = Apollo.MutationResult<DeleteQuestionMutation>;
export type DeleteQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteQuestionMutation, DeleteQuestionMutationVariables>;
export const GenerateQuestionsDocument = gql`
    mutation generateQuestions($input: InitGenerateQuestionsInput!) {
  initGenerateQuestions(input: $input)
}
    `;
export type GenerateQuestionsMutationFn = Apollo.MutationFunction<GenerateQuestionsMutation, GenerateQuestionsMutationVariables>;

/**
 * __useGenerateQuestionsMutation__
 *
 * To run a mutation, you first call `useGenerateQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateQuestionsMutation, { data, loading, error }] = useGenerateQuestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateQuestionsMutation, GenerateQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateQuestionsMutation, GenerateQuestionsMutationVariables>(GenerateQuestionsDocument, options);
      }
export type GenerateQuestionsMutationHookResult = ReturnType<typeof useGenerateQuestionsMutation>;
export type GenerateQuestionsMutationResult = Apollo.MutationResult<GenerateQuestionsMutation>;
export type GenerateQuestionsMutationOptions = Apollo.BaseMutationOptions<GenerateQuestionsMutation, GenerateQuestionsMutationVariables>;
export const RegenerateQuestionDocument = gql`
    mutation regenerateQuestion($input: RegenerateQuestionDataInput!) {
  regenerateQuestionSync(input: $input) {
    criterion
    referenceAnswer
    text
  }
}
    `;
export type RegenerateQuestionMutationFn = Apollo.MutationFunction<RegenerateQuestionMutation, RegenerateQuestionMutationVariables>;

/**
 * __useRegenerateQuestionMutation__
 *
 * To run a mutation, you first call `useRegenerateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateQuestionMutation, { data, loading, error }] = useRegenerateQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegenerateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateQuestionMutation, RegenerateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateQuestionMutation, RegenerateQuestionMutationVariables>(RegenerateQuestionDocument, options);
      }
export type RegenerateQuestionMutationHookResult = ReturnType<typeof useRegenerateQuestionMutation>;
export type RegenerateQuestionMutationResult = Apollo.MutationResult<RegenerateQuestionMutation>;
export type RegenerateQuestionMutationOptions = Apollo.BaseMutationOptions<RegenerateQuestionMutation, RegenerateQuestionMutationVariables>;
export const QuestionDocument = gql`
    query question($id: ID!) {
  question(id: $id) {
    id
    confirmation
    text
    criterion
    time
    grade
    recommendedTime
    microCriterion
    type
    subtype
    language
    referenceAnswer
    skill {
      id
    }
    parts {
      id
      content
      isCorrect
    }
  }
}
    `;

/**
 * __useQuestionQuery__
 *
 * To run a query within a React component, call `useQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuestionQuery(baseOptions: Apollo.QueryHookOptions<QuestionQuery, QuestionQueryVariables> & ({ variables: QuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionQuery, QuestionQueryVariables>(QuestionDocument, options);
      }
export function useQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionQuery, QuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionQuery, QuestionQueryVariables>(QuestionDocument, options);
        }
export function useQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionQuery, QuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionQuery, QuestionQueryVariables>(QuestionDocument, options);
        }
export type QuestionQueryHookResult = ReturnType<typeof useQuestionQuery>;
export type QuestionLazyQueryHookResult = ReturnType<typeof useQuestionLazyQuery>;
export type QuestionSuspenseQueryHookResult = ReturnType<typeof useQuestionSuspenseQuery>;
export type QuestionQueryResult = Apollo.QueryResult<QuestionQuery, QuestionQueryVariables>;
export const QuestionSubtypesDocument = gql`
    query questionSubtypes($questionType: [QUESTION_TYPE!]!) {
  questionSubtypes(questionType: $questionType) {
    subtypes
    type
  }
}
    `;

/**
 * __useQuestionSubtypesQuery__
 *
 * To run a query within a React component, call `useQuestionSubtypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionSubtypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionSubtypesQuery({
 *   variables: {
 *      questionType: // value for 'questionType'
 *   },
 * });
 */
export function useQuestionSubtypesQuery(baseOptions: Apollo.QueryHookOptions<QuestionSubtypesQuery, QuestionSubtypesQueryVariables> & ({ variables: QuestionSubtypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionSubtypesQuery, QuestionSubtypesQueryVariables>(QuestionSubtypesDocument, options);
      }
export function useQuestionSubtypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionSubtypesQuery, QuestionSubtypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionSubtypesQuery, QuestionSubtypesQueryVariables>(QuestionSubtypesDocument, options);
        }
export function useQuestionSubtypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuestionSubtypesQuery, QuestionSubtypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuestionSubtypesQuery, QuestionSubtypesQueryVariables>(QuestionSubtypesDocument, options);
        }
export type QuestionSubtypesQueryHookResult = ReturnType<typeof useQuestionSubtypesQuery>;
export type QuestionSubtypesLazyQueryHookResult = ReturnType<typeof useQuestionSubtypesLazyQuery>;
export type QuestionSubtypesSuspenseQueryHookResult = ReturnType<typeof useQuestionSubtypesSuspenseQuery>;
export type QuestionSubtypesQueryResult = Apollo.QueryResult<QuestionSubtypesQuery, QuestionSubtypesQueryVariables>;
export const CreateOrUpdateSkillDocument = gql`
    mutation createOrUpdateSkill($input: CreateOrUpdateSkillInput!) {
  createOrUpdateSkill(input: $input) {
    id
    title
    knowledgeBlock {
      id
      title
      profession
    }
    grades
    createdAt
    updatedAt
    questions {
      id
      confirmation
      text
      criterion
      time
      microCriterion
      type
      subtype
    }
  }
}
    `;
export type CreateOrUpdateSkillMutationFn = Apollo.MutationFunction<CreateOrUpdateSkillMutation, CreateOrUpdateSkillMutationVariables>;

/**
 * __useCreateOrUpdateSkillMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateSkillMutation, { data, loading, error }] = useCreateOrUpdateSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateSkillMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateSkillMutation, CreateOrUpdateSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateSkillMutation, CreateOrUpdateSkillMutationVariables>(CreateOrUpdateSkillDocument, options);
      }
export type CreateOrUpdateSkillMutationHookResult = ReturnType<typeof useCreateOrUpdateSkillMutation>;
export type CreateOrUpdateSkillMutationResult = Apollo.MutationResult<CreateOrUpdateSkillMutation>;
export type CreateOrUpdateSkillMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateSkillMutation, CreateOrUpdateSkillMutationVariables>;
export const DeleteSkillDocument = gql`
    mutation deleteSkill($skillId: ID!) {
  deleteSkill(skillId: $skillId)
}
    `;
export type DeleteSkillMutationFn = Apollo.MutationFunction<DeleteSkillMutation, DeleteSkillMutationVariables>;

/**
 * __useDeleteSkillMutation__
 *
 * To run a mutation, you first call `useDeleteSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSkillMutation, { data, loading, error }] = useDeleteSkillMutation({
 *   variables: {
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useDeleteSkillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSkillMutation, DeleteSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSkillMutation, DeleteSkillMutationVariables>(DeleteSkillDocument, options);
      }
export type DeleteSkillMutationHookResult = ReturnType<typeof useDeleteSkillMutation>;
export type DeleteSkillMutationResult = Apollo.MutationResult<DeleteSkillMutation>;
export type DeleteSkillMutationOptions = Apollo.BaseMutationOptions<DeleteSkillMutation, DeleteSkillMutationVariables>;
export const SkillDocument = gql`
    query skill($skillId: ID!) {
  skill(skillId: $skillId) {
    id
    title
    knowledgeBlock {
      id
      title
      profession
    }
    grades
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSkillQuery__
 *
 * To run a query within a React component, call `useSkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillQuery({
 *   variables: {
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useSkillQuery(baseOptions: Apollo.QueryHookOptions<SkillQuery, SkillQueryVariables> & ({ variables: SkillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillQuery, SkillQueryVariables>(SkillDocument, options);
      }
export function useSkillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillQuery, SkillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillQuery, SkillQueryVariables>(SkillDocument, options);
        }
export function useSkillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillQuery, SkillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillQuery, SkillQueryVariables>(SkillDocument, options);
        }
export type SkillQueryHookResult = ReturnType<typeof useSkillQuery>;
export type SkillLazyQueryHookResult = ReturnType<typeof useSkillLazyQuery>;
export type SkillSuspenseQueryHookResult = ReturnType<typeof useSkillSuspenseQuery>;
export type SkillQueryResult = Apollo.QueryResult<SkillQuery, SkillQueryVariables>;
export const SkillBasicDocument = gql`
    query skillBasic($skillId: ID!) {
  skill(skillId: $skillId) {
    id
    title
    knowledgeBlock {
      id
      title
    }
  }
}
    `;

/**
 * __useSkillBasicQuery__
 *
 * To run a query within a React component, call `useSkillBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillBasicQuery({
 *   variables: {
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useSkillBasicQuery(baseOptions: Apollo.QueryHookOptions<SkillBasicQuery, SkillBasicQueryVariables> & ({ variables: SkillBasicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillBasicQuery, SkillBasicQueryVariables>(SkillBasicDocument, options);
      }
export function useSkillBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillBasicQuery, SkillBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillBasicQuery, SkillBasicQueryVariables>(SkillBasicDocument, options);
        }
export function useSkillBasicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillBasicQuery, SkillBasicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillBasicQuery, SkillBasicQueryVariables>(SkillBasicDocument, options);
        }
export type SkillBasicQueryHookResult = ReturnType<typeof useSkillBasicQuery>;
export type SkillBasicLazyQueryHookResult = ReturnType<typeof useSkillBasicLazyQuery>;
export type SkillBasicSuspenseQueryHookResult = ReturnType<typeof useSkillBasicSuspenseQuery>;
export type SkillBasicQueryResult = Apollo.QueryResult<SkillBasicQuery, SkillBasicQueryVariables>;
export const SkillGenQuestionsLogDocument = gql`
    query skillGenQuestionsLog($skillId: ID!) {
  skillGenQuestionsLog(skillId: $skillId) {
    id
    status
    createdAt
  }
}
    `;

/**
 * __useSkillGenQuestionsLogQuery__
 *
 * To run a query within a React component, call `useSkillGenQuestionsLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillGenQuestionsLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillGenQuestionsLogQuery({
 *   variables: {
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useSkillGenQuestionsLogQuery(baseOptions: Apollo.QueryHookOptions<SkillGenQuestionsLogQuery, SkillGenQuestionsLogQueryVariables> & ({ variables: SkillGenQuestionsLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillGenQuestionsLogQuery, SkillGenQuestionsLogQueryVariables>(SkillGenQuestionsLogDocument, options);
      }
export function useSkillGenQuestionsLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillGenQuestionsLogQuery, SkillGenQuestionsLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillGenQuestionsLogQuery, SkillGenQuestionsLogQueryVariables>(SkillGenQuestionsLogDocument, options);
        }
export function useSkillGenQuestionsLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillGenQuestionsLogQuery, SkillGenQuestionsLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillGenQuestionsLogQuery, SkillGenQuestionsLogQueryVariables>(SkillGenQuestionsLogDocument, options);
        }
export type SkillGenQuestionsLogQueryHookResult = ReturnType<typeof useSkillGenQuestionsLogQuery>;
export type SkillGenQuestionsLogLazyQueryHookResult = ReturnType<typeof useSkillGenQuestionsLogLazyQuery>;
export type SkillGenQuestionsLogSuspenseQueryHookResult = ReturnType<typeof useSkillGenQuestionsLogSuspenseQuery>;
export type SkillGenQuestionsLogQueryResult = Apollo.QueryResult<SkillGenQuestionsLogQuery, SkillGenQuestionsLogQueryVariables>;
export const SkillQuestionsDocument = gql`
    query skillQuestions($skillId: ID!) {
  skill(skillId: $skillId) {
    id
    questions {
      id
      confirmation
      text
      criterion
      time
      grade
      recommendedTime
      microCriterion
      type
      subtype
      language
      referenceAnswer
      parts {
        id
        content
        isCorrect
      }
    }
  }
}
    `;

/**
 * __useSkillQuestionsQuery__
 *
 * To run a query within a React component, call `useSkillQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillQuestionsQuery({
 *   variables: {
 *      skillId: // value for 'skillId'
 *   },
 * });
 */
export function useSkillQuestionsQuery(baseOptions: Apollo.QueryHookOptions<SkillQuestionsQuery, SkillQuestionsQueryVariables> & ({ variables: SkillQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillQuestionsQuery, SkillQuestionsQueryVariables>(SkillQuestionsDocument, options);
      }
export function useSkillQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillQuestionsQuery, SkillQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillQuestionsQuery, SkillQuestionsQueryVariables>(SkillQuestionsDocument, options);
        }
export function useSkillQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillQuestionsQuery, SkillQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillQuestionsQuery, SkillQuestionsQueryVariables>(SkillQuestionsDocument, options);
        }
export type SkillQuestionsQueryHookResult = ReturnType<typeof useSkillQuestionsQuery>;
export type SkillQuestionsLazyQueryHookResult = ReturnType<typeof useSkillQuestionsLazyQuery>;
export type SkillQuestionsSuspenseQueryHookResult = ReturnType<typeof useSkillQuestionsSuspenseQuery>;
export type SkillQuestionsQueryResult = Apollo.QueryResult<SkillQuestionsQuery, SkillQuestionsQueryVariables>;
export const SkillsDocument = gql`
    query skills($filter: ListSkillFilterInput!, $limit: Float!, $page: Float!) {
  skills(filter: $filter, page: $page, limit: $limit) {
    totalCount
    data {
      id
      title
      grades
      confirmedQuestionsCount
      knowledgeBlock {
        id
        title
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useSkillsQuery__
 *
 * To run a query within a React component, call `useSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSkillsQuery(baseOptions: Apollo.QueryHookOptions<SkillsQuery, SkillsQueryVariables> & ({ variables: SkillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillsQuery, SkillsQueryVariables>(SkillsDocument, options);
      }
export function useSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillsQuery, SkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillsQuery, SkillsQueryVariables>(SkillsDocument, options);
        }
export function useSkillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillsQuery, SkillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillsQuery, SkillsQueryVariables>(SkillsDocument, options);
        }
export type SkillsQueryHookResult = ReturnType<typeof useSkillsQuery>;
export type SkillsLazyQueryHookResult = ReturnType<typeof useSkillsLazyQuery>;
export type SkillsSuspenseQueryHookResult = ReturnType<typeof useSkillsSuspenseQuery>;
export type SkillsQueryResult = Apollo.QueryResult<SkillsQuery, SkillsQueryVariables>;
export const AddCompanyCandidatesToExaminationDocument = gql`
    mutation addCompanyCandidatesToExamination($input: AddCompanyCandidatesToExaminationInput!) {
  addCompanyCandidatesToExamination(input: $input) {
    id
  }
}
    `;
export type AddCompanyCandidatesToExaminationMutationFn = Apollo.MutationFunction<AddCompanyCandidatesToExaminationMutation, AddCompanyCandidatesToExaminationMutationVariables>;

/**
 * __useAddCompanyCandidatesToExaminationMutation__
 *
 * To run a mutation, you first call `useAddCompanyCandidatesToExaminationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyCandidatesToExaminationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyCandidatesToExaminationMutation, { data, loading, error }] = useAddCompanyCandidatesToExaminationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCompanyCandidatesToExaminationMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyCandidatesToExaminationMutation, AddCompanyCandidatesToExaminationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyCandidatesToExaminationMutation, AddCompanyCandidatesToExaminationMutationVariables>(AddCompanyCandidatesToExaminationDocument, options);
      }
export type AddCompanyCandidatesToExaminationMutationHookResult = ReturnType<typeof useAddCompanyCandidatesToExaminationMutation>;
export type AddCompanyCandidatesToExaminationMutationResult = Apollo.MutationResult<AddCompanyCandidatesToExaminationMutation>;
export type AddCompanyCandidatesToExaminationMutationOptions = Apollo.BaseMutationOptions<AddCompanyCandidatesToExaminationMutation, AddCompanyCandidatesToExaminationMutationVariables>;
export const CancelExaminationDocument = gql`
    mutation cancelExamination($examinationId: ID!) {
  cancelExamination(examinationId: $examinationId)
}
    `;
export type CancelExaminationMutationFn = Apollo.MutationFunction<CancelExaminationMutation, CancelExaminationMutationVariables>;

/**
 * __useCancelExaminationMutation__
 *
 * To run a mutation, you first call `useCancelExaminationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelExaminationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelExaminationMutation, { data, loading, error }] = useCancelExaminationMutation({
 *   variables: {
 *      examinationId: // value for 'examinationId'
 *   },
 * });
 */
export function useCancelExaminationMutation(baseOptions?: Apollo.MutationHookOptions<CancelExaminationMutation, CancelExaminationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelExaminationMutation, CancelExaminationMutationVariables>(CancelExaminationDocument, options);
      }
export type CancelExaminationMutationHookResult = ReturnType<typeof useCancelExaminationMutation>;
export type CancelExaminationMutationResult = Apollo.MutationResult<CancelExaminationMutation>;
export type CancelExaminationMutationOptions = Apollo.BaseMutationOptions<CancelExaminationMutation, CancelExaminationMutationVariables>;
export const CreateExaminationDocument = gql`
    mutation createExamination($input: CreateExaminationInput!) {
  createExamination(input: $input) {
    id
    numericId
    competencyMap {
      id
      title
      comment
      grades
    }
    createdAt
    type
    trials {
      id
    }
  }
}
    `;
export type CreateExaminationMutationFn = Apollo.MutationFunction<CreateExaminationMutation, CreateExaminationMutationVariables>;

/**
 * __useCreateExaminationMutation__
 *
 * To run a mutation, you first call `useCreateExaminationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExaminationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExaminationMutation, { data, loading, error }] = useCreateExaminationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExaminationMutation(baseOptions?: Apollo.MutationHookOptions<CreateExaminationMutation, CreateExaminationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExaminationMutation, CreateExaminationMutationVariables>(CreateExaminationDocument, options);
      }
export type CreateExaminationMutationHookResult = ReturnType<typeof useCreateExaminationMutation>;
export type CreateExaminationMutationResult = Apollo.MutationResult<CreateExaminationMutation>;
export type CreateExaminationMutationOptions = Apollo.BaseMutationOptions<CreateExaminationMutation, CreateExaminationMutationVariables>;
export const UpdatePersonalTrialDocument = gql`
    mutation updatePersonalTrial($input: UpdateTrialInput!) {
  updatePersonalTrial(input: $input) {
    id
    comment
    status
    numericId
    companyCandidate {
      id
      fullName
      candidateUsername {
        id
        telegramUsername
        candidate {
          id
          phoneNumber
        }
      }
      email
      grade
    }
    examination {
      id
      competencyMap {
        id
        title
        comment
        grades
      }
    }
    createdAt
    trialStatusHistory {
      id
      newStatus
      createdAt
    }
  }
}
    `;
export type UpdatePersonalTrialMutationFn = Apollo.MutationFunction<UpdatePersonalTrialMutation, UpdatePersonalTrialMutationVariables>;

/**
 * __useUpdatePersonalTrialMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalTrialMutation, { data, loading, error }] = useUpdatePersonalTrialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePersonalTrialMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonalTrialMutation, UpdatePersonalTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonalTrialMutation, UpdatePersonalTrialMutationVariables>(UpdatePersonalTrialDocument, options);
      }
export type UpdatePersonalTrialMutationHookResult = ReturnType<typeof useUpdatePersonalTrialMutation>;
export type UpdatePersonalTrialMutationResult = Apollo.MutationResult<UpdatePersonalTrialMutation>;
export type UpdatePersonalTrialMutationOptions = Apollo.BaseMutationOptions<UpdatePersonalTrialMutation, UpdatePersonalTrialMutationVariables>;
export const GenerateReportFileDocument = gql`
    mutation generateReportFile($input: GenerateReportFileInput!) {
  generateReportFile(input: $input) {
    id
    trial {
      id
      numericId
      completedAt
      examination {
        id
        numericId
        title
        competencyMap {
          id
          title
        }
      }
      companyCandidate {
        id
        fullName
      }
    }
    file {
      id
      url
    }
  }
}
    `;
export type GenerateReportFileMutationFn = Apollo.MutationFunction<GenerateReportFileMutation, GenerateReportFileMutationVariables>;

/**
 * __useGenerateReportFileMutation__
 *
 * To run a mutation, you first call `useGenerateReportFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportFileMutation, { data, loading, error }] = useGenerateReportFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateReportFileMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReportFileMutation, GenerateReportFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReportFileMutation, GenerateReportFileMutationVariables>(GenerateReportFileDocument, options);
      }
export type GenerateReportFileMutationHookResult = ReturnType<typeof useGenerateReportFileMutation>;
export type GenerateReportFileMutationResult = Apollo.MutationResult<GenerateReportFileMutation>;
export type GenerateReportFileMutationOptions = Apollo.BaseMutationOptions<GenerateReportFileMutation, GenerateReportFileMutationVariables>;
export const CancelTrialDocument = gql`
    mutation cancelTrial($trialId: ID!) {
  cancelTrial(trialId: $trialId) {
    id
    status
  }
}
    `;
export type CancelTrialMutationFn = Apollo.MutationFunction<CancelTrialMutation, CancelTrialMutationVariables>;

/**
 * __useCancelTrialMutation__
 *
 * To run a mutation, you first call `useCancelTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTrialMutation, { data, loading, error }] = useCancelTrialMutation({
 *   variables: {
 *      trialId: // value for 'trialId'
 *   },
 * });
 */
export function useCancelTrialMutation(baseOptions?: Apollo.MutationHookOptions<CancelTrialMutation, CancelTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTrialMutation, CancelTrialMutationVariables>(CancelTrialDocument, options);
      }
export type CancelTrialMutationHookResult = ReturnType<typeof useCancelTrialMutation>;
export type CancelTrialMutationResult = Apollo.MutationResult<CancelTrialMutation>;
export type CancelTrialMutationOptions = Apollo.BaseMutationOptions<CancelTrialMutation, CancelTrialMutationVariables>;
export const ExaminationCompetencyListDocument = gql`
    query examinationCompetencyList($examinationId: ID!) {
  examination(examinationId: $examinationId) {
    id
    competencyMap {
      id
      competences {
        id
        title
        order
      }
    }
  }
}
    `;

/**
 * __useExaminationCompetencyListQuery__
 *
 * To run a query within a React component, call `useExaminationCompetencyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExaminationCompetencyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExaminationCompetencyListQuery({
 *   variables: {
 *      examinationId: // value for 'examinationId'
 *   },
 * });
 */
export function useExaminationCompetencyListQuery(baseOptions: Apollo.QueryHookOptions<ExaminationCompetencyListQuery, ExaminationCompetencyListQueryVariables> & ({ variables: ExaminationCompetencyListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExaminationCompetencyListQuery, ExaminationCompetencyListQueryVariables>(ExaminationCompetencyListDocument, options);
      }
export function useExaminationCompetencyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExaminationCompetencyListQuery, ExaminationCompetencyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExaminationCompetencyListQuery, ExaminationCompetencyListQueryVariables>(ExaminationCompetencyListDocument, options);
        }
export function useExaminationCompetencyListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExaminationCompetencyListQuery, ExaminationCompetencyListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExaminationCompetencyListQuery, ExaminationCompetencyListQueryVariables>(ExaminationCompetencyListDocument, options);
        }
export type ExaminationCompetencyListQueryHookResult = ReturnType<typeof useExaminationCompetencyListQuery>;
export type ExaminationCompetencyListLazyQueryHookResult = ReturnType<typeof useExaminationCompetencyListLazyQuery>;
export type ExaminationCompetencyListSuspenseQueryHookResult = ReturnType<typeof useExaminationCompetencyListSuspenseQuery>;
export type ExaminationCompetencyListQueryResult = Apollo.QueryResult<ExaminationCompetencyListQuery, ExaminationCompetencyListQueryVariables>;
export const ExaminationHeaderDocument = gql`
    query examinationHeader($examinationId: ID!) {
  examination(examinationId: $examinationId) {
    id
    numericId
    type
    title
    isActive
    trials {
      id
      status
      completedAt
      companyCandidate {
        id
        fullName
      }
    }
  }
}
    `;

/**
 * __useExaminationHeaderQuery__
 *
 * To run a query within a React component, call `useExaminationHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useExaminationHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExaminationHeaderQuery({
 *   variables: {
 *      examinationId: // value for 'examinationId'
 *   },
 * });
 */
export function useExaminationHeaderQuery(baseOptions: Apollo.QueryHookOptions<ExaminationHeaderQuery, ExaminationHeaderQueryVariables> & ({ variables: ExaminationHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExaminationHeaderQuery, ExaminationHeaderQueryVariables>(ExaminationHeaderDocument, options);
      }
export function useExaminationHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExaminationHeaderQuery, ExaminationHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExaminationHeaderQuery, ExaminationHeaderQueryVariables>(ExaminationHeaderDocument, options);
        }
export function useExaminationHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExaminationHeaderQuery, ExaminationHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExaminationHeaderQuery, ExaminationHeaderQueryVariables>(ExaminationHeaderDocument, options);
        }
export type ExaminationHeaderQueryHookResult = ReturnType<typeof useExaminationHeaderQuery>;
export type ExaminationHeaderLazyQueryHookResult = ReturnType<typeof useExaminationHeaderLazyQuery>;
export type ExaminationHeaderSuspenseQueryHookResult = ReturnType<typeof useExaminationHeaderSuspenseQuery>;
export type ExaminationHeaderQueryResult = Apollo.QueryResult<ExaminationHeaderQuery, ExaminationHeaderQueryVariables>;
export const ExaminationInfoDocument = gql`
    query examinationInfo($examinationId: ID!) {
  examination(examinationId: $examinationId) {
    id
    title
    createdAt
    numericId
    type
    isSendResult
    sendResultType
    competencyMap {
      id
      title
      comment
      grades
    }
    trials {
      id
      status
      completedAt
      createdAt
      comment
      companyCandidate {
        id
        candidateUsername {
          id
          telegramUsername
          login
          candidate {
            id
            phoneNumber
          }
        }
        fullName
        email
        position
        organization
        grade
      }
      trialStatusHistory {
        id
        newStatus
        createdAt
      }
    }
  }
}
    `;

/**
 * __useExaminationInfoQuery__
 *
 * To run a query within a React component, call `useExaminationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useExaminationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExaminationInfoQuery({
 *   variables: {
 *      examinationId: // value for 'examinationId'
 *   },
 * });
 */
export function useExaminationInfoQuery(baseOptions: Apollo.QueryHookOptions<ExaminationInfoQuery, ExaminationInfoQueryVariables> & ({ variables: ExaminationInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExaminationInfoQuery, ExaminationInfoQueryVariables>(ExaminationInfoDocument, options);
      }
export function useExaminationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExaminationInfoQuery, ExaminationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExaminationInfoQuery, ExaminationInfoQueryVariables>(ExaminationInfoDocument, options);
        }
export function useExaminationInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExaminationInfoQuery, ExaminationInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExaminationInfoQuery, ExaminationInfoQueryVariables>(ExaminationInfoDocument, options);
        }
export type ExaminationInfoQueryHookResult = ReturnType<typeof useExaminationInfoQuery>;
export type ExaminationInfoLazyQueryHookResult = ReturnType<typeof useExaminationInfoLazyQuery>;
export type ExaminationInfoSuspenseQueryHookResult = ReturnType<typeof useExaminationInfoSuspenseQuery>;
export type ExaminationInfoQueryResult = Apollo.QueryResult<ExaminationInfoQuery, ExaminationInfoQueryVariables>;
export const ExaminationListDocument = gql`
    query examinationList($filter: ListExaminationFilterInput, $limit: Float!, $page: Float!, $order: PlatformExaminationListOrderInput!) {
  examinations(filter: $filter, limit: $limit, page: $page, order: $order) {
    totalCount
    data {
      id
      numericId
      title
      type
      questionsTime
      lastCompleteDate
      competencyMap {
        id
        title
        specialization
        blocksCount
        competencesCount
        grades
        isRepositoryCheck
        competences {
          id
          knowledgeBlockCompetences {
            id
          }
        }
      }
      trials {
        id
        examination {
          id
          type
          questionsTime
        }
        companyCandidate {
          id
          fullName
          numericId
          candidateUsername {
            id
            login
          }
        }
        candidateTime
        candidateScore
        createdAt
        completedAt
        status
        isAssessmentComplete
        recruiterReportFiles {
          id
          type
          file {
            id
            url
          }
        }
        reportData {
          ai_generation_percentage
        }
      }
      createdAt
    }
  }
}
    `;

/**
 * __useExaminationListQuery__
 *
 * To run a query within a React component, call `useExaminationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useExaminationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExaminationListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useExaminationListQuery(baseOptions: Apollo.QueryHookOptions<ExaminationListQuery, ExaminationListQueryVariables> & ({ variables: ExaminationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExaminationListQuery, ExaminationListQueryVariables>(ExaminationListDocument, options);
      }
export function useExaminationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExaminationListQuery, ExaminationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExaminationListQuery, ExaminationListQueryVariables>(ExaminationListDocument, options);
        }
export function useExaminationListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExaminationListQuery, ExaminationListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExaminationListQuery, ExaminationListQueryVariables>(ExaminationListDocument, options);
        }
export type ExaminationListQueryHookResult = ReturnType<typeof useExaminationListQuery>;
export type ExaminationListLazyQueryHookResult = ReturnType<typeof useExaminationListLazyQuery>;
export type ExaminationListSuspenseQueryHookResult = ReturnType<typeof useExaminationListSuspenseQuery>;
export type ExaminationListQueryResult = Apollo.QueryResult<ExaminationListQuery, ExaminationListQueryVariables>;
export const ExaminationTitleDocument = gql`
    query examinationTitle($examinationId: ID!) {
  examination(examinationId: $examinationId) {
    id
    title
  }
}
    `;

/**
 * __useExaminationTitleQuery__
 *
 * To run a query within a React component, call `useExaminationTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useExaminationTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExaminationTitleQuery({
 *   variables: {
 *      examinationId: // value for 'examinationId'
 *   },
 * });
 */
export function useExaminationTitleQuery(baseOptions: Apollo.QueryHookOptions<ExaminationTitleQuery, ExaminationTitleQueryVariables> & ({ variables: ExaminationTitleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExaminationTitleQuery, ExaminationTitleQueryVariables>(ExaminationTitleDocument, options);
      }
export function useExaminationTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExaminationTitleQuery, ExaminationTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExaminationTitleQuery, ExaminationTitleQueryVariables>(ExaminationTitleDocument, options);
        }
export function useExaminationTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExaminationTitleQuery, ExaminationTitleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExaminationTitleQuery, ExaminationTitleQueryVariables>(ExaminationTitleDocument, options);
        }
export type ExaminationTitleQueryHookResult = ReturnType<typeof useExaminationTitleQuery>;
export type ExaminationTitleLazyQueryHookResult = ReturnType<typeof useExaminationTitleLazyQuery>;
export type ExaminationTitleSuspenseQueryHookResult = ReturnType<typeof useExaminationTitleSuspenseQuery>;
export type ExaminationTitleQueryResult = Apollo.QueryResult<ExaminationTitleQuery, ExaminationTitleQueryVariables>;
export const TrialHeaderDocument = gql`
    query trialHeader($trialId: ID!) {
  trial(trialId: $trialId) {
    id
    numericId
    status
    companyCandidate {
      id
      fullName
    }
    examination {
      id
      title
      numericId
    }
    completedAt
    isAssessmentComplete
    recruiterReportFiles {
      id
      file {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useTrialHeaderQuery__
 *
 * To run a query within a React component, call `useTrialHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialHeaderQuery({
 *   variables: {
 *      trialId: // value for 'trialId'
 *   },
 * });
 */
export function useTrialHeaderQuery(baseOptions: Apollo.QueryHookOptions<TrialHeaderQuery, TrialHeaderQueryVariables> & ({ variables: TrialHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrialHeaderQuery, TrialHeaderQueryVariables>(TrialHeaderDocument, options);
      }
export function useTrialHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrialHeaderQuery, TrialHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrialHeaderQuery, TrialHeaderQueryVariables>(TrialHeaderDocument, options);
        }
export function useTrialHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrialHeaderQuery, TrialHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrialHeaderQuery, TrialHeaderQueryVariables>(TrialHeaderDocument, options);
        }
export type TrialHeaderQueryHookResult = ReturnType<typeof useTrialHeaderQuery>;
export type TrialHeaderLazyQueryHookResult = ReturnType<typeof useTrialHeaderLazyQuery>;
export type TrialHeaderSuspenseQueryHookResult = ReturnType<typeof useTrialHeaderSuspenseQuery>;
export type TrialHeaderQueryResult = Apollo.QueryResult<TrialHeaderQuery, TrialHeaderQueryVariables>;
export const TrialInfoDocument = gql`
    query trialInfo($trialId: ID!) {
  trial(trialId: $trialId) {
    id
    comment
    status
    companyCandidate {
      id
      fullName
      candidateUsername {
        id
        telegramUsername
        login
        candidate {
          id
          phoneNumber
        }
      }
      email
      organization
      position
      grade
    }
    examination {
      id
      title
      isSendResult
      sendResultType
      competencyMap {
        id
        title
        comment
        grades
      }
    }
    createdAt
    completedAt
    trialStatusHistory {
      id
      newStatus
      createdAt
    }
  }
}
    `;

/**
 * __useTrialInfoQuery__
 *
 * To run a query within a React component, call `useTrialInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialInfoQuery({
 *   variables: {
 *      trialId: // value for 'trialId'
 *   },
 * });
 */
export function useTrialInfoQuery(baseOptions: Apollo.QueryHookOptions<TrialInfoQuery, TrialInfoQueryVariables> & ({ variables: TrialInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrialInfoQuery, TrialInfoQueryVariables>(TrialInfoDocument, options);
      }
export function useTrialInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrialInfoQuery, TrialInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrialInfoQuery, TrialInfoQueryVariables>(TrialInfoDocument, options);
        }
export function useTrialInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrialInfoQuery, TrialInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrialInfoQuery, TrialInfoQueryVariables>(TrialInfoDocument, options);
        }
export type TrialInfoQueryHookResult = ReturnType<typeof useTrialInfoQuery>;
export type TrialInfoLazyQueryHookResult = ReturnType<typeof useTrialInfoLazyQuery>;
export type TrialInfoSuspenseQueryHookResult = ReturnType<typeof useTrialInfoSuspenseQuery>;
export type TrialInfoQueryResult = Apollo.QueryResult<TrialInfoQuery, TrialInfoQueryVariables>;
export const TrialListDocument = gql`
    query trialList($filter: ListTrialFilterInput, $limit: Float!, $order: PlatformTrialListOrderInput!, $page: Float!) {
  trials(filter: $filter, limit: $limit, page: $page, order: $order) {
    totalCount
    data {
      id
      examination {
        id
        questionsTime
      }
      candidateTime
      companyCandidate {
        id
        numericId
        fullName
      }
      completedAt
      status
      isAssessmentComplete
      recruiterReportFiles {
        id
        type
        file {
          id
          url
        }
      }
      reportData {
        ai_generation_percentage
      }
      candidateScore
      competencesScore {
        competenceId
        score
        order
      }
    }
  }
}
    `;

/**
 * __useTrialListQuery__
 *
 * To run a query within a React component, call `useTrialListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTrialListQuery(baseOptions: Apollo.QueryHookOptions<TrialListQuery, TrialListQueryVariables> & ({ variables: TrialListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrialListQuery, TrialListQueryVariables>(TrialListDocument, options);
      }
export function useTrialListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrialListQuery, TrialListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrialListQuery, TrialListQueryVariables>(TrialListDocument, options);
        }
export function useTrialListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrialListQuery, TrialListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrialListQuery, TrialListQueryVariables>(TrialListDocument, options);
        }
export type TrialListQueryHookResult = ReturnType<typeof useTrialListQuery>;
export type TrialListLazyQueryHookResult = ReturnType<typeof useTrialListLazyQuery>;
export type TrialListSuspenseQueryHookResult = ReturnType<typeof useTrialListSuspenseQuery>;
export type TrialListQueryResult = Apollo.QueryResult<TrialListQuery, TrialListQueryVariables>;
export const TrialResultDocument = gql`
    query trialResult($trialId: ID!) {
  trial(trialId: $trialId) {
    id
    candidateScore
    companyCandidate {
      id
      fullName
    }
    trialRepositoryChecks {
      id
      algorithmsScore
      error
      facts {
        first_release_date
        main_language
        developers_count
        forks_count
        languages
        repo_url
        stars_count
      }
      maintainabilityScore
      readabilityScore
      repoUrl
      totalScore
    }
    examination {
      id
      numericId
      title
      competencyMap {
        id
        competences {
          id
          title
          knowledgeBlockCompetences {
            id
            knowledgeBlock {
              id
              title
              skills {
                id
                title
                trialAnswer(trialId: $trialId) {
                  id
                  score
                  time
                  answer
                  file {
                    id
                    url
                    name
                  }
                  question {
                    id
                    text
                    type
                    parts {
                      id
                      content
                      isCorrect
                    }
                  }
                  criterionAssessments {
                    criteria
                    decision
                  }
                  partsIds
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTrialResultQuery__
 *
 * To run a query within a React component, call `useTrialResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialResultQuery({
 *   variables: {
 *      trialId: // value for 'trialId'
 *   },
 * });
 */
export function useTrialResultQuery(baseOptions: Apollo.QueryHookOptions<TrialResultQuery, TrialResultQueryVariables> & ({ variables: TrialResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrialResultQuery, TrialResultQueryVariables>(TrialResultDocument, options);
      }
export function useTrialResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrialResultQuery, TrialResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrialResultQuery, TrialResultQueryVariables>(TrialResultDocument, options);
        }
export function useTrialResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrialResultQuery, TrialResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrialResultQuery, TrialResultQueryVariables>(TrialResultDocument, options);
        }
export type TrialResultQueryHookResult = ReturnType<typeof useTrialResultQuery>;
export type TrialResultLazyQueryHookResult = ReturnType<typeof useTrialResultLazyQuery>;
export type TrialResultSuspenseQueryHookResult = ReturnType<typeof useTrialResultSuspenseQuery>;
export type TrialResultQueryResult = Apollo.QueryResult<TrialResultQuery, TrialResultQueryVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserDataInput!) {
  updateUser(input: $input) {
    id
    firstName
    lastName
    middleName
    userEmail {
      id
      email
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UserCompaniesDocument = gql`
    query userCompanies {
  userCompanies {
    id
    shortName
    currentUserPosition
  }
}
    `;

/**
 * __useUserCompaniesQuery__
 *
 * To run a query within a React component, call `useUserCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<UserCompaniesQuery, UserCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCompaniesQuery, UserCompaniesQueryVariables>(UserCompaniesDocument, options);
      }
export function useUserCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCompaniesQuery, UserCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCompaniesQuery, UserCompaniesQueryVariables>(UserCompaniesDocument, options);
        }
export function useUserCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCompaniesQuery, UserCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCompaniesQuery, UserCompaniesQueryVariables>(UserCompaniesDocument, options);
        }
export type UserCompaniesQueryHookResult = ReturnType<typeof useUserCompaniesQuery>;
export type UserCompaniesLazyQueryHookResult = ReturnType<typeof useUserCompaniesLazyQuery>;
export type UserCompaniesSuspenseQueryHookResult = ReturnType<typeof useUserCompaniesSuspenseQuery>;
export type UserCompaniesQueryResult = Apollo.QueryResult<UserCompaniesQuery, UserCompaniesQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    id
    firstName
    lastName
    middleName
    userEmail {
      id
      email
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const AddCandidatesToVacancyDocument = gql`
    mutation addCandidatesToVacancy($input: CreateVacancyCompanyCandidatesInput!) {
  createVacancyCompanyCandidate(input: $input) {
    id
  }
}
    `;
export type AddCandidatesToVacancyMutationFn = Apollo.MutationFunction<AddCandidatesToVacancyMutation, AddCandidatesToVacancyMutationVariables>;

/**
 * __useAddCandidatesToVacancyMutation__
 *
 * To run a mutation, you first call `useAddCandidatesToVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCandidatesToVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCandidatesToVacancyMutation, { data, loading, error }] = useAddCandidatesToVacancyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCandidatesToVacancyMutation(baseOptions?: Apollo.MutationHookOptions<AddCandidatesToVacancyMutation, AddCandidatesToVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCandidatesToVacancyMutation, AddCandidatesToVacancyMutationVariables>(AddCandidatesToVacancyDocument, options);
      }
export type AddCandidatesToVacancyMutationHookResult = ReturnType<typeof useAddCandidatesToVacancyMutation>;
export type AddCandidatesToVacancyMutationResult = Apollo.MutationResult<AddCandidatesToVacancyMutation>;
export type AddCandidatesToVacancyMutationOptions = Apollo.BaseMutationOptions<AddCandidatesToVacancyMutation, AddCandidatesToVacancyMutationVariables>;
export const CreateVacancyDocument = gql`
    mutation createVacancy($input: CreateVacancyInput!) {
  createVacancy(input: $input) {
    id
    description
    numericId
    title
  }
}
    `;
export type CreateVacancyMutationFn = Apollo.MutationFunction<CreateVacancyMutation, CreateVacancyMutationVariables>;

/**
 * __useCreateVacancyMutation__
 *
 * To run a mutation, you first call `useCreateVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVacancyMutation, { data, loading, error }] = useCreateVacancyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVacancyMutation(baseOptions?: Apollo.MutationHookOptions<CreateVacancyMutation, CreateVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVacancyMutation, CreateVacancyMutationVariables>(CreateVacancyDocument, options);
      }
export type CreateVacancyMutationHookResult = ReturnType<typeof useCreateVacancyMutation>;
export type CreateVacancyMutationResult = Apollo.MutationResult<CreateVacancyMutation>;
export type CreateVacancyMutationOptions = Apollo.BaseMutationOptions<CreateVacancyMutation, CreateVacancyMutationVariables>;
export const DeleteVacancyDocument = gql`
    mutation deleteVacancy($vacancyId: String!) {
  deleteVacancy(vacancyId: $vacancyId)
}
    `;
export type DeleteVacancyMutationFn = Apollo.MutationFunction<DeleteVacancyMutation, DeleteVacancyMutationVariables>;

/**
 * __useDeleteVacancyMutation__
 *
 * To run a mutation, you first call `useDeleteVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVacancyMutation, { data, loading, error }] = useDeleteVacancyMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useDeleteVacancyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVacancyMutation, DeleteVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVacancyMutation, DeleteVacancyMutationVariables>(DeleteVacancyDocument, options);
      }
export type DeleteVacancyMutationHookResult = ReturnType<typeof useDeleteVacancyMutation>;
export type DeleteVacancyMutationResult = Apollo.MutationResult<DeleteVacancyMutation>;
export type DeleteVacancyMutationOptions = Apollo.BaseMutationOptions<DeleteVacancyMutation, DeleteVacancyMutationVariables>;
export const DeleteVacancyCompanyCandidateDocument = gql`
    mutation deleteVacancyCompanyCandidate($vacancyCompanyCandidateId: ID!) {
  deleteVacancyCompanyCandidate(
    vacancyCompanyCandidateId: $vacancyCompanyCandidateId
  )
}
    `;
export type DeleteVacancyCompanyCandidateMutationFn = Apollo.MutationFunction<DeleteVacancyCompanyCandidateMutation, DeleteVacancyCompanyCandidateMutationVariables>;

/**
 * __useDeleteVacancyCompanyCandidateMutation__
 *
 * To run a mutation, you first call `useDeleteVacancyCompanyCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVacancyCompanyCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVacancyCompanyCandidateMutation, { data, loading, error }] = useDeleteVacancyCompanyCandidateMutation({
 *   variables: {
 *      vacancyCompanyCandidateId: // value for 'vacancyCompanyCandidateId'
 *   },
 * });
 */
export function useDeleteVacancyCompanyCandidateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVacancyCompanyCandidateMutation, DeleteVacancyCompanyCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVacancyCompanyCandidateMutation, DeleteVacancyCompanyCandidateMutationVariables>(DeleteVacancyCompanyCandidateDocument, options);
      }
export type DeleteVacancyCompanyCandidateMutationHookResult = ReturnType<typeof useDeleteVacancyCompanyCandidateMutation>;
export type DeleteVacancyCompanyCandidateMutationResult = Apollo.MutationResult<DeleteVacancyCompanyCandidateMutation>;
export type DeleteVacancyCompanyCandidateMutationOptions = Apollo.BaseMutationOptions<DeleteVacancyCompanyCandidateMutation, DeleteVacancyCompanyCandidateMutationVariables>;
export const InitAssessmentCvDocument = gql`
    mutation initAssessmentCv($vacancyId: ID!) {
  assessmentCv(vacancyId: $vacancyId)
}
    `;
export type InitAssessmentCvMutationFn = Apollo.MutationFunction<InitAssessmentCvMutation, InitAssessmentCvMutationVariables>;

/**
 * __useInitAssessmentCvMutation__
 *
 * To run a mutation, you first call `useInitAssessmentCvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitAssessmentCvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initAssessmentCvMutation, { data, loading, error }] = useInitAssessmentCvMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useInitAssessmentCvMutation(baseOptions?: Apollo.MutationHookOptions<InitAssessmentCvMutation, InitAssessmentCvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitAssessmentCvMutation, InitAssessmentCvMutationVariables>(InitAssessmentCvDocument, options);
      }
export type InitAssessmentCvMutationHookResult = ReturnType<typeof useInitAssessmentCvMutation>;
export type InitAssessmentCvMutationResult = Apollo.MutationResult<InitAssessmentCvMutation>;
export type InitAssessmentCvMutationOptions = Apollo.BaseMutationOptions<InitAssessmentCvMutation, InitAssessmentCvMutationVariables>;
export const UploadCandidatesToVacancyDocument = gql`
    mutation uploadCandidatesToVacancy($files: [Upload!]!, $vacancyId: ID!) {
  createVacancyCompanyCandidateByCVs(files: $files, vacancyId: $vacancyId) {
    fullName
    login
    numericId
    password
  }
}
    `;
export type UploadCandidatesToVacancyMutationFn = Apollo.MutationFunction<UploadCandidatesToVacancyMutation, UploadCandidatesToVacancyMutationVariables>;

/**
 * __useUploadCandidatesToVacancyMutation__
 *
 * To run a mutation, you first call `useUploadCandidatesToVacancyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCandidatesToVacancyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCandidatesToVacancyMutation, { data, loading, error }] = useUploadCandidatesToVacancyMutation({
 *   variables: {
 *      files: // value for 'files'
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useUploadCandidatesToVacancyMutation(baseOptions?: Apollo.MutationHookOptions<UploadCandidatesToVacancyMutation, UploadCandidatesToVacancyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCandidatesToVacancyMutation, UploadCandidatesToVacancyMutationVariables>(UploadCandidatesToVacancyDocument, options);
      }
export type UploadCandidatesToVacancyMutationHookResult = ReturnType<typeof useUploadCandidatesToVacancyMutation>;
export type UploadCandidatesToVacancyMutationResult = Apollo.MutationResult<UploadCandidatesToVacancyMutation>;
export type UploadCandidatesToVacancyMutationOptions = Apollo.BaseMutationOptions<UploadCandidatesToVacancyMutation, UploadCandidatesToVacancyMutationVariables>;
export const VacanciesListDocument = gql`
    query vacanciesList($filter: ListVacancyFilterInput, $limit: Float!, $order: PlatformVacancyListOrderInput!, $page: Float!) {
  vacancies(filter: $filter, limit: $limit, page: $page, order: $order) {
    totalCount
    data {
      id
      createdAt
      companyCandidatesCount
      description
      numericId
      title
    }
  }
}
    `;

/**
 * __useVacanciesListQuery__
 *
 * To run a query within a React component, call `useVacanciesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacanciesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacanciesListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useVacanciesListQuery(baseOptions: Apollo.QueryHookOptions<VacanciesListQuery, VacanciesListQueryVariables> & ({ variables: VacanciesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VacanciesListQuery, VacanciesListQueryVariables>(VacanciesListDocument, options);
      }
export function useVacanciesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacanciesListQuery, VacanciesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VacanciesListQuery, VacanciesListQueryVariables>(VacanciesListDocument, options);
        }
export function useVacanciesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacanciesListQuery, VacanciesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VacanciesListQuery, VacanciesListQueryVariables>(VacanciesListDocument, options);
        }
export type VacanciesListQueryHookResult = ReturnType<typeof useVacanciesListQuery>;
export type VacanciesListLazyQueryHookResult = ReturnType<typeof useVacanciesListLazyQuery>;
export type VacanciesListSuspenseQueryHookResult = ReturnType<typeof useVacanciesListSuspenseQuery>;
export type VacanciesListQueryResult = Apollo.QueryResult<VacanciesListQuery, VacanciesListQueryVariables>;
export const VacancyDocument = gql`
    query vacancy($vacancyId: ID!) {
  vacancy(vacancyId: $vacancyId) {
    id
    description
    numericId
    title
  }
}
    `;

/**
 * __useVacancyQuery__
 *
 * To run a query within a React component, call `useVacancyQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacancyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacancyQuery({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useVacancyQuery(baseOptions: Apollo.QueryHookOptions<VacancyQuery, VacancyQueryVariables> & ({ variables: VacancyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VacancyQuery, VacancyQueryVariables>(VacancyDocument, options);
      }
export function useVacancyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacancyQuery, VacancyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VacancyQuery, VacancyQueryVariables>(VacancyDocument, options);
        }
export function useVacancySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacancyQuery, VacancyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VacancyQuery, VacancyQueryVariables>(VacancyDocument, options);
        }
export type VacancyQueryHookResult = ReturnType<typeof useVacancyQuery>;
export type VacancyLazyQueryHookResult = ReturnType<typeof useVacancyLazyQuery>;
export type VacancySuspenseQueryHookResult = ReturnType<typeof useVacancySuspenseQuery>;
export type VacancyQueryResult = Apollo.QueryResult<VacancyQuery, VacancyQueryVariables>;
export const VacancyCompanyCandidatesDocument = gql`
    query vacancyCompanyCandidates($filter: ListVacancyCompanyCandidateFilterInput, $limit: Float!, $order: PlatformVacancyCompanyCandidateListOrderInput! = {order: DESC, field: companyCandidate_fullName}, $page: Float!) {
  vacancyCompanyCandidates(
    filter: $filter
    limit: $limit
    page: $page
    order: $order
  ) {
    totalCount
    data {
      id
      createdAt
      currentCvCheck {
        id
        score
        reportFile {
          id
          url
        }
        assessmentCV
      }
      cvChecks {
        id
      }
      companyCandidate {
        id
        numericId
        fullName
        createdAt
        cvFileId
        candidateUsername {
          id
          telegramUsername
          login
        }
      }
    }
  }
}
    `;

/**
 * __useVacancyCompanyCandidatesQuery__
 *
 * To run a query within a React component, call `useVacancyCompanyCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacancyCompanyCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacancyCompanyCandidatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useVacancyCompanyCandidatesQuery(baseOptions: Apollo.QueryHookOptions<VacancyCompanyCandidatesQuery, VacancyCompanyCandidatesQueryVariables> & ({ variables: VacancyCompanyCandidatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VacancyCompanyCandidatesQuery, VacancyCompanyCandidatesQueryVariables>(VacancyCompanyCandidatesDocument, options);
      }
export function useVacancyCompanyCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacancyCompanyCandidatesQuery, VacancyCompanyCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VacancyCompanyCandidatesQuery, VacancyCompanyCandidatesQueryVariables>(VacancyCompanyCandidatesDocument, options);
        }
export function useVacancyCompanyCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacancyCompanyCandidatesQuery, VacancyCompanyCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VacancyCompanyCandidatesQuery, VacancyCompanyCandidatesQueryVariables>(VacancyCompanyCandidatesDocument, options);
        }
export type VacancyCompanyCandidatesQueryHookResult = ReturnType<typeof useVacancyCompanyCandidatesQuery>;
export type VacancyCompanyCandidatesLazyQueryHookResult = ReturnType<typeof useVacancyCompanyCandidatesLazyQuery>;
export type VacancyCompanyCandidatesSuspenseQueryHookResult = ReturnType<typeof useVacancyCompanyCandidatesSuspenseQuery>;
export type VacancyCompanyCandidatesQueryResult = Apollo.QueryResult<VacancyCompanyCandidatesQuery, VacancyCompanyCandidatesQueryVariables>;
export const VacancyHeaderDocument = gql`
    query vacancyHeader($vacancyId: ID!) {
  vacancy(vacancyId: $vacancyId) {
    id
    title
  }
}
    `;

/**
 * __useVacancyHeaderQuery__
 *
 * To run a query within a React component, call `useVacancyHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useVacancyHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVacancyHeaderQuery({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *   },
 * });
 */
export function useVacancyHeaderQuery(baseOptions: Apollo.QueryHookOptions<VacancyHeaderQuery, VacancyHeaderQueryVariables> & ({ variables: VacancyHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VacancyHeaderQuery, VacancyHeaderQueryVariables>(VacancyHeaderDocument, options);
      }
export function useVacancyHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VacancyHeaderQuery, VacancyHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VacancyHeaderQuery, VacancyHeaderQueryVariables>(VacancyHeaderDocument, options);
        }
export function useVacancyHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VacancyHeaderQuery, VacancyHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VacancyHeaderQuery, VacancyHeaderQueryVariables>(VacancyHeaderDocument, options);
        }
export type VacancyHeaderQueryHookResult = ReturnType<typeof useVacancyHeaderQuery>;
export type VacancyHeaderLazyQueryHookResult = ReturnType<typeof useVacancyHeaderLazyQuery>;
export type VacancyHeaderSuspenseQueryHookResult = ReturnType<typeof useVacancyHeaderSuspenseQuery>;
export type VacancyHeaderQueryResult = Apollo.QueryResult<VacancyHeaderQuery, VacancyHeaderQueryVariables>;